// Auto-generated by backend/generate_tr.py — 11-language UI/content strings.
// Each value is {id,en,ar,fr,de,es,ru,zh,ja,ko,hi}; use with tc() from LangContext.
export const TR = {
  "dash.keutamaan.label": {
    "id": "Keutamaan Haji & Umrah",
    "en": "Virtues of Hajj & Umrah",
    "ar": "فضائل الحج والعمرة",
    "fr": "Vertus du Hajj & de la Umrah",
    "de": "Vorzüge von Hajj & Umrah",
    "es": "Virtudes del Hajj y la Umrah",
    "ru": "Достоинства Хаджа и Умры",
    "zh": "朝觐与副朝的美德",
    "ja": "ハッジとウムラの徳",
    "ko": "하지와 움라의 덕목",
    "hi": "हज और उमरा की फज़ीलत"
  },
  "dash.keutamaan.hint": {
    "id": "Dalil Al-Qur'an, hadits shahih & pandangan 4 madzhab",
    "en": "Qur'anic evidences, authentic hadiths & views of the 4 madhabs",
    "ar": "أدلة من القرآن الكريم وأحاديث صحيحة وآراء المذاهب الأربعة",
    "fr": "Preuves coraniques, hadiths authentiques & avis des 4 madhabs",
    "de": "Koranische Belege, authentische Hadithe & Ansichten der 4 Madhabs",
    "es": "Evidencias coránicas, hadices auténticos & opiniones de los 4 madhabs",
    "ru": "Коранические доводы, достоверные хадисы и мнения 4 мазхабов",
    "zh": "《古兰经》依据、真实圣训及四大法学派观点",
    "ja": "クルアーンの根拠、真正なハディース、4マズハブの見解",
    "ko": "꾸란의 근거, 진정한 하디스 및 4대 마드합의 견해",
    "hi": "क़ुरआनी दलील, सहीह हदीस और चारों मज़हब के विचार"
  },
  "dash.quran.label": {
    "id": "Al-Qur'an & Tafsir",
    "en": "Al-Qur'an & Tafsir",
    "ar": "القرآن الكريم والتفسير",
    "fr": "Al-Qur'an & Tafsir",
    "de": "Al-Qur'an & Tafsir",
    "es": "Al-Qur'an & Tafsir",
    "ru": "Аль-Куран и Тафсир",
    "zh": "《古兰经》与注释",
    "ja": "クルアーンとタフスィール",
    "ko": "알-꾸란 & 타프시르",
    "hi": "अल-क़ुरआन और तफ़सीर"
  },
  "dash.quran.hint": {
    "id": "114 surah, terjemahan, audio & tafsir Kemenag",
    "en": "114 surahs, translations, audio & Kemenag tafsir",
    "ar": "١١٤ سورة، ترجمات، تسجيلات صوتية وتفسير كيمناغ",
    "fr": "114 sourates, traductions, audio & tafsir Kemenag",
    "de": "114 Suren, Übersetzungen, Audio & Kemenag-Tafsir",
    "es": "114 surahs, traducciones, audio & tafsir Kemenag",
    "ru": "114 сур, переводы, аудио и тафсир Кеменаг",
    "zh": "114章、译文、音频及宗教部注释",
    "ja": "114スーラ、翻訳、音声、ケメナグのタフスィール",
    "ko": "114개 수라, 번역, 오디오 및 케메나그 타프시르",
    "hi": "114 सूरह, अनुवाद, ऑडियो और केमेनाग तफ़सीर"
  },
  "dash.ziyarah.label": {
    "id": "Tempat Bersejarah",
    "en": "Historical Sites",
    "ar": "المواقع التاريخية",
    "fr": "Sites Historiques",
    "de": "Historische Stätten",
    "es": "Sitios Históricos",
    "ru": "Исторические места",
    "zh": "历史遗址",
    "ja": "史跡・歴史的場所",
    "ko": "역사적 명소",
    "hi": "ऐतिहासिक स्थल"
  },
  "dash.ziyarah.hint": {
    "id": "Situs ziyarah Makkah & Madinah + kisahnya",
    "en": "Ziyarah sites of Makkah & Madinah with their stories",
    "ar": "مواقع الزيارة في مكة المكرمة والمدينة المنورة وقصصها",
    "fr": "Sites de ziyarah de La Mecque & Médine avec leurs récits",
    "de": "Ziyarah-Stätten in Makkah & Madinah mit ihren Geschichten",
    "es": "Sitios de ziyarah en La Meca & Medina con sus historias",
    "ru": "Места зийары в Мекке и Медине с их историями",
    "zh": "麦加与麦地那的探访地点及其历史故事",
    "ja": "マッカとマディーナのズィヤーラ地とその物語",
    "ko": "메카와 메디나의 지야라 장소와 그 이야기",
    "hi": "मक्का और मदीना के ज़ियारत स्थल और उनकी कहानियाँ"
  },
  "dash.haram.label": {
    "id": "Peta Masjidil Haram",
    "en": "Map of Masjid al-Haram",
    "ar": "خريطة المسجد الحرام",
    "fr": "Plan de la Mosquée Al-Haram",
    "de": "Karte der Masjid al-Haram",
    "es": "Mapa de la Mezquita Al-Haram",
    "ru": "Карта Масджид аль-Харам",
    "zh": "麦斯吉德·哈拉姆地图",
    "ja": "マスジド・アル・ハラームの地図",
    "ko": "마스지드 알-하람 지도",
    "hi": "मस्जिद अल-हराम का नक्शा"
  },
  "dash.haram.hint": {
    "id": "Denah & isi Masjidil Haram secara detail",
    "en": "Detailed floor plan & contents of Masjid al-Haram",
    "ar": "مخطط تفصيلي ومحتويات المسجد الحرام",
    "fr": "Plan détaillé et contenu de la Mosquée Al-Haram",
    "de": "Detaillierter Grundriss und Inhalt der Masjid al-Haram",
    "es": "Plano detallado y contenido de la Mezquita Al-Haram",
    "ru": "Подробная планировка и содержимое Масджид аль-Харам",
    "zh": "麦斯吉德·哈拉姆详细平面图及内容介绍",
    "ja": "マスジド・アル・ハラームの詳細な見取り図と内容",
    "ko": "마스지드 알-하람의 상세 도면 및 내용",
    "hi": "मस्जिद अल-हराम का विस्तृत नक्शा एवं विवरण"
  },
  "dash.nabawi.label": {
    "id": "Peta Masjid Nabawi",
    "en": "Map of Masjid Nabawi",
    "ar": "خريطة المسجد النبوي",
    "fr": "Plan de la Mosquée Nabawi",
    "de": "Karte der Masjid Nabawi",
    "es": "Mapa de la Mezquita Nabawi",
    "ru": "Карта Масджид Набави",
    "zh": "麦斯吉德·纳巴维地图",
    "ja": "マスジド・ナバウィーの地図",
    "ko": "마스지드 나바위 지도",
    "hi": "मस्जिद नबवी का नक्शा"
  },
  "dash.nabawi.hint": {
    "id": "Denah & bagian-bagian Masjid Nabawi",
    "en": "Floor plan & sections of Masjid Nabawi",
    "ar": "مخطط وأقسام المسجد النبوي",
    "fr": "Plan et sections de la Mosquée Nabawi",
    "de": "Grundriss und Bereiche der Masjid Nabawi",
    "es": "Plano y secciones de la Mezquita Nabawi",
    "ru": "Планировка и разделы Масджид Набави",
    "zh": "麦斯吉德·纳巴维平面图及各区域介绍",
    "ja": "マスジド・ナバウィーの見取り図と各区域",
    "ko": "마스지드 나바위 도면 및 구역 안내",
    "hi": "मस्जिद नबवी का नक्शा एवं विभिन्न भाग"
  },
  "dash.baqi.label": {
    "id": "Makam Al-Baqi'",
    "en": "Jannatul Baqi' Cemetery",
    "ar": "مقبرة جنة البقيع",
    "fr": "Cimetière Jannatul Baqi'",
    "de": "Friedhof Jannatul Baqi'",
    "es": "Cementerio Jannatul Baqi'",
    "ru": "Кладбище Джаннатуль Баки'",
    "zh": "仁纳图勒·巴基'墓地",
    "ja": "ジャンナトゥル・バキーの墓地",
    "ko": "잔나툴 바키' 묘지",
    "hi": "जन्नतुल बक़ी' कब्रिस्तान"
  },
  "dash.baqi.hint": {
    "id": "Yang dimakamkan, doa, & larangannya",
    "en": "Those buried, supplications, & prohibitions at Jannatul Baqi'",
    "ar": "المدفونون والأدعية والمحظورات في جنة البقيع",
    "fr": "Les personnes inhumées, les invocations et les interdictions à Jannatul Baqi'",
    "de": "Bestattete Personen, Bittgebete und Verbote in Jannatul Baqi'",
    "es": "Los sepultados, súplicas y prohibiciones en Jannatul Baqi'",
    "ru": "Погребённые, мольбы и запреты в Джаннатуль Баки'",
    "zh": "仁纳图勒·巴基'的安葬者、祈祷词及禁忌",
    "ja": "ジャンナトゥル・バキーに埋葬された方々、ドゥアー、および禁止事項",
    "ko": "잔나툴 바키'에 안장된 분들, 기도문 및 금지 사항",
    "hi": "जन्नतुल बक़ी' में दफ़न लोग, दुआएँ एवं निषेध"
  },
  "dash.jenazah.label": {
    "id": "Panduan Sholat Jenazah",
    "en": "Funeral Prayer Guide",
    "ar": "دليل صلاة الجنازة",
    "fr": "Guide de la Prière Funèbre",
    "de": "Leitfaden zum Totengebet",
    "es": "Guía de la Oración Fúnebre",
    "ru": "Руководство по заупокойной молитве",
    "zh": "殡礼（丧礼祈祷）指南",
    "ja": "ジャナザの礼拝ガイド",
    "ko": "장례 예배 안내",
    "hi": "जनाज़ा नमाज़ गाइड"
  },
  "dash.jenazah.hint": {
    "id": "Niat & doa: pria, wanita, & anak",
    "en": "Intentions & supplications: male, female, & child",
    "ar": "النية والدعاء: للرجل، والمرأة، والطفل",
    "fr": "Intentions & invocations : homme, femme & enfant",
    "de": "Niyyah & Bittgebete: Mann, Frau & Kind",
    "es": "Intenciones y súplicas: hombre, mujer y niño",
    "ru": "Намерения и молитвы: мужчина, женщина и ребёнок",
    "zh": "意图与祈祷：男性、女性及儿童",
    "ja": "ニーヤとドゥアー：男性・女性・子供",
    "ko": "니야 & 두아: 남성, 여성 & 아동",
    "hi": "नियत और दुआ: पुरुष, महिला और बच्चा"
  },
  "dash.sunnah.label": {
    "id": "Sholat Sunnah Umrah & Haji",
    "en": "Sunnah Prayers of Umrah & Hajj",
    "ar": "الصلوات السنية في العمرة والحج",
    "fr": "Prières Sunnah de la Oumra & du Hajj",
    "de": "Sunnah-Gebete der Umrah & Hajj",
    "es": "Oraciones Sunnah de la Umrah y el Hajj",
    "ru": "Сунна-намазы Умры и Хаджа",
    "zh": "副朝与朝觐的逊奈礼拜",
    "ja": "ウムラとハッジのスンナ礼拝",
    "ko": "우므라 & 하즈의 순나 예배",
    "hi": "उमरा और हज की सुन्नत नमाज़ें"
  },
  "dash.sunnah.hint": {
    "id": "Ragam salat sunnah di tanah suci",
    "en": "Various Sunnah prayers performed in the holy land",
    "ar": "أنواع الصلوات السنية في الأراضي المقدسة",
    "fr": "Diverses prières sunnah accomplies en Terre Sainte",
    "de": "Verschiedene Sunnah-Gebete im Heiligen Land",
    "es": "Diversas oraciones sunnah realizadas en la Tierra Santa",
    "ru": "Различные сунна-намазы, совершаемые на Святой земле",
    "zh": "在圣地所行的各类逊奈礼拜",
    "ja": "聖地で行われるさまざまなスンナ礼拝",
    "ko": "성지에서 드리는 다양한 순나 예배",
    "hi": "पवित्र भूमि में अदा की जाने वाली विभिन्न सुन्नत नमाज़ें"
  },
  "quran.title": {
    "id": "Al-Qur'an & Tafsir",
    "en": "Al-Qur'an & Tafsir",
    "ar": "القرآن الكريم والتفسير",
    "fr": "Al-Qur'an & Tafsir",
    "de": "Al-Qur'an & Tafsir",
    "es": "Al-Qur'an & Tafsir",
    "ru": "Аль-Куръан и Тафсир",
    "zh": "《古兰经》与注释（Tafsir）",
    "ja": "アル＝クルアーンとタフスィール",
    "ko": "알-꾸르안 & 타프시르",
    "hi": "अल-क़ुरआन और तफ़सीर"
  },
  "quran.subtitle": {
    "id": "114 surah lengkap dengan terjemahan & tafsir Kemenag",
    "en": "114 complete Surahs with translation & Tafsir from the Ministry of Religious Affairs",
    "ar": "١١٤ سورة كاملة مع الترجمة والتفسير من وزارة الشؤون الدينية",
    "fr": "114 sourates complètes avec traduction & Tafsir du Ministère des Affaires Religieuses",
    "de": "114 vollständige Suren mit Übersetzung & Tafsir des Ministeriums für Religiöse Angelegenheiten",
    "es": "114 Surahs completas con traducción y Tafsir del Ministerio de Asuntos Religiosos",
    "ru": "114 полных сур с переводом и Тафсиром Министерства по делам религий",
    "zh": "114章完整经文，附印度尼西亚宗教事务部译文与注释（Tafsir）",
    "ja": "宗教省によるタフスィール付き114スーラの完全翻訳",
    "ko": "종교부의 번역 & 타프시르가 포함된 114개 수라 전문",
    "hi": "धार्मिक मामलों के मंत्रालय के अनुवाद और तफ़सीर सहित 114 पूर्ण सूरतें"
  },
  "quran.search": {
    "id": "Cari surah...",
    "en": "Search surah...",
    "ar": "ابحث عن سورة...",
    "fr": "Rechercher une sourate...",
    "de": "Sure suchen...",
    "es": "Buscar surah...",
    "ru": "Поиск суры...",
    "zh": "搜索苏拉...",
    "ja": "スーラを検索...",
    "ko": "수라 검색...",
    "hi": "सूरह खोजें..."
  },
  "quran.ayat": {
    "id": "Ayat",
    "en": "Verse",
    "ar": "آية",
    "fr": "Verset",
    "de": "Vers",
    "es": "Versículo",
    "ru": "Аят",
    "zh": "节",
    "ja": "アーヤ",
    "ko": "아야트",
    "hi": "आयत"
  },
  "quran.tafsir": {
    "id": "Tafsir",
    "en": "Tafsir",
    "ar": "تفسير",
    "fr": "Tafsir",
    "de": "Tafsir",
    "es": "Tafsir",
    "ru": "Тафсир",
    "zh": "塔夫西尔",
    "ja": "タフスィール",
    "ko": "타프시르",
    "hi": "तफ़सीर"
  },
  "quran.back": {
    "id": "Kembali",
    "en": "Back",
    "ar": "رجوع",
    "fr": "Retour",
    "de": "Zurück",
    "es": "Volver",
    "ru": "Назад",
    "zh": "返回",
    "ja": "戻る",
    "ko": "뒤로",
    "hi": "वापस"
  },
  "quran.loading": {
    "id": "Memuat...",
    "en": "Loading...",
    "ar": "جارٍ التحميل...",
    "fr": "Chargement...",
    "de": "Wird geladen...",
    "es": "Cargando...",
    "ru": "Загрузка...",
    "zh": "加载中...",
    "ja": "読み込み中...",
    "ko": "불러오는 중...",
    "hi": "लोड हो रहा है..."
  },
  "ziyarah.title": {
    "id": "Tempat Bersejarah",
    "en": "Historical Sites",
    "ar": "المواقع التاريخية",
    "fr": "Sites Historiques",
    "de": "Historische Stätten",
    "es": "Lugares Históricos",
    "ru": "Исторические места",
    "zh": "历史遗址",
    "ja": "史跡",
    "ko": "역사 유적지",
    "hi": "ऐतिहासिक स्थल"
  },
  "ziyarah.subtitle": {
    "id": "Situs ziyarah di Makkah & Madinah beserta kisahnya di zaman Rasulullah ﷺ",
    "en": "Ziyarah sites in Makkah & Madinah along with their stories from the time of the Prophet ﷺ",
    "ar": "مواقع الزيارة في مكة المكرمة والمدينة المنورة مع قصصها في عهد رسول الله ﷺ",
    "fr": "Sites de ziyarah à La Mecque et à Médine avec leurs récits à l'époque du Prophète ﷺ",
    "de": "Ziyarah-Stätten in Makkah & Madinah und ihre Geschichte zur Zeit des Propheten ﷺ",
    "es": "Sitios de ziyarah en La Meca y Medina junto con sus historias de la época del Profeta ﷺ",
    "ru": "Места зияры в Мекке и Медине и их истории времён Пророка ﷺ",
    "zh": "麦加与麦地那的探访（Ziyarah）圣地及其先知ﷺ时代的故事",
    "ja": "マッカ＆マディーナのズィヤーラ巡礼地と預言者ﷺの時代のその物語",
    "ko": "예언자 ﷺ 시대의 이야기와 함께하는 마카 & 마디나의 지야라 성지",
    "hi": "मक्का और मदीना में ज़ियारा स्थल एवं नबी ﷺ के युग की उनकी कहानियाँ"
  },
  "ziyarah.makkah": {
    "id": "Makkah",
    "en": "Makkah",
    "ar": "مكة المكرمة",
    "fr": "La Mecque",
    "de": "Makkah",
    "es": "La Meca",
    "ru": "Мекка",
    "zh": "麦加",
    "ja": "マッカ",
    "ko": "마카",
    "hi": "मक्का"
  },
  "ziyarah.madinah": {
    "id": "Madinah",
    "en": "Madinah",
    "ar": "المدينة المنورة",
    "fr": "Médine",
    "de": "Madinah",
    "es": "Medina",
    "ru": "Медина",
    "zh": "麦地那",
    "ja": "マディーナ",
    "ko": "마디나",
    "hi": "मदीना"
  },
  "ziyarah.makkah.haram.name": {
    "id": "Masjidil Haram & Ka'bah",
    "en": "Masjidil Haram & Ka'bah",
    "ar": "المسجد الحرام والكعبة المشرفة",
    "fr": "Masjidil Haram & Ka'bah",
    "de": "Masjidil Haram & Ka'bah",
    "es": "Masjidil Haram & Ka'bah",
    "ru": "Масджидул-Харам и Кааба",
    "zh": "禁寺（Masjidil Haram）与天房（Ka'bah）",
    "ja": "マスジドゥル・ハラーム＆カアバ",
    "ko": "마스지딜 하람 & 카아바",
    "hi": "मस्जिदुल हराम और काबा"
  },
  "ziyarah.makkah.haram.story": {
    "id": "Kiblat seluruh Muslim dan rumah pertama yang dibangun untuk manusia menyembah Allah. Ka'bah dibangun kembali oleh Nabi Ibrahim & Ismail. Ketika kaum Quraisy merenovasinya sebelum kenabian, mereka berselisih siapa yang meletakkan Hajar Aswad; Nabi Muhammad ﷺ menengahi dengan meletakkannya di atas kain agar semua kabilah mengangkatnya bersama. Saat Fathu Makkah (8 H), beliau ﷺ membersihkan 360 berhala di sekitarnya sambil membaca, 'Kebenaran telah datang dan lenyaplah kebatilan.'",
    "en": "The Qiblah of all Muslims and the first house built for mankind to worship Allah. The Ka'bah was rebuilt by Prophet Ibrahim & Ismail. When the Quraysh renovated it before Prophethood, they disputed over who would place the Hajar Aswad; the Prophet Muhammad ﷺ mediated by placing it on a cloth so that all the tribes could lift it together. During Fathu Makkah (8 AH), he ﷺ cleansed 360 idols from around it while reciting, 'Truth has come and falsehood has perished.'",
    "ar": "قبلة جميع المسلمين وأول بيت وُضع للناس ليعبدوا الله. أعاد بناء الكعبة المشرفة النبيان إبراهيم وإسماعيل عليهما السلام. وحين جدَّدت قريش بناءها قبل البعثة النبوية اختلفوا في وضع الحجر الأسود، فتوسَّط النبي محمد ﷺ بوضعه على كساء ليرفعه جميع القبائل معاً. وفي يوم الفتح (8 هـ) طهَّر ﷺ الكعبة من ثلاثمائة وستين صنماً وهو يتلو: ﴿جَاءَ الْحَقُّ وَزَهَقَ الْبَاطِلُ﴾.",
    "fr": "La Qiblah de tous les musulmans et la première maison construite pour que l'humanité adore Allah. La Ka'bah a été rebâtie par le Prophète Ibrahim et Ismaïl. Lorsque les Quraysh la rénovèrent avant la prophétie, ils se disputèrent pour savoir qui poserait le Hajar Aswad ; le Prophète Muhammad ﷺ joua les médiateurs en le plaçant sur un tissu afin que toutes les tribus puissent le soulever ensemble. Lors du Fathu Makkah (8 H), il ﷺ purifia 360 idoles qui l'entouraient en récitant : « La vérité est venue et le mensonge a disparu. »",
    "de": "Die Qiblah aller Muslime und das erste Haus, das für die Menschheit zur Anbetung Allahs errichtet wurde. Die Ka'bah wurde von den Propheten Ibrahim und Ismail wiederaufgebaut. Als die Quraysh sie vor der Prophetenschaft renovierten, stritten sie darüber, wer den Hajar Aswad platzieren sollte; der Prophet Muhammad ﷺ vermittelte, indem er ihn auf ein Tuch legte, damit alle Stämme ihn gemeinsam anheben konnten. Beim Fathu Makkah (8 n. H.) reinigte er ﷺ 360 Götzen rund um sie, während er rezitierte: „Die Wahrheit ist gekommen und das Falsche hat sich verflüchtigt.\"",
    "es": "La Qiblah de todos los musulmanes y la primera casa construida para que la humanidad adorara a Allah. La Ka'bah fue reconstruida por el Profeta Ibrahim e Ismail. Cuando los Quraysh la renovaron antes de la Profecía, disputaron sobre quién colocaría el Hajar Aswad; el Profeta Muhammad ﷺ medió colocándolo sobre una tela para que todas las tribus pudieran levantarlo juntas. Durante el Fathu Makkah (8 H), él ﷺ purificó 360 ídolos a su alrededor mientras recitaba: «La verdad ha llegado y la falsedad ha perecido.»",
    "ru": "Кибла всех мусульман и первый дом, возведённый для поклонения людей Аллаху. Каабу восстановили пророки Ибрахим и Исмаил. Когда курайшиты обновляли её до начала пророческой миссии, они поспорили о том, кто положит Хаджар аль-Асвад на место; Пророк Мухаммад ﷺ разрешил спор, поместив камень на плащ, чтобы все племена подняли его вместе. В день Фатх Мakkah (8 г. х.) он ﷺ очистил вокруг неё 360 идолов, произнося: «Истина пришла, и ложь сгинула».",
    "zh": "所有穆斯林的礼拜朝向（Qiblah），也是为人类建造的第一座敬拜真主的圣殿。天房（Ka'bah）由先知易卜拉欣（Ibrahim）与伊斯玛仪（Ismail）重建。古莱氏人（Quraysh）在先知受命前翻修天房时，争执谁来安放黑石（Hajar Aswad）；先知穆罕默德ﷺ从中调解，将黑石置于布上，让所有部落共同抬起。在征服麦加（Fathu Makkah，伊历8年）时，他ﷺ清除了周围360座偶像，同时诵读：\"真理已降临，虚妄已消逝。\"",
    "ja": "すべてのムスリムのキブラ（礼拝の方向）であり、人類がアッラーを礼拝するために建てられた最初の家。カアバは預言者イブラーヒームとイスマーイールによって再建された。クライシュ族が預言者使命の前に修復した際、ハジャル・アスワドを誰が置くかで争いが生じた。預言者ムハンマドﷺは布の上に石を置き、全部族が共に持ち上げられるよう仲裁した。ファトフ・マッカ（ヒジュラ暦8年）の際、彼ﷺは「真実は来たり、虚偽は滅びた」と唱えながら、周囲の360体の偶像を取り除いた。",
    "ko": "모든 무슬림의 끼블라이자 인류가 알라를 예배하기 위해 세워진 최초의 집. 카아바는 예언자 이브라힘과 이스마일에 의해 재건되었다. 쿠라이시족이 예언자 사명 이전에 카아바를 보수할 때 하자르 아스와드를 누가 놓을지를 두고 분쟁이 생겼고, 예언자 무함마드 ﷺ는 천을 위에 놓고 모든 부족이 함께 들어 올릴 수 있도록 중재하였다. 파트후 마카(히즈라력 8년) 때 그ﷺ는 \"진리가 왔고 거짓은 사라졌다\"고 낭송하며 주변의 360개 우상을 없앴다.",
    "hi": "समस्त मुसलमानों का क़िब्ला और अल्लाह की इबादत के लिए मनुष्यों हेतु बनाया गया पहला घर। काबा को नबी इब्राहीम और इस्माईल ने पुनर्निर्मित किया था। जब क़ुरैश ने नुबुव्वत से पहले इसकी मरम्मत की तो हजरे-असवद रखने को लेकर विवाद हुआ; नबी मुहम्मद ﷺ ने एक कपड़े पर पत्थर रखकर मध्यस्थता की ताकि सभी कबीले मिलकर इसे उठा सकें। फत्हु मक्का (8 हिजरी) के दिन उन्होंने ﷺ आसपास के 360 बुतों को साफ़ करते हुए पढ़ा: 'सच आ गया और झूठ मिट गया।'"
  },
  "ziyarah.makkah.hira.name": {
    "id": "Jabal Nur – Gua Hira",
    "en": "Jabal Nur – Cave of Hira",
    "ar": "جبل النور – غار حراء",
    "fr": "Jabal Nur – Grotte de Hirâ",
    "de": "Jabal Nur – Höhle Hira",
    "es": "Jabal Nur – Cueva de Hira",
    "ru": "Джабаль Нур – пещера Хира",
    "zh": "努尔山（Jabal Nur）——希拉山洞（Gua Hira）",
    "ja": "ジャバル・ヌール – ヒラー洞窟",
    "ko": "자발 누르 – 히라 동굴",
    "hi": "जबल नूर – गार-ए-हिरा"
  },
  "ziyarah.makkah.hira.story": {
    "id": "Di gua kecil di puncak Jabal Nur inilah Nabi Muhammad ﷺ sering menyendiri untuk beribadah. Pada usia 40 tahun, Malaikat Jibril datang dan memeluk beliau seraya berkata 'Iqra' (Bacalah!), menurunkan wahyu pertama: Surah Al-'Alaq ayat 1–5. Inilah awal kenabian dan risalah Islam.",
    "en": "It is in this small cave at the summit of Jabal Nur that the Prophet Muhammad ﷺ would often seclude himself in worship. At the age of 40, the Angel Jibril came and embraced him, saying 'Iqra' (Read!), revealing the first revelation: Surah Al-'Alaq, verses 1–5. This was the beginning of prophethood and the message of Islam.",
    "ar": "في هذا الغار الصغير على قمة جبل النور كان النبي محمد ﷺ يتعبّد ويتخلّى للعبادة. وفي سن الأربعين جاءه جبريل عليه السلام فضمّه وقال: 'اقرأ'، فنزل الوحي الأول: سورة العلق، الآيات 1–5. وكان ذلك بداية النبوة ورسالة الإسلام.",
    "fr": "C'est dans cette petite grotte au sommet du Jabal Nur que le Prophète Muhammad ﷺ se retirait souvent pour l'adoration. À l'âge de 40 ans, l'ange Jibril vint l'embrasser en disant 'Iqra' (Lis !), révélant la première révélation : la Sourate Al-'Alaq, versets 1–5. Ce fut le début de la prophétie et du message de l'Islam.",
    "de": "In dieser kleinen Höhle auf dem Gipfel des Jabal Nur pflegte der Prophet Muhammad ﷺ sich oft zur Anbetung zurückzuziehen. Im Alter von 40 Jahren kam der Engel Jibril zu ihm, umarmte ihn und sprach 'Iqra' (Lies!), womit die erste Offenbarung herabgesandt wurde: Sure Al-'Alaq, Verse 1–5. Dies war der Beginn des Prophetentums und der Botschaft des Islam.",
    "es": "En esta pequeña cueva en la cima del Jabal Nur, el Profeta Muhammad ﷺ solía retirarse para adorar a Allah. A los 40 años, el ángel Jibril vino, lo abrazó y dijo 'Iqra' (¡Lee!), revelando la primera revelación: Surah Al-'Alaq, versículos 1–5. Este fue el comienzo de la profecía y el mensaje del Islam.",
    "ru": "Именно в этой небольшой пещере на вершине Джабаль Нур Пророк Мухаммад ﷺ часто уединялся для поклонения. В возрасте 40 лет явился ангел Джибриль, обнял его и произнёс «Икра» (Читай!), ниспослав первое откровение: Суру Аль-'Алак, аяты 1–5. Это было начало пророчества и послания Ислама.",
    "zh": "正是在努尔山（Jabal Nur）山顶的这个小山洞里，先知穆罕默德ﷺ常常独自隐居礼拜。40岁时，天使吉布里勒前来将他紧紧抱住，说道\"伊格拉\"（你念吧！），降示了第一段启示：《凝块章》（Al-'Alaq）第1至5节。这是先知职责与伊斯兰使命的开端。",
    "ja": "ジャバル・ヌール（Jabal Nur）の頂にあるこの小さな洞窟で、預言者ムハンマドﷺはしばしば礼拝のために籠もりました。40歳のとき、天使ジブリールが現れて彼を抱きしめ、「イクラ（読め！）」と告げ、最初の啓示であるスーラ・アル＝アラク第1〜5節が下されました。これが預言者としての使命とイスラームのメッセージの始まりです。",
    "ko": "자발 누르(Jabal Nur) 정상에 있는 이 작은 동굴에서 예언자 무함마드ﷺ는 자주 홀로 예배를 드리며 은거하였습니다. 40세가 되던 해, 천사 지브리일(Jibril)이 찾아와 그를 꼭 껴안으며 '이크라(읽어라!)'라고 말하였고, 최초의 계시인 수라 알-알라크(Al-'Alaq) 1~5절이 내려졌습니다. 이것이 예언자직과 이슬람 메시지의 시작이었습니다.",
    "hi": "जबल नूर (Jabal Nur) की चोटी पर स्थित इसी छोटी गुफा में नबी मुहम्मद ﷺ अक्सर इबादत के लिए एकांत में रहते थे। 40 वर्ष की आयु में फ़रिश्ते जिब्रील उनके पास आए और उन्हें गले लगाते हुए कहा 'इक्रा' (पढ़ो!), जिससे पहली वही नाज़िल हुई: सूरह अल-'अलक, आयत 1–5। यही नबूवत और इस्लाम के पैग़ाम की शुरुआत थी।"
  },
  "ziyarah.makkah.tsur.name": {
    "id": "Jabal Tsur – Gua Tsur",
    "en": "Jabal Tsur – Cave of Tsur",
    "ar": "جبل ثور – غار ثور",
    "fr": "Jabal Tsur – Grotte de Tsur",
    "de": "Jabal Tsur – Höhle von Tsur",
    "es": "Jabal Tsur – Cueva de Tsur",
    "ru": "Джабаль Тур – Пещера Тур",
    "zh": "萨乌尔山（Jabal Tsur）——萨乌尔山洞",
    "ja": "ジャバル・ツール（Jabal Tsur）― ツールの洞窟",
    "ko": "자발 쑤르(Jabal Tsur) – 쑤르 동굴",
    "hi": "जबल सूर (Jabal Tsur) – ग़ार-ए-सूर"
  },
  "ziyarah.makkah.tsur.story": {
    "id": "Ketika hijrah ke Madinah, Nabi ﷺ dan Abu Bakar ash-Shiddiq bersembunyi tiga hari di gua ini dari kejaran Quraisy. Allah melindungi mereka; dikisahkan laba-laba membuat sarang dan burung merpati bertelur di mulut gua. Saat Abu Bakar cemas, Nabi ﷺ berkata, 'Janganlah bersedih, sesungguhnya Allah bersama kita.' (QS. At-Taubah: 40).",
    "en": "During the Hijrah to Madinah, the Prophet ﷺ and Abu Bakar ash-Shiddiq hid for three days in this cave to escape the pursuit of the Quraysh. Allah protected them; it is narrated that a spider spun its web and a dove laid its eggs at the mouth of the cave. When Abu Bakar grew anxious, the Prophet ﷺ said, 'Do not grieve, for indeed Allah is with us.' (QS. At-Taubah: 40).",
    "ar": "حين هاجر النبي ﷺ إلى المدينة، اختبأ هو وأبو بكر الصدّيق ثلاثة أيام في هذا الغار فراراً من تعقّب قريش. حماهم الله تعالى؛ وتُروى قصة أن العنكبوت نسج خيوطه وأن الحمامة باضت عند مدخل الغار. وحين اعترى أبا بكر القلق، قال له النبي ﷺ: 'لَا تَحْزَنْ إِنَّ اللَّهَ مَعَنَا.' (سورة التوبة: 40).",
    "fr": "Lors de la Hijrah vers Médine, le Prophète ﷺ et Abu Bakar ash-Shiddiq se cachèrent pendant trois jours dans cette grotte pour échapper à la poursuite des Quraysh. Allah les protégea ; il est rapporté qu'une araignée tissa sa toile et qu'une colombe pondit ses œufs à l'entrée de la grotte. Lorsqu'Abu Bakar s'inquiéta, le Prophète ﷺ dit : 'Ne t'attriste pas, car Allah est certainement avec nous.' (Sourate At-Taubah : 40).",
    "de": "Während der Hijrah nach Madinah versteckten sich der Prophet ﷺ und Abu Bakar ash-Shiddiq drei Tage lang in dieser Höhle, um der Verfolgung der Quraysch zu entkommen. Allah schützte sie; es wird berichtet, dass eine Spinne ihr Netz spann und eine Taube am Eingang der Höhle ihre Eier legte. Als Abu Bakar besorgt wurde, sagte der Prophet ﷺ: 'Sei nicht traurig, denn wahrlich, Allah ist mit uns.' (QS. At-Taubah: 40).",
    "es": "Durante la Hégira a Medina, el Profeta ﷺ y Abu Bakar ash-Shiddiq se escondieron durante tres días en esta cueva para escapar de la persecución de los Quraysh. Allah los protegió; se narra que una araña tejió su tela y una paloma puso sus huevos en la boca de la cueva. Cuando Abu Bakar se angustió, el Profeta ﷺ dijo: 'No te entristezcas, pues ciertamente Allah está con nosotros.' (Corán, At-Taubah: 40).",
    "ru": "Во время Хиджры в Медину Пророк ﷺ и Абу Бакр ас-Сиддик скрывались в этой пещере три дня, спасаясь от преследования курайшитов. Аллах охранял их; передаётся, что паук сплёл свою паутину, а голубь отложил яйца у входа в пещеру. Когда Абу Бакр встревожился, Пророк ﷺ сказал: «Не печалься, ведь поистине Аллах с нами». (Коран, Ат-Тауба: 40).",
    "zh": "在迁徙（Hijrah）前往麦地那途中，先知ﷺ与艾布·伯克尔·阿西迪格（Abu Bakar ash-Shiddiq）在此洞中躲藏了三天，以躲避古莱什人的追捕。安拉保护了他们；据传一只蜘蛛在洞口结网，一只鸽子在洞口产卵。当艾布·伯克尔感到担忧时，先知ﷺ说：\"不要悲伤，真主确实与我们同在。\"（《古兰经》忏悔章：40节）。",
    "ja": "マディーナへのヒジュラ（移住）の際、預言者ﷺとアブー・バクル・アッ＝スィッディークはクライシュ族の追跡から逃れるため、この洞窟に3日間身を隠しました。アッラーが彼らを守られ、蜘蛛が巣を張り、鳩が洞窟の入り口に卵を産んだと伝えられています。アブー・バクルが不安になったとき、預言者ﷺは「悲しむな、まことにアッラーは我々と共におられる」と仰いました。（クルアーン、アッ＝タウバ：40節）。",
    "ko": "마디나로의 히즈라(Hijrah) 중에 예언자ﷺ와 아부 바크르 앗-싯디크(Abu Bakar ash-Shiddiq)는 쿠라이쉬(Quraysh)의 추격을 피해 이 동굴에 3일간 숨어 있었습니다. 알라께서 그들을 보호하셨으며, 거미가 동굴 입구에 거미줄을 치고 비둘기가 알을 낳았다고 전해집니다. 아부 바크르가 불안해하자 예언자ﷺ는 \"슬퍼하지 말라, 분명히 알라께서 우리와 함께 계신다\"라고 말씀하셨습니다. (꾸란, 앗-타우바: 40절).",
    "hi": "मदीना की ओर हिजरत के दौरान नबी ﷺ और हज़रत अबू बक्र अस-सिद्दीक़ तीन दिनों तक इस गुफा में क़ुरैश के पीछा करने से बचने के लिए छुपे रहे। अल्लाह ने उनकी रक्षा की; रिवायत है कि एक मकड़ी ने गुफा के मुँह पर जाला बुना और एक कबूतर ने वहाँ अंडे दिए। जब अबू बक्र घबरा गए, तो नबी ﷺ ने फ़रमाया: 'ग़म मत करो, बेशक अल्लाह हमारे साथ है।' (क़ुरआन, अत-तौबा: 40)।"
  },
  "ziyarah.makkah.rahmah.name": {
    "id": "Jabal Rahmah – Padang Arafah",
    "en": "Jabal Rahmah – Plain of Arafah",
    "ar": "جبل الرحمة – صعيد عرفات",
    "fr": "Jabal Rahmah – Plaine d'Arafah",
    "de": "Jabal Rahmah – Ebene von Arafah",
    "es": "Jabal Rahmah – Llanura de Arafah",
    "ru": "Джабаль Рахма – Долина Арафа",
    "zh": "仁慈山（Jabal Rahmah）——阿拉法特平原",
    "ja": "ジャバル・ラフマ（Jabal Rahmah）― アラファの平原",
    "ko": "자발 라흐마(Jabal Rahmah) – 아라파(Arafah) 평원",
    "hi": "जबल रहमा (Jabal Rahmah) – अरफ़ात का मैदान"
  },
  "ziyarah.makkah.rahmah.story": {
    "id": "Di padang Arafah, di dekat Jabal Rahmah, Nabi ﷺ menyampaikan Khutbah Wada' (haji perpisahan) di hadapan lebih dari 100.000 sahabat. Beliau menegaskan kesucian darah dan harta, hak-hak wanita, penghapusan riba, dan persaudaraan. Di sinilah turun ayat, 'Pada hari ini telah Kusempurnakan bagimu agamamu.' (QS. Al-Ma'idah: 3).",
    "en": "On the plain of Arafah, near Jabal Rahmah, the Prophet ﷺ delivered the Farewell Sermon (Khutbah Wada') before more than 100,000 companions. He affirmed the sanctity of blood and wealth, women's rights, the abolition of usury, and brotherhood. It was here that the verse was revealed: 'This day I have perfected for you your religion.' (QS. Al-Ma'idah: 3).",
    "ar": "في صعيد عرفات، بالقرب من جبل الرحمة، ألقى النبي ﷺ خطبة الوداع أمام أكثر من مئة ألف صحابي. فأكّد حرمة الدماء والأموال، وحقوق المرأة، وإلغاء الربا، وأواصر الأخوة الإسلامية. وهنا نزلت الآية الكريمة: 'الْيَوْمَ أَكْمَلْتُ لَكُمْ دِينَكُمْ.' (سورة المائدة: 3).",
    "fr": "Sur la plaine d'Arafah, près du Jabal Rahmah, le Prophète ﷺ prononça le Sermon d'Adieu (Khutbah Wada') devant plus de 100 000 compagnons. Il affirma la sacralité du sang et des biens, les droits des femmes, l'abolition de l'usure et la fraternité. C'est ici que fut révélé le verset : 'Aujourd'hui, J'ai parachevé pour vous votre religion.' (Sourate Al-Ma'idah : 3).",
    "de": "Auf der Ebene von Arafah, nahe dem Jabal Rahmah, hielt der Prophet ﷺ die Abschiedspredigt (Khutbah Wada') vor mehr als 100.000 Gefährten. Er betonte die Heiligkeit von Blut und Vermögen, die Rechte der Frauen, die Abschaffung des Zinses und die Brüderlichkeit. Hier wurde der Vers offenbart: 'Heute habe Ich euch eure Religion vervollständigt.' (QS. Al-Ma'idah: 3).",
    "es": "En la llanura de Arafah, cerca del Jabal Rahmah, el Profeta ﷺ pronunció el Sermón de Despedida (Khutbah Wada') ante más de 100.000 compañeros. Afirmó la santidad de la sangre y la riqueza, los derechos de las mujeres, la abolición de la usura y la fraternidad. Fue aquí donde se reveló el versículo: 'Hoy he perfeccionado para vosotros vuestra religión.' (Corán, Al-Ma'idah: 3).",
    "ru": "На равнине Арафа, вблизи Джабаль Рахма, Пророк ﷺ произнёс Прощальную проповедь (Хутбат аль-Вада') перед более чем 100 000 сподвижников. Он подтвердил неприкосновенность крови и имущества, права женщин, запрет ростовщичества и братство. Именно здесь был ниспослан аят: «Сегодня Я завершил для вас вашу религию». (Коран, Аль-Маида: 3).",
    "zh": "在阿拉法特平原靠近仁慈山（Jabal Rahmah）处，先知ﷺ在逾10万名圣门弟子面前发表了辞别演讲（Khutbah Wada'）。他强调了生命与财产的神圣性、妇女的权利、废除利息以及穆斯林的兄弟情谊。正是在这里，以下经文降示：\"今天，我为你们完善了你们的宗教。\"（《古兰经》筵席章：3节）。",
    "ja": "アラファの平原のジャバル・ラフマ近くで、預言者ﷺは10万人以上の教友たちを前に告別説教（フトバ・ワダー、Khutbah Wada'）を行いました。命と財産の神聖さ、女性の権利、利息の廃止、そして兄弟愛を確認されました。ここで次の御言葉が啓示されました：「今日、わたしはあなた方のためにあなた方の宗教を完成させた。」（クルアーン、アル＝マーイダ：3節）。",
    "ko": "아라파(Arafah) 평원의 자발 라흐마(Jabal Rahmah) 근처에서 예언자ﷺ는 10만 명이 넘는 교우들 앞에서 고별 설교(Khutbah Wada')를 전하셨습니다. 그는 생명과 재산의 신성함, 여성의 권리, 이자의 폐지, 그리고 형제애를 확언하셨습니다. 바로 이곳에서 다음 구절이 계시되었습니다: \"오늘 나는 너희를 위해 너희의 종교를 완성하였노라.\" (꾸란, 알-마이다: 3절).",
    "hi": "अरफ़ात के मैदान में जबल रहमा के पास नबी ﷺ ने 1 लाख से अधिक सहाबा के सामने विदाई भाषण (ख़ुत्बा वदा', Khutbah Wada') दिया। आपने ख़ून और माल की पवित्रता, महिलाओं के अधिकारों, सूद की समाप्ति और भाईचारे की पुष्टि की। यहीं यह आयत नाज़िल हुई: 'आज मैंने तुम्हारे लिए तुम्हारे दीन को मुकम्मल कर दिया।' (क़ुरआन, अल-माइदा: 3)।"
  },
  "ziyarah.makkah.mualla.name": {
    "id": "Jannatul Mu'alla",
    "en": "Jannatul Mu'alla",
    "ar": "جنة المعلى",
    "fr": "Jannatul Mu'alla",
    "de": "Jannatul Mu'alla",
    "es": "Jannatul Mu'alla",
    "ru": "Джаннат аль-Му'алла",
    "zh": "穆阿拉墓园（Jannatul Mu'alla）",
    "ja": "ジャンナトゥル・ムアッラー（Jannatul Mu'alla）",
    "ko": "잔나툴 무알라(Jannatul Mu'alla)",
    "hi": "जन्नतुल मु'अल्ला (Jannatul Mu'alla)"
  },
  "ziyarah.makkah.mualla.story": {
    "id": "Pemakaman tertua Makkah. Di sinilah dimakamkan istri tercinta Nabi ﷺ, Khadijah binti Khuwailid RA — wanita pertama yang beriman dan penopang dakwah di masa-masa sulit. Tahun wafatnya Khadijah dan paman beliau Abu Thalib dikenal sebagai 'Amul Huzn (Tahun Kesedihan).",
    "en": "The oldest cemetery in Makkah. Here lies the beloved wife of the Prophet ﷺ, Khadijah binti Khuwailid RA — the first woman to embrace Islam and the steadfast supporter of the da'wah during its most difficult times. The year of Khadijah's passing and that of his uncle Abu Thalib is known as 'Amul Huzn (the Year of Grief).",
    "ar": "أقدم مقابر مكة المكرمة. هنا دُفنت زوجة النبي ﷺ الحبيبة خديجة بنت خويلد رضي الله عنها — أول امرأة آمنت بالإسلام وركيزة الدعوة في أحلك أوقاتها. وقد عُرف عام وفاة خديجة ووفاة عمه أبي طالب بـ\"عام الحزن\".",
    "fr": "Le plus ancien cimetière de La Mecque. C'est ici que repose la bien-aimée épouse du Prophète ﷺ, Khadijah bint Khuwaylid RA — la première femme à avoir embrassé l'islam et le soutien indéfectible de la da'wah aux moments les plus difficiles. L'année du décès de Khadijah et de son oncle Abu Talib est connue sous le nom d''Amul Huzn (l'Année du Chagrin).",
    "de": "Der älteste Friedhof Makkahss. Hier ruht die geliebte Ehefrau des Propheten ﷺ, Khadijah binti Khuwailid RA — die erste Frau, die den Islam annahm, und die unerschütterliche Stütze der Da'wah in den schwierigsten Zeiten. Das Jahr ihres Todes und das des Onkels Abu Thalib ist bekannt als 'Amul Huzn (das Jahr der Trauer).",
    "es": "El cementerio más antiguo de La Meca. Aquí yace la amada esposa del Profeta ﷺ, Khadijah binti Khuwailid RA — la primera mujer en abrazar el islam y el firme sostén de la da'wah en los momentos más difíciles. El año del fallecimiento de Khadijah y de su tío Abu Talib es conocido como 'Amul Huzn (el Año del Dolor).",
    "ru": "Старейшее кладбище Мекки. Здесь покоится любимая супруга Пророка ﷺ, Хадиджа бинт Хувайлид RA — первая женщина, принявшая ислам, и верная опора да'вата в самые трудные времена. Год смерти Хадиджи и дяди Пророка Абу Талиба известен как 'Амул Хузн (Год Скорби).",
    "zh": "麦加最古老的墓地。先知ﷺ挚爱的妻子海迪彻·宾特·胡外利德（RA）长眠于此——她是第一位信仰伊斯兰的女性，也是在最艰难岁月中支撑传教事业的坚强柱石。海迪彻与先知的叔父阿布·塔利卜相继离世的那一年，被称为\"忧伤之年\"（'Amul Huzn）。",
    "ja": "マッカ最古の墓地。ここには預言者ﷺの愛する妻、ハディージャ・ビント・フワイリドRA――イスラームに最初に入信した女性であり、最も困難な時代にダアワを支えた柱――が眠っています。ハディージャと叔父アブー・ターリブが亡くなった年は「アームル・フズン（悲しみの年）」として知られています。",
    "ko": "메카에서 가장 오래된 묘지입니다. 이곳에는 예언자 ﷺ의 사랑하는 아내 하디자 빈트 후와일리드 RA — 이슬람을 가장 먼저 받아들인 여성이자 가장 어려운 시기에 다와를 지탱한 기둥 — 가 잠들어 있습니다. 하디자와 삼촌 아부 탈리브가 세상을 떠난 해는 '아물 후즌(슬픔의 해)'으로 알려져 있습니다.",
    "hi": "मक्का का सबसे पुराना कब्रिस्तान। यहाँ नबी ﷺ की प्रिय पत्नी खदीजा बिन्त खुवैलिद RA — इस्लाम की पहली महिला स्वीकारकर्ता और कठिनतम समय में दावत की आधारशिला — की कब्र है। खदीजा और उनके चाचा अबू तालिब के निधन के वर्ष को 'आमुल हुज़्न (शोक का वर्ष)' कहा जाता है।"
  },
  "ziyarah.makkah.tanim.name": {
    "id": "Masjid Tan'im (Miqat)",
    "en": "Tan'im Mosque (Miqat)",
    "ar": "مسجد التنعيم (الميقات)",
    "fr": "Mosquée de Tan'im (Miqat)",
    "de": "Tan'im-Moschee (Miqat)",
    "es": "Mezquita de Tan'im (Miqat)",
    "ru": "Мечеть Тан'им (Микат)",
    "zh": "坦尼姆清真寺（米卡特）",
    "ja": "タン'イム・モスク（ミーカート）",
    "ko": "탄임 모스크 (미카트)",
    "hi": "मस्जिद तन'ईम (मीक़ात)"
  },
  "ziyarah.makkah.tanim.story": {
    "id": "Titik miqat terdekat dari Makkah untuk mengambil ihram umrah. Dinamai juga Masjid Aisyah, karena Nabi ﷺ memerintahkan Aisyah RA mengambil ihram umrah dari sini pada haji Wada' setelah ia berhalangan menyelesaikan umrahnya.",
    "en": "The nearest Miqat point to Makkah for donning the Ihram for Umrah. It is also known as Masjid Aisha, because the Prophet ﷺ instructed Aisha RA to assume the Ihram for Umrah from this point during the Farewell Hajj, after she had been unable to complete her Umrah.",
    "ar": "أقرب نقطة ميقات من مكة المكرمة للإحرام بالعمرة. ويُعرف أيضاً بمسجد عائشة، إذ أمر النبي ﷺ عائشة رضي الله عنها أن تُحرم للعمرة من هذا المكان في حجة الوداع بعد أن حال المانع دون إتمامها عمرتها.",
    "fr": "Le point de Miqat le plus proche de La Mecque pour revêtir l'Ihram en vue de l'Umrah. Il est également connu sous le nom de Masjid Aisha, car le Prophète ﷺ avait ordonné à Aisha RA de prendre l'Ihram pour l'Umrah depuis cet endroit lors du Hajj d'Adieu, après qu'elle n'eût pu achever son Umrah.",
    "de": "Der nächstgelegene Miqat-Punkt zu Makkah, um den Ihram für die Umrah anzulegen. Er ist auch als Masjid Aisha bekannt, da der Prophet ﷺ Aisha RA anwies, beim Abschiedshajj von diesem Ort aus den Ihram für die Umrah anzunehmen, nachdem sie ihre Umrah nicht hatte vollenden können.",
    "es": "El punto de Miqat más cercano a La Meca para ponerse el Ihram con el fin de realizar la Umrah. También se le conoce como Masjid Aisha, pues el Profeta ﷺ ordenó a Aisha RA que tomara el Ihram para la Umrah desde este lugar durante el Hajj de Despedida, después de que ella no hubiera podido completar su Umrah.",
    "ru": "Ближайшая к Мекке точка Микат для принятия Ихрама перед Умрой. Также известна как Мечеть Аиши, поскольку Пророк ﷺ велел Аише RA вступить в Ихрам для Умры именно отсюда во время Прощального Хаджа, после того как она не смогла завершить свою Умру.",
    "zh": "距麦加最近的米卡特，用于穿戴小朝（副朝）的伊赫拉姆。此处亦称\"阿伊莎清真寺\"，因为先知ﷺ在辞别朝觐中，命令阿伊莎RA在此处开始小朝的伊赫拉姆，彼时她因故未能完成原来的小朝。",
    "ja": "ウムラのためのイフラームを身に着けるための、マッカに最も近いミーカート地点です。預言者ﷺが告別巡礼の際にアーイシャRAが自身のウムラを完了できなかった後、ここからウムラのイフラームを結ぶよう命じたことから、マスジド・アーイシャとも呼ばれています。",
    "ko": "우므라를 위한 이흐람을 착용하기 위해 메카에서 가장 가까운 미카트 지점입니다. 이별 하즈 당시 예언자 ﷺ가 아이샤 RA에게 우므라를 미처 마치지 못한 후 이곳에서 우므라의 이흐람을 입도록 명하셨기 때문에, 마스지드 아이샤로도 알려져 있습니다.",
    "hi": "मक्का से उम्रा के इह्राम के लिए सबसे निकटतम मीक़ात बिंदु। इसे मस्जिद आइशा भी कहा जाता है, क्योंकि नबी ﷺ ने हज्जतुल-विदाअ (विदाई हज) के दौरान आइशा RA को यहाँ से उम्रा का इह्राम बाँधने का आदेश दिया था, जब वे अपनी उम्रा पूरी करने में असमर्थ रही थीं।"
  },
  "ziyarah.madinah.nabawi.name": {
    "id": "Masjid Nabawi & Raudhah",
    "en": "Al-Masjid Al-Nabawi & Raudhah",
    "ar": "المسجد النبوي والروضة الشريفة",
    "fr": "Masjid Nabawi & Raudhah",
    "de": "Masjid Nabawi & Raudhah",
    "es": "Masjid Nabawi & Raudhah",
    "ru": "Мечеть Пророка (Масджид Набави) и Рауда",
    "zh": "先知清真寺（麦地那圣寺）与花园（Raudhah）",
    "ja": "マスジド・ナバウィー（預言者のモスク）とラウダ",
    "ko": "마스지드 나바위 & 라우다",
    "hi": "मस्जिद नबवी और रौज़ा"
  },
  "ziyarah.madinah.nabawi.story": {
    "id": "Masjid yang dibangun Nabi ﷺ sendiri bersama para sahabat sesaat setelah tiba di Madinah. Di dalamnya terdapat makam beliau ﷺ (di bawah Kubah Hijau) dan Raudhah — area antara rumah dan mimbar beliau yang disabdakan, 'Antara rumahku dan mimbarku adalah salah satu taman surga.'",
    "en": "The mosque built by the Prophet ﷺ himself together with his Companions shortly after arriving in Madinah. Within it lies his ﷺ tomb (beneath the Green Dome) and the Raudhah — the area between his house and his pulpit — of which he said: 'Between my house and my pulpit is one of the gardens of Paradise.'",
    "ar": "المسجد الذي بناه النبي ﷺ بنفسه مع صحابته الكرام فور وصوله إلى المدينة المنورة. ويضم قبره الشريف ﷺ تحت القبة الخضراء، والروضة الشريفة — المنطقة الواقعة بين بيته ومنبره — التي قال عنها: \"ما بين بيتي ومنبري روضةٌ من رياض الجنة\".",
    "fr": "La mosquée construite par le Prophète ﷺ lui-même avec ses Compagnons peu après son arrivée à Médine. Elle abrite son tombeau ﷺ (sous le Dôme Vert) et la Raudhah — l'espace entre sa maison et son minbar — dont il a dit : « Entre ma maison et mon minbar se trouve l'un des jardins du Paradis. »",
    "de": "Die Moschee, die der Prophet ﷺ selbst gemeinsam mit seinen Gefährten kurz nach seiner Ankunft in Madinah erbaute. In ihr befinden sich sein ﷺ Grab (unter der Grünen Kuppel) und die Raudhah — der Bereich zwischen seinem Haus und seiner Kanzel — über den er sagte: „Zwischen meinem Haus und meiner Kanzel ist einer der Gärten des Paradieses.\"",
    "es": "La mezquita construida por el Profeta ﷺ junto con sus Compañeros poco después de llegar a Medina. En su interior se encuentra su tumba ﷺ (bajo la Cúpula Verde) y la Raudhah — el área entre su casa y su mimbar — de la que él dijo: \"Entre mi casa y mi mimbar hay uno de los jardines del Paraíso.\"",
    "ru": "Мечеть, построенная самим Пророком ﷺ вместе с его сподвижниками вскоре после прибытия в Медину. В ней находится его ﷺ гробница (под Зелёным куполом) и Рауда — пространство между его домом и минбаром, о котором он сказал: «Между моим домом и моим минбаром — один из садов Рая».",
    "zh": "这座清真寺由先知ﷺ亲自与众圣门弟子在抵达麦地那后不久共同建造。寺内安葬着先知ﷺ（绿色圆顶之下），以及花园（Raudhah）——位于他的居所与讲台之间的区域——先知曾言：\"我的家与我的讲台之间，是天园中的一片园地。\"",
    "ja": "マディーナに到着してすぐ、預言者ﷺ自らが感化を受けた仲間たちとともに建設したモスクです。その中には預言者ﷺの御廟（緑のドームの下）と、ラウダ――彼の家とミンバル（説教壇）の間の区域――があり、彼はこう述べています。「私の家と私のミンバルの間は、楽園の庭園の一つである。」",
    "ko": "예언자 ﷺ께서 마디나에 도착하신 직후 교우들과 함께 직접 건축하신 모스크입니다. 내부에는 예언자 ﷺ의 묘소(녹색 돔 아래)와 라우다 — 그분의 집과 민바르 사이의 공간 — 가 있으며, 예언자 ﷺ께서는 이렇게 말씀하셨습니다: \"내 집과 내 민바르 사이는 천국의 정원 중 하나이다.\"",
    "hi": "यह मस्जिद नबी ﷺ ने स्वयं अपने साथियों के साथ मदीना पहुँचने के तुरंत बाद बनाई थी। इसके अंदर उनका ﷺ मज़ार (हरे गुंबद के नीचे) और रौज़ा — उनके घर और मिम्बर के बीच का क्षेत्र — है, जिसके बारे में उन्होंने फ़रमाया: \"मेरे घर और मेरे मिम्बर के बीच का हिस्सा जन्नत के बागों में से एक बाग है।\""
  },
  "ziyarah.madinah.quba.name": {
    "id": "Masjid Quba",
    "en": "Masjid Quba",
    "ar": "مسجد قباء",
    "fr": "Masjid Quba",
    "de": "Masjid Quba",
    "es": "Masjid Quba",
    "ru": "Мечеть Куба (Масджид Куба)",
    "zh": "古巴清真寺（Masjid Quba）",
    "ja": "マスジド・クバー",
    "ko": "마스지드 쿠바",
    "hi": "मस्जिद कुबा"
  },
  "ziyarah.madinah.quba.story": {
    "id": "Masjid pertama dalam sejarah Islam, diletakkan fondasinya oleh Nabi ﷺ saat singgah di Quba dalam perjalanan hijrah. Beliau ﷺ bersabda, 'Siapa yang berwudhu di rumahnya lalu datang ke Masjid Quba dan salat di dalamnya, ia mendapat pahala seperti umrah.'",
    "en": "The first mosque in Islamic history, whose foundation was laid by the Prophet ﷺ when he stopped at Quba during the Hijrah. He ﷺ said, 'Whoever performs wudu at home, then comes to Masjid Quba and prays there, will receive a reward equal to that of Umrah.'",
    "ar": "أول مسجد في تاريخ الإسلام، وضع أساسه النبي ﷺ حين نزل بقباء في طريق الهجرة. قال ﷺ: «مَن تطهَّر في بيته ثم أتى مسجد قباء فصلَّى فيه، كان له كأجر عمرة.»",
    "fr": "La première mosquée de l'histoire islamique, dont les fondations furent posées par le Prophète ﷺ lors de son séjour à Quba au cours de l'Hijrah. Il ﷺ a dit : « Quiconque fait ses ablutions chez lui, puis se rend à la Mosquée de Quba et y prie, recevra une récompense équivalente à celle d'une Umrah. »",
    "de": "Die erste Moschee in der islamischen Geschichte, deren Grundstein der Prophet ﷺ während seines Aufenthalts in Quba auf dem Weg der Hijrah legte. Er ﷺ sagte: „Wer zu Hause die Wudu vollzieht, dann zur Masjid Quba kommt und dort betet, erhält eine Belohnung, die der einer Umrah gleicht.\"",
    "es": "La primera mezquita en la historia islámica, cuya fundación fue establecida por el Profeta ﷺ cuando se detuvo en Quba durante la Hiyra. Él ﷺ dijo: «Quien realice el wudu en su casa, luego vaya a la Masjid Quba y ore allí, recibirá una recompensa equivalente a la de una Umrah.»",
    "ru": "Первая мечеть в истории ислама, фундамент которой заложил Пророк ﷺ во время остановки в Куба в ходе Хиджры. Он ﷺ сказал: «Тот, кто совершит омовение (вуду) дома, затем придёт в мечеть Куба и совершит там намаз, получит награду, равную награде за Умру».",
    "zh": "这是伊斯兰历史上的第一座清真寺，先知ﷺ在迁徙（Hijrah）途中停留于古巴（Quba）时亲自奠定了其基础。他ﷺ说：\"凡在家中完成净礼（wudu），然后前往古巴清真寺（Masjid Quba）礼拜者，其所获得的回赐如同完成了一次副朝（Umrah）。\"",
    "ja": "イスラーム史上最初のモスクであり、預言者ﷺがヒジュラの旅の途中にクバー（Quba）に立ち寄られた際、その礎を築かれました。預言者ﷺは仰せになりました。「自宅でウドゥーを行い、マスジド・クバー（Masjid Quba）に来て礼拝した者は、ウムラ（Umrah）に相当する報酬を得る。」",
    "ko": "이슬람 역사상 최초의 모스크로, 예언자ﷺ께서 히즈라(Hijrah) 여정 중 쿠바(Quba)에 들르셨을 때 그 기초를 놓으셨습니다. 그분ﷺ께서는 말씀하셨습니다. \"집에서 우두(wudu)를 행하고 마스지드 쿠바(Masjid Quba)에 와서 예배를 드리는 자는 움라(Umrah)에 해당하는 보상을 얻는다.\"",
    "hi": "यह इस्लामी इतिहास की पहली मस्जिद है, जिसकी नींव नबी ﷺ ने हिजरत के सफर में क़ुबा (Quba) में पड़ाव के दौरान रखी। आप ﷺ ने फ़रमाया: \"जो व्यक्ति अपने घर में वुज़ू करे, फिर मस्जिद क़ुबा (Masjid Quba) आकर नमाज़ पढ़े, उसे उमरह (Umrah) के बराबर सवाब मिलता है।\""
  },
  "ziyarah.madinah.qiblatain.name": {
    "id": "Masjid Qiblatain",
    "en": "Masjid Qiblatain",
    "ar": "مسجد القبلتين",
    "fr": "Mosquée Qiblatain",
    "de": "Masjid Qiblatain",
    "es": "Masjid Qiblatain",
    "ru": "Мечеть Киблатайн (Masjid Qiblatain)",
    "zh": "两朝向清真寺（Masjid Qiblatain）",
    "ja": "マスジド・キブラタイン（Masjid Qiblatain）",
    "ko": "마스지드 끼블라타인（Masjid Qiblatain）",
    "hi": "मस्जिद क़िब्लतैन (Masjid Qiblatain)"
  },
  "ziyarah.madinah.qiblatain.story": {
    "id": "Masjid 'dua kiblat'. Di sinilah, di tengah salat, turun perintah Allah agar kiblat dipindah dari Masjidil Aqsa (Baitul Maqdis) ke Ka'bah di Makkah. Nabi ﷺ dan para sahabat langsung berputar menghadap Ka'bah dalam salat yang sama (QS. Al-Baqarah: 144).",
    "en": "The mosque of 'two Qiblahs'. It was here, in the middle of prayer, that Allah's command descended to change the Qiblah from Masjid al-Aqsa (Baitul Maqdis) to the Ka'bah in Makkah. The Prophet ﷺ and his Companions immediately turned to face the Ka'bah within the same prayer (QS. Al-Baqarah: 144).",
    "ar": "مسجد «القبلتين». هنا، في أثناء الصلاة، نزل أمر الله بتحويل القبلة من المسجد الأقصى (بيت المقدس) إلى الكعبة في مكة المكرمة. فاستدار النبي ﷺ والصحابة فوراً نحو الكعبة في الصلاة ذاتها (القرآن الكريم، البقرة: 144).",
    "fr": "La mosquée des « deux Qiblahs ». C'est ici, en plein milieu de la prière, que descendit l'ordre d'Allah de déplacer la Qiblah de la Mosquée Al-Aqsa (Baitul Maqdis) vers la Ka'bah à La Mecque. Le Prophète ﷺ et ses Compagnons se retournèrent immédiatement vers la Ka'bah au cours de la même prière (QS. Al-Baqarah : 144).",
    "de": "Die Moschee der „zwei Qiblahs\". Hier, mitten im Gebet, kam Allahs Befehl herab, die Qiblah von der Masjid al-Aqsa (Baitul Maqdis) zur Ka'bah in Makkah zu verlegen. Der Prophet ﷺ und seine Gefährten wandten sich sofort der Ka'bah zu, noch während desselben Gebets (QS. Al-Baqarah: 144).",
    "es": "La mezquita de las «dos Qiblahs». Fue aquí, en medio de la oración, donde descendió la orden de Allah de cambiar la Qiblah desde la Masjid al-Aqsa (Baitul Maqdis) hacia la Ka'bah en La Meca. El Profeta ﷺ y sus Compañeros se giraron inmediatamente hacia la Ka'bah en la misma oración (QS. Al-Baqarah: 144).",
    "ru": "Мечеть «двух Кибл». Именно здесь, в середине намаза, сошло повеление Аллаха перенести Киблу с мечети Аль-Акса (Байтуль-Макдис) на Каабу в Мекке. Пророк ﷺ и его сподвижники немедленно повернулись в сторону Каабы прямо в ходе того же намаза (Коран, Аль-Бакара: 144).",
    "zh": "这是\"两朝向\"清真寺。正是在这里，礼拜进行当中，真主降示命令，将朝向（Qiblah）从阿克萨清真寺（Masjid al-Aqsa，即白图・麦格迪斯）改为麦加的天房（Ka'bah）。先知ﷺ与众圣门弟子当即在同一次礼拜中转身面向天房（《古兰经》黄牛章：144节）。",
    "ja": "「二つのキブラ（Qiblah）」のモスクです。ここで礼拝の最中に、キブラをマスジド・アル＝アクサー（Masjid al-Aqsa、バイトゥル・マクディス）からマッカのカアバ（Ka'bah）へ変更するというアッラーの命令が下りました。預言者ﷺとサハーバたちは、同じ礼拝の中でただちにカアバの方向へ向き直りました（クルアーン、アル＝バカラ：144節）。",
    "ko": "'두 키블라(Qiblah)'의 모스크입니다. 바로 이곳에서 예배 도중 알라의 명령이 내려와, 키블라를 마스지드 알-아크사(Masjid al-Aqsa, 바이툴 막디스)에서 메카의 카아바(Ka'bah)로 변경하게 되었습니다. 예언자ﷺ와 교우들은 같은 예배 중에 즉시 카아바 방향으로 돌아섰습니다（꾸란, 알-바카라: 144절）.",
    "hi": "यह \"दो क़िब्लों\" की मस्जिद है। यहीं नमाज़ के दौरान अल्लाह का यह हुक्म नाज़िल हुआ कि क़िब्ला (Qiblah) को मस्जिद अल-अक़्सा (Masjid al-Aqsa, बैतुल मक़्दिस) से बदलकर मक्का की काबा (Ka'bah) की ओर कर दिया जाए। नबी ﷺ और सहाबा ने उसी नमाज़ में फ़ौरन काबा की तरफ़ रुख़ कर लिया (क़ुरआन, अल-बक़रह: 144)।"
  },
  "ziyarah.madinah.uhud.name": {
    "id": "Jabal Uhud & Makam Syuhada",
    "en": "Jabal Uhud & the Martyrs' Cemetery",
    "ar": "جبل أُحد ومقبرة الشهداء",
    "fr": "Jabal Uhud & Cimetière des Martyrs",
    "de": "Jabal Uhud & Märtyrerfriedhof",
    "es": "Jabal Uhud & Cementerio de los Mártires",
    "ru": "Джабаль Ухуд и Кладбище мучеников",
    "zh": "乌胡德山（Jabal Uhud）与烈士墓地",
    "ja": "ジャバル・ウフド（Jabal Uhud）と殉教者墓地",
    "ko": "자발 우후드（Jabal Uhud）와 순교자 묘지",
    "hi": "जबल उहुद (Jabal Uhud) और शुहदा का क़ब्रिस्तान"
  },
  "ziyarah.madinah.uhud.story": {
    "id": "Lokasi Perang Uhud (3 H). Di sinilah 70 sahabat gugur syahid, termasuk paman Nabi ﷺ, Hamzah bin Abdul Muthalib RA, 'Singa Allah'. Gigi geraham Nabi ﷺ pun patah. Tentang Uhud beliau bersabda, 'Ini gunung yang mencintai kami dan kami mencintainya.'",
    "en": "The site of the Battle of Uhud (3 AH). Here, 70 Companions were martyred, including the Prophet's ﷺ uncle, Hamzah bin Abdul Muttalib RA, 'the Lion of Allah'. The Prophet's ﷺ molar tooth was also broken here. Regarding Uhud, he ﷺ said: 'This is a mountain that loves us and we love it.'",
    "ar": "موقع غزوة أُحد (3 هـ). هنا استشهد سبعون صحابياً، من بينهم عمُّ النبي ﷺ حمزة بن عبد المطلب رضي الله عنه، «أسد الله». وكُسرت فيها رَباعيَّة النبي ﷺ. وقال ﷺ في حقِّ أُحد: «هذا جبلٌ يُحبُّنا ونحبُّه.»",
    "fr": "Le site de la Bataille d'Uhud (3 H). C'est ici que 70 Compagnons furent martyrisés, dont l'oncle du Prophète ﷺ, Hamzah bin Abdul Muttalib RA, « le Lion d'Allah ». La molaire du Prophète ﷺ y fut également brisée. À propos d'Uhud, il ﷺ dit : « C'est une montagne qui nous aime et que nous aimons. »",
    "de": "Der Ort der Schlacht von Uhud (3 n. H.). Hier wurden 70 Gefährten märtyrerhaft getötet, darunter der Onkel des Propheten ﷺ, Hamzah bin Abdul Muttalib RA, „der Löwe Allahs\". Auch der Backenzahn des Propheten ﷺ wurde hier gebrochen. Über Uhud sagte er ﷺ: „Dies ist ein Berg, der uns liebt und den wir lieben.\"",
    "es": "El escenario de la Batalla de Uhud (3 H). Aquí cayeron mártires 70 Compañeros, entre ellos el tío del Profeta ﷺ, Hamzah bin Abdul Muttalib RA, «el León de Allah». El diente molar del Profeta ﷺ también fue roto aquí. Sobre Uhud, él ﷺ dijo: «Este es un monte que nos ama y nosotros lo amamos.»",
    "ru": "Место битвы при Ухуде (3 г. х.). Здесь пали мученической смертью 70 сподвижников, в том числе дядя Пророка ﷺ — Хамза бин Абдуль-Мутталиб RA, «Лев Аллаха». Здесь же был сломан коренной зуб Пророка ﷺ. Об Ухуде он ﷺ сказал: «Это гора, которая любит нас, и мы любим её».",
    "zh": "这里是乌胡德战役（伊斯兰历3年）的战场。在此，70位圣门弟子壮烈殉道，其中包括先知ﷺ的叔父哈姆扎·本·阿卜杜勒·穆塔里卜（Hamzah bin Abdul Muttalib）RA——\"真主之狮\"。先知ﷺ的臼齿也在此战中折断。关于乌胡德，他ﷺ说：\"这座山爱我们，我们也爱它。\"",
    "ja": "ウフドの戦い（ヒジュラ暦3年）の地です。ここで70人のサハーバが殉教し、その中には預言者ﷺの叔父ハムザ・ビン・アブドゥル・ムッタリブ（Hamzah bin Abdul Muttalib）RA「アッラーの獅子」も含まれます。預言者ﷺの臼歯もここで折られました。ウフドについて彼ﷺは仰せになりました。「これは我々を愛し、我々もまたそれを愛する山である。」",
    "ko": "우후드 전투(히즈라력 3년)의 현장입니다. 이곳에서 70명의 교우가 순교하였으며, 그 중에는 예언자ﷺ의 삼촌 함자 빈 압둘 무탈리브（Hamzah bin Abdul Muttalib）RA, '알라의 사자'도 포함됩니다. 예언자ﷺ의 어금니도 이곳에서 부러졌습니다. 우후드에 대해 그분ﷺ은 말씀하셨습니다: \"이 산은 우리를 사랑하고, 우리도 이 산을 사랑한다.\"",
    "hi": "यह उहुद की जंग (हिजरी 3) का स्थल है। यहाँ 70 सहाबा शहीद हुए, जिनमें नबी ﷺ के चाचा हमज़ा बिन अब्दुल मुत्तलिब (Hamzah bin Abdul Muttalib) RA — \"अल्लाह के शेर\" — भी शामिल थे। यहाँ नबी ﷺ का दाढ़ का दाँत भी टूट गया था। उहुद के बारे में आप ﷺ ने फ़रमाया: \"यह वह पहाड़ है जो हमसे मुहब्बत करता है और हम उससे मुहब्बत करते हैं।\""
  },
  "ziyarah.madinah.baqi.name": {
    "id": "Jannatul Baqi'",
    "en": "Jannatul Baqi'",
    "ar": "جنة البقيع",
    "fr": "Jannatul Baqi'",
    "de": "Jannatul Baqi'",
    "es": "Jannatul Baqi'",
    "ru": "Джаннатуль-Баки' (Jannatul Baqi')",
    "zh": "天堂白给（Jannatul Baqi'）",
    "ja": "ジャンナトゥル・バキー（Jannatul Baqi'）",
    "ko": "잔나툴 바끼으（Jannatul Baqi'）",
    "hi": "जन्नतुल बक़ी' (Jannatul Baqi')"
  },
  "ziyarah.madinah.baqi.story": {
    "id": "Pemakaman utama Madinah, tepat di samping Masjid Nabawi. Di sini dimakamkan ribuan sahabat, para istri Nabi ﷺ (Ummahatul Mukminin), putra-putri beliau, dan Utsman bin Affan RA. Nabi ﷺ sering menziarahi dan mendoakan penghuninya.",
    "en": "The main cemetery of Madinah, located right beside Masjid Nabawi. Thousands of Companions, the wives of the Prophet ﷺ (Ummahatul Mukminin), his sons and daughters, and Utsman bin Affan RA are buried here. The Prophet ﷺ would frequently visit and supplicate for its inhabitants.",
    "ar": "مقبرة البقيع هي المقبرة الرئيسية في المدينة المنورة، تقع إلى جانب المسجد النبوي مباشرةً. دُفن فيها آلاف الصحابة وأمهات المؤمنين وأبناء النبي ﷺ وبناته، فضلاً عن عثمان بن عفان رضي الله عنه. وكان النبي ﷺ يزورها كثيراً ويدعو لأهلها.",
    "fr": "Le principal cimetière de Madinah, situé juste à côté de la Masjid Nabawi. Des milliers de Compagnons, les épouses du Prophète ﷺ (Ummahatul Mukminin), ses fils et filles, ainsi qu'Utsman bin Affan RA y sont enterrés. Le Prophète ﷺ les visitait fréquemment et suppliait pour leurs habitants.",
    "de": "Der Hauptfriedhof von Madinah, unmittelbar neben der Masjid Nabawi gelegen. Hier sind Tausende von Gefährten, die Ehefrauen des Propheten ﷺ (Ummahatul Mukminin), seine Söhne und Töchter sowie Utsman bin Affan RA begraben. Der Prophet ﷺ besuchte den Friedhof häufig und bat für seine Bewohner um Gottes Gnade.",
    "es": "El principal cementerio de Madinah, ubicado justo al lado de la Masjid Nabawi. Aquí están enterrados miles de Compañeros, las esposas del Profeta ﷺ (Ummahatul Mukminin), sus hijos e hijas, y Utsman bin Affan RA. El Profeta ﷺ solía visitarlo con frecuencia y suplicaba por sus habitantes.",
    "ru": "Главное кладбище Мадины, расположенное прямо рядом с Масджид Набави. Здесь похоронены тысячи сподвижников, жёны Пророка ﷺ (Уммахатуль Муминин), его сыновья и дочери, а также Усман бин Аффан (RA). Пророк ﷺ часто посещал это место и молился за его обитателей.",
    "zh": "麦地那的主要墓地，紧邻先知清真寺（Masjid Nabawi）。数千位圣门弟子、先知ﷺ的妻子们（Ummahatul Mukminin）、他的子女以及奥斯曼·本·阿凡（RA）均长眠于此。先知ﷺ常来此探望，并为墓中亡者祈祷。",
    "ja": "マディーナの主要な墓地で、マスジド・ナバウィのすぐ隣に位置します。ここには数千人の教友（サハーバ）、預言者ﷺの妻たち（ウンマハートゥル・ムウミニーン）、預言者の息子・娘たち、そしてウスマーン・ビン・アッファーン（RA）が埋葬されています。預言者ﷺはたびたびこの地を訪れ、亡者のために祈りを捧げました。",
    "ko": "마디나의 주요 묘지로, 마스지드 나바위 바로 옆에 위치합니다. 이곳에는 수천 명의 교우들, 예언자ﷺ의 부인들(Ummahatul Mukminin), 그의 자녀들, 그리고 우스만 빈 아판(RA)이 묻혀 있습니다. 예언자ﷺ께서는 자주 이곳을 방문하시어 묻힌 이들을 위해 기도하셨습니다.",
    "hi": "मदीना का मुख्य कब्रिस्तान, मस्जिद नबवी के ठीक बगल में स्थित है। यहाँ हज़ारों सहाबा, नबी ﷺ की पत्नियाँ (उम्महातुल मुमिनीन), उनके बेटे-बेटियाँ और उस्मान बिन अफ्फान (RA) दफ़न हैं। नबी ﷺ अक्सर यहाँ ज़ियारत के लिए आते और यहाँ के वासियों के लिए दुआ करते थे।"
  },
  "ziyarah.madinah.ghamamah.name": {
    "id": "Masjid Al-Ghamamah",
    "en": "Masjid Al-Ghamamah",
    "ar": "مسجد الغمامة",
    "fr": "Masjid Al-Ghamamah",
    "de": "Masjid Al-Ghamamah",
    "es": "Masjid Al-Ghamamah",
    "ru": "Масджид Аль-Гамама",
    "zh": "盖玛玛清真寺（Masjid Al-Ghamamah）",
    "ja": "マスジド・アル＝ガマーマ",
    "ko": "마스지드 알-가마마",
    "hi": "मस्जिद अल-ग़मामह"
  },
  "ziyarah.madinah.ghamamah.story": {
    "id": "Terletak dekat Masjid Nabawi, di tempat Nabi ﷺ pernah mengerjakan salat Id dan salat Istisqa (memohon hujan). Dinamai 'Ghamamah' (awan) karena diriwayatkan awan menaungi beliau ﷺ saat berdoa memohon hujan, lalu turunlah hujan.",
    "en": "Located near Masjid Nabawi, this is the site where the Prophet ﷺ once performed the Eid prayer and the Istisqa prayer (supplicating for rain). It is named 'Ghamamah' (cloud) because it is narrated that a cloud shaded him ﷺ while he supplicated for rain, after which rain fell.",
    "ar": "يقع هذا المسجد بالقرب من المسجد النبوي، في الموضع الذي أدّى فيه النبي ﷺ صلاة العيد وصلاة الاستسقاء. وقد سُمِّي بـ«الغمامة» لأنه رُوي أن غمامةً أظلّت النبي ﷺ حين دعا طالباً المطر، فنزل المطر بعد ذلك.",
    "fr": "Situé près de la Masjid Nabawi, c'est l'endroit où le Prophète ﷺ accomplit la prière de l'Aïd et la prière de l'Istisqa (imploration de la pluie). Il est nommé 'Ghamamah' (nuage) car il est rapporté qu'un nuage ombrageait le Prophète ﷺ lorsqu'il suppliait pour la pluie, et que la pluie tomba ensuite.",
    "de": "Diese Moschee liegt in der Nähe der Masjid Nabawi, an dem Ort, an dem der Prophet ﷺ einst das Eid-Gebet und das Istisqa-Gebet (Bittgebet um Regen) verrichtete. Sie trägt den Namen 'Ghamamah' (Wolke), da überliefert wird, dass eine Wolke den Propheten ﷺ beschattete, als er um Regen bat, woraufhin Regen fiel.",
    "es": "Ubicada cerca de la Masjid Nabawi, este es el lugar donde el Profeta ﷺ realizó en su momento la oración del Eid y la oración del Istisqa (súplica por la lluvia). Recibe el nombre de 'Ghamamah' (nube) porque se narra que una nube cubrió al Profeta ﷺ mientras suplicaba por la lluvia, tras lo cual cayó la lluvia.",
    "ru": "Расположена вблизи Масджид Набави, на месте, где Пророк ﷺ однажды совершил праздничную молитву (Ид) и молитву об испрошении дождя (Истиска). Название «Гамама» означает «облако», поскольку предание гласит, что облако осеняло Пророка ﷺ в то время, когда он молил о дожде, после чего дождь пошёл.",
    "zh": "位于麦地那的这座清真寺靠近先知清真寺（Masjid Nabawi），是先知ﷺ曾在此举行开斋节礼拜和求雨礼（Istisqa）的地方。其名\"Ghamamah\"意为\"云\"，因为据传先知ﷺ祈雨时，一片云彩遮蔽了他，随后雨水便降落了。",
    "ja": "マスジド・ナバウィの近くに位置するこのモスクは、預言者ﷺがかつてイード礼拝とイスティスカー礼拝（雨乞いの祈り）を行った場所です。「ガマーマ」（雲）と名付けられたのは、預言者ﷺが雨を求めて祈られた際に雲が彼を覆い、その後雨が降ったと伝えられているためです。",
    "ko": "마스지드 나바위 근처에 위치한 이 모스크는 예언자ﷺ께서 이드 예배와 이스티스카 예배(비를 구하는 기도)를 드리신 장소입니다. '가마마'(구름)라는 이름은, 예언자ﷺ께서 비를 간구하며 기도하실 때 구름이 그를 덮었고 이후 비가 내렸다는 전승에서 유래합니다.",
    "hi": "मस्जिद नबवी के पास स्थित इस मस्जिद में नबी ﷺ ने ईद की नमाज़ और इस्तिस्क़ा की नमाज़ (बारिश के लिए दुआ) अदा की थी। इसे 'ग़मामह' (बादल) इसलिए कहा जाता है क्योंकि रिवायत है कि जब नबी ﷺ बारिश के लिए दुआ कर रहे थे, तो एक बादल ने उन्हें छाया दी और फिर बारिश हो गई।"
  },
  "adab.tip.wudu": {
    "id": "Datang dalam keadaan suci (berwudhu) dan berpakaian sopan.",
    "en": "Come in a state of purity (with wudu) and dressed modestly.",
    "ar": "احرص على القدوم إلى المسجد في حالة طهارة (بوضوء) ولابساً لباساً محتشماً.",
    "fr": "Venez dans un état de pureté (avec le wudu) et habillé modestement.",
    "de": "Kommen Sie im Zustand der Reinheit (mit Wudu) und in bescheidener Kleidung.",
    "es": "Llega en estado de pureza (con wudu) y vestido modestamente.",
    "ru": "Приходите в состоянии ритуальной чистоты (с вуду) и в скромной одежде.",
    "zh": "请在洁净状态下（已作小净，即Wudu）前来，并穿着得体庄重。",
    "ja": "ウドゥー（清め）を行い清潔な状態で、また慎み深い服装でお越しください。",
    "ko": "정결한 상태(우두를 갖추고)로, 단정한 복장을 하여 방문하십시오.",
    "hi": "पाकी की हालत में (वुज़ू के साथ) और शालीन लिबास पहनकर आएं।"
  },
  "adab.tip.rightFoot": {
    "id": "Masuk dengan kaki kanan sambil membaca doa masuk masjid.",
    "en": "Enter with the right foot while reciting the supplication for entering the mosque.",
    "ar": "ادخل بقدمك اليمنى وأنت تقرأ دعاء دخول المسجد.",
    "fr": "Entrez avec le pied droit en récitant la supplication pour entrer dans la mosquée.",
    "de": "Betreten Sie die Moschee mit dem rechten Fuß und sprechen Sie dabei das Eintrittsgebet.",
    "es": "Entra con el pie derecho mientras recitas la súplica para entrar en la mezquita.",
    "ru": "Входите с правой ноги, читая дуа при входе в мечеть.",
    "zh": "迈右脚进入，同时诵读进入清真寺的祈祷词（入寺杜阿）。",
    "ja": "右足から入り、モスクに入る際の祈り（ドゥアー）を唱えてください。",
    "ko": "오른발로 먼저 들어서며 입사(入寺) 두아를 읽으십시오.",
    "hi": "दाहिने पाँव से अंदर जाएं और मस्जिद में दाखिल होने की दुआ पढ़ें।"
  },
  "adab.tip.tahiyat": {
    "id": "Kerjakan salat tahiyyatul masjid dua rakaat bila memungkinkan.",
    "en": "Perform the tahiyyatul masjid prayer of two rak'ahs if possible.",
    "ar": "أدِّ صلاة تحية المسجد ركعتين إن أمكن ذلك.",
    "fr": "Effectuez la prière de tahiyyatul masjid de deux rak'ahs si possible.",
    "de": "Verrichten Sie, wenn möglich, das Tahiyyatul-Masjid-Gebet mit zwei Rak'ahs.",
    "es": "Realiza la oración de tahiyyatul masjid de dos rak'ahs si es posible.",
    "ru": "По возможности совершите молитву тахиййатуль-масджид в два ракаата.",
    "zh": "如有可能，请礼两拜\"迎寺礼\"（Tahiyyatul Masjid）。",
    "ja": "可能であれば、タヒーヤトゥル・マスジド（モスク挨拶礼拝）の2ラクアを行ってください。",
    "ko": "가능하다면 타히야툴 마스지드 두 라크아 예배를 드리십시오.",
    "hi": "अगर हो सके तो तहिय्यतुल मस्जिद की दो रकअत नमाज़ अदा करें।"
  },
  "adab.tip.salamKubur": {
    "id": "Ucapkan salam kepada ahli kubur dan doakan mereka.",
    "en": "Offer greetings of peace to the people of the graves and supplicate for them.",
    "ar": "سَلِّم على أهل القبور وادعُ لهم.",
    "fr": "Adressez le salut aux gens des tombes et invoquez Allah pour eux.",
    "de": "Grüße die Bewohner der Gräber und bete für sie.",
    "es": "Ofrece el saludo de paz a los habitantes de las tumbas y suplica por ellos.",
    "ru": "Произноси приветствие обитателям могил и делай ду'а за них.",
    "zh": "向亡者致以和平的问候，并为他们祈祷。",
    "ja": "墓地の人々にサラームを送り、彼らのために祈ってください。",
    "ko": "무덤의 사람들에게 살람을 전하고 그들을 위해 두아를 드리십시오.",
    "hi": "कब्र वालों को सलाम करें और उनके लिए दुआ करें।"
  },
  "adab.tip.noSyirik": {
    "id": "Berdoa hanya kepada Allah; jangan meminta kepada penghuni kubur.",
    "en": "Supplicate to Allah alone; do not ask anything from the occupants of the graves.",
    "ar": "ادعُ الله وحده ولا تطلب من أهل القبور شيئاً.",
    "fr": "Invoquez Allah seul; ne demandez rien aux occupants des tombes.",
    "de": "Bete zu Allah allein; bitte die Bewohner der Gräber um nichts.",
    "es": "Suplica únicamente a Allah; no pidas nada a los ocupantes de las tumbas.",
    "ru": "Взывай только к Аллаху; не проси ничего у обитателей могил.",
    "zh": "只向安拉祈求；不要向墓中的人请求任何事物。",
    "ja": "アッラーのみに祈願してください；墓の中の人に何かを求めてはいけません。",
    "ko": "오직 알라께만 두아하십시오; 무덤의 주인들에게 무언가를 구하지 마십시오.",
    "hi": "केवल अल्लाह से दुआ करें; कब्र में रहने वालों से कुछ न माँगें।"
  },
  "adab.tip.ibrah": {
    "id": "Ambil pelajaran tentang kematian dan kehidupan akhirat.",
    "en": "Take lessons about death and the life of the Hereafter.",
    "ar": "خذ العِبرة من الموت والحياة الآخرة.",
    "fr": "Tirez des leçons sur la mort et la vie de l'au-delà.",
    "de": "Ziehe Lehren über den Tod und das Leben im Jenseits.",
    "es": "Toma lecciones sobre la muerte y la vida del Más Allá.",
    "ru": "Извлекай уроки о смерти и жизни в вечном мире (ахира).",
    "zh": "从死亡和后世的生命中汲取教训。",
    "ja": "死と来世の生について教訓を学んでください。",
    "ko": "죽음과 내세의 삶에 대한 교훈을 얻으십시오.",
    "hi": "मृत्यु और आखिरत की ज़िंदगी के बारे में इबरत (सबक) हासिल करें।"
  },
  "adab.tip.notWorship": {
    "id": "Tempat ini untuk mengambil ibrah, bukan tempat ibadah khusus.",
    "en": "This place is for taking ibrah, not a place of special worship.",
    "ar": "هذا المكان للاعتبار والعِبرة، وليس موضعاً للعبادة الخاصة.",
    "fr": "Ce lieu est destiné à tirer des ibrah (leçons), et non à un acte d'adoration particulier.",
    "de": "Dieser Ort dient der Ibrah (Besinnung), nicht einem besonderen Gottesdienst.",
    "es": "Este lugar es para tomar ibrah (lecciones), no para un acto de adoración especial.",
    "ru": "Это место предназначено для извлечения ибры (поучения), а не для особого поклонения.",
    "zh": "此地是用于汲取教训（ibrah），而非特定崇拜的场所。",
    "ja": "この場所はイブラ（教訓を得る）のためであり、特別な礼拝の場所ではありません。",
    "ko": "이 장소는 이브라(교훈)를 얻기 위한 곳이며, 특별한 예배 장소가 아닙니다.",
    "hi": "यह स्थान इबरत (सबक) लेने के लिए है, न कि किसी विशेष इबादत की जगह।"
  },
  "adab.tip.dhikr": {
    "id": "Perbanyak dzikir dan doa kepada Allah.",
    "en": "Increase your dhikr and supplications to Allah.",
    "ar": "أكثِر من الذِّكر والدعاء لله.",
    "fr": "Multipliez le dhikr et les invocations à Allah.",
    "de": "Vermehre deinen Dhikr und deine Bittgebete an Allah.",
    "es": "Aumenta tu dhikr y tus súplicas a Allah.",
    "ru": "Больше совершай зикр и ду'а, обращённые к Аллаху.",
    "zh": "多做迪克尔（念记）并向安拉祈祷。",
    "ja": "アッラーへのズィクルとドゥアーを多く行ってください。",
    "ko": "알라를 향한 디크르와 두아를 많이 하십시오.",
    "hi": "अल्लाह के लिए ज़िक्र और दुआ अधिक से अधिक करें।"
  },
  "adab.tip.respect": {
    "id": "Jaga kebersihan dan hormati tempat bersejarah ini.",
    "en": "Maintain cleanliness and show respect for this historic site.",
    "ar": "حافِظ على النظافة واحترِم هذا المكان التاريخي.",
    "fr": "Maintenez la propreté et respectez ce site historique.",
    "de": "Halte Sauberkeit und respektiere diese historische Stätte.",
    "es": "Mantén la limpieza y muestra respeto por este sitio histórico.",
    "ru": "Соблюдай чистоту и уважай это историческое место.",
    "zh": "保持清洁，尊重这一历史遗址。",
    "ja": "清潔を保ち、この歴史的な場所を敬ってください。",
    "ko": "청결을 유지하고 이 역사적인 장소를 존중하십시오。",
    "hi": "स्वच्छता बनाए रखें और इस ऐतिहासिक स्थान का सम्मान करें।"
  },
  "adab.site.makkah-haram": {
    "id": "Utamakan tawaf dan salat di Masjidil Haram serta jaga adab di sekitar Ka'bah.",
    "en": "Prioritize Tawaf and prayer at Masjidil Haram, and maintain proper adab around the Ka'bah.",
    "ar": "أَوْلِ الأولوية للطواف والصلاة في المسجد الحرام، وحافظ على الآداب اللازمة حول الكعبة المشرفة.",
    "fr": "Privilégiez le Tawaf et la prière à la Masjidil Haram, et respectez les bonnes conduites autour de la Ka'bah.",
    "de": "Priorisieren Sie Tawaf und das Gebet in der Masjidil Haram und wahren Sie die gebührenden Adab rund um die Ka'bah.",
    "es": "Priorice el Tawaf y la oración en la Masjidil Haram, y mantenga el adab adecuado alrededor de la Ka'bah.",
    "ru": "Уделяйте приоритет Тавафу и молитве в Масджидуль-Харам и соблюдайте подобающий адаб вокруг Каабы.",
    "zh": "优先在麦斯吉德·哈拉姆进行塔瓦夫和礼拜，并在卡尔白周围保持良好的礼仪。",
    "ja": "マスジドゥル・ハラームでのタワーフと礼拝を優先し、カアバの周辺では適切なアダブを守りましょう。",
    "ko": "마스지둘 하람에서의 타와프와 예배를 우선시하고, 카바 주변에서 적절한 아답을 지키십시오.",
    "hi": "मस्जिदुल हरम में तवाफ और नमाज़ को प्राथमिकता दें, और काबा के आसपास उचित अदब बनाए रखें।"
  },
  "adab.site.makkah-hira": {
    "id": "Kenang turunnya wahyu pertama; berdzikir tanpa memaksakan mendaki bila berisiko.",
    "en": "Reflect on the descent of the first revelation; engage in dhikr without forcing yourself to climb if it poses a risk.",
    "ar": "تذكَّر نزول الوحي الأول، وأكثِر من الذِّكر دون إرغام نفسك على الصعود إن كان فيه خطر.",
    "fr": "Méditez sur la descente de la première révélation ; pratiquez le dhikr sans vous forcer à grimper si cela présente un risque.",
    "de": "Bedenken Sie das Herabkommen der ersten Offenbarung; verrichten Sie Dhikr, ohne sich zum Aufstieg zu zwingen, falls dieser ein Risiko birgt.",
    "es": "Reflexione sobre el descenso de la primera revelación; practique el dhikr sin forzarse a subir si ello representa un riesgo.",
    "ru": "Размышляйте о ниспослании первого откровения; совершайте зикр, не принуждая себя к восхождению, если оно сопряжено с риском.",
    "zh": "铭记第一次启示降临之时；进行迪克尔，若攀登有风险则不必强行登顶。",
    "ja": "最初の啓示が降りたことを思い起こし、危険を伴う場合は無理に登らず、ズィクルに専念しましょう。",
    "ko": "최초의 계시가 내려온 것을 묵상하며, 위험이 있다면 무리하게 오르지 말고 디크르를 행하십시오。",
    "hi": "पहली वहय के अवतरण पर चिंतन करें; यदि चढ़ाई जोखिम भरी हो तो ज़बरदस्ती चढ़ने की कोशिश किए बिना ज़िक्र करें।"
  },
  "adab.site.makkah-tsur": {
    "id": "Kenang keteguhan Nabi ﷺ dan Abu Bakar saat hijrah; bertawakal kepada Allah.",
    "en": "Recall the steadfastness of the Prophet ﷺ and Abu Bakr during the Hijrah; place your trust in Allah.",
    "ar": "تذكَّر ثبات النبي ﷺ وأبي بكر الصديق رضي الله عنه أثناء الهجرة، وتوكَّل على الله.",
    "fr": "Rappelez-vous de la fermeté du Prophète ﷺ et d'Abu Bakr lors de la Hijrah ; placez votre confiance en Allah.",
    "de": "Erinnern Sie sich an die Standhaftigkeit des Propheten ﷺ und Abu Bakrs während der Hijrah; vertrauen Sie auf Allah.",
    "es": "Recuerde la firmeza del Profeta ﷺ y Abu Bakr durante la Hijrah; deposite su confianza en Allah.",
    "ru": "Вспомните стойкость Пророка ﷺ и Абу Бакра во время Хиджры; уповайте на Аллаха.",
    "zh": "铭记先知ﷺ和阿布·伯克尔在希吉拉期间的坚定；托靠于安拉。",
    "ja": "ヒジュラの際の预言者ﷺとアブー・バクルの堅固さを思い起こし、アッラーへのタワックルを持ちましょう。",
    "ko": "히즈라 당시 예언자 ﷺ와 아부 바크르의 굳건함을 기억하고, 알라께 타와쿨하십시오.",
    "hi": "हिजरत के दौरान नबी ﷺ और अबू बक्र की दृढ़ता को याद करें; अल्लाह पर तवक्कुल करें।"
  },
  "adab.site.makkah-rahmah": {
    "id": "Perbanyak doa; wukuf sah di seluruh Arafah, tidak harus di bukit ini.",
    "en": "Increase your supplications; the Wuquf is valid throughout all of Arafah, and standing on this hill specifically is not obligatory.",
    "ar": "أكثِر من الدعاء؛ والوقوف صحيح في سائر أرض عرفة، ولا يُشترط الوقوف على هذا الجبل تحديدًا.",
    "fr": "Multipliez les invocations ; le Wuquf est valide sur toute l'étendue d'Arafah, et il n'est pas obligatoire de se tenir sur cette colline en particulier.",
    "de": "Vermehren Sie Ihre Bittgebete; der Wuquf ist im gesamten Arafah gültig, und das Stehen auf diesem Hügel im Besonderen ist nicht verpflichtend.",
    "es": "Incremente sus súplicas; el Wuquf es válido en toda Arafah, y no es obligatorio estar específicamente en esta colina.",
    "ru": "Увеличьте количество дуа; Вукуф действителен на всей территории Арафа, и стоять именно на этом холме не обязательно.",
    "zh": "增加祈祷；吴古福在整个阿拉法特境内均有效，无需专门站在此山上。",
    "ja": "ドゥアーを多く行いましょう；ウクーフはアラファートの全域で有効であり、この丘に立つことは必須ではありません。",
    "ko": "두아를 많이 드리십시오; 우꾸프는 아라파 전역에서 유효하며, 이 언덕에 반드시 서야 하는 것은 아닙니다.",
    "hi": "अधिक दुआ करें; वुक़ूफ पूरे अरफ़ात में वैध है, इस पहाड़ी पर खड़े होना ज़रूरी नहीं है।"
  },
  "adab.site.makkah-mualla": {
    "id": "Ziarahi dengan tenang dan doakan Khadijah RA serta kaum muslimin.",
    "en": "Visit with tranquility and supplicate for Khadijah RA and all Muslims.",
    "ar": "زُرْه بسكينة ووقار، وادعُ لخديجة رضي الله عنها ولعموم المسلمين.",
    "fr": "Visitez avec sérénité et invoquez Allah pour Khadijah RA et pour l'ensemble des musulmans.",
    "de": "Besuchen Sie den Ort in Ruhe und Würde und beten Sie für Khadijah RA sowie für alle Muslime.",
    "es": "Visite con tranquilidad y suplique por Khadijah RA y por todos los musulmanes.",
    "ru": "Посещайте с душевным спокойствием и взывайте к Аллаху за Хадиджу РА и всех мусульман.",
    "zh": "平静地前往探访，并为海地彻（愿真主喜悦她）及全体穆斯林祈祷。",
    "ja": "静かな心で訪れ、ハディージャ（RA）と全てのムスリムのためにドゥアーを捧げましょう。",
    "ko": "평온하게 방문하여 하디자 RA와 모든 무슬림을 위해 두아를 드리십시오.",
    "hi": "शांति के साथ ज़ियारत करें और हज़रत ख़दीजा रज़ि. तथा तमाम मुसलमानों के लिए दुआ करें।"
  },
  "adab.site.makkah-tanim": {
    "id": "Ambil miqat dan niat umrah dari sini bila hendak berumrah lagi.",
    "en": "Take the Miqat and make the intention (niyyah) for Umrah from here if you wish to perform another Umrah.",
    "ar": "أَحْرِم وانوِ العمرة من هنا إن أردتَ أداء عمرة أخرى.",
    "fr": "Prenez le Miqat et formulez l'intention (niyyah) pour l'Umrah depuis cet endroit si vous souhaitez effectuer une nouvelle Umrah.",
    "de": "Nehmen Sie den Miqat ein und fassen Sie die Niyyah für die Umrah von hier, wenn Sie eine weitere Umrah verrichten möchten.",
    "es": "Tome el Miqat y establezca la intención (niyyah) para la Umrah desde aquí si desea realizar otra Umrah.",
    "ru": "Примите Микат и сделайте намерение (ниййя) на Умру отсюда, если хотите совершить ещё одну Умру.",
    "zh": "若您希望再次进行乌姆拉，请从此处进入米卡特并做出乌姆拉的意念（尼亚）。",
    "ja": "再度ウムラを行う場合は、ここでミーカートを受けてウムラの意図（ニーヤ）を立てましょう。",
    "ko": "우므라를 다시 수행하고자 한다면 이곳에서 미까트를 취하고 우므라의 니야를 하십시오.",
    "hi": "यदि आप दोबारा उमरा करना चाहते हैं तो यहाँ से मीक़ात लें और उमरा की नियत करें।"
  },
  "adab.site.madinah-nabawi": {
    "id": "Kunjungi Raudhah dan ucapkan salam kepada Nabi ﷺ dengan tenang dan tertib.",
    "en": "Visit the Raudhah and convey salutations upon the Prophet ﷺ with calmness and orderliness.",
    "ar": "زُرِ الرَّوضةَ وأَلقِ السَّلامَ على النبيِّ ﷺ بهدوءٍ وانتظامٍ.",
    "fr": "Visitez la Raudhah et transmettez les salutations au Prophète ﷺ avec calme et ordre.",
    "de": "Besuche die Raudhah und übermittle dem Propheten ﷺ Grüße mit Ruhe und Besonnenheit.",
    "es": "Visita la Raudhah y transmite los saludos al Profeta ﷺ con calma y orden.",
    "ru": "Посети Рауду и передай салам Пророку ﷺ спокойно и с соблюдением порядка.",
    "zh": "参观莱欧德哈（Raudhah），平静有序地向先知ﷺ致色俩目。",
    "ja": "ラウダを訪れ、落ち着きと秩序をもって預言者ﷺへのサラームを伝えなさい。",
    "ko": "라우다를 방문하고 차분하고 질서 있게 예언자 ﷺ께 살람을 전하십시오.",
    "hi": "Raudhah का दौरा करें और नबी ﷺ पर शांति और व्यवस्था के साथ सलाम पेश करें।"
  },
  "adab.site.madinah-quba": {
    "id": "Berwudhu dari penginapan lalu salat dua rakaat di Masjid Quba (pahala seperti umrah).",
    "en": "Perform wudu at your accommodation, then pray two rak'ahs at Masjid Quba (the reward is like that of Umrah).",
    "ar": "تَوَضَّأْ في مَقَرِّ إقامتِك ثم صَلِّ ركعتينِ في مسجدِ قُباء (ثوابُهُ كأجرِ عمرةٍ).",
    "fr": "Effectuez le wudu depuis votre hébergement, puis priez deux rak'ahs à la Mosquée Quba (la récompense est semblable à celle d'une Umrah).",
    "de": "Verrichte Wudu in deiner Unterkunft und bete dann zwei Rak'ahs in der Masjid Quba (der Lohn entspricht dem einer Umrah).",
    "es": "Realiza el wudu en tu alojamiento y luego ora dos rak'ahs en la Mezquita Quba (la recompensa es como la de una Umrah).",
    "ru": "Соверши омовение (вуду) в своём жилище, затем совершите два ракаата в Мечети Куба (награда подобна награде за Умру).",
    "zh": "在住所完成小净（Wudu），然后在库巴清真寺（Masjid Quba）礼两拜（奖赏如同副朝）。",
    "ja": "宿泊先でウドゥーを行い、マスジド・クバーで2ラクアートの礼拝を行いなさい（その報酬はウムラに等しい）。",
    "ko": "숙소에서 우두를 행하고, 마스지드 쿠바에서 두 라크아를 기도하십시오 (그 보상은 우므라와 같습니다).",
    "hi": "अपने आवास पर वुज़ू करें, फिर मस्जिद क़ुबा में दो रकअत नमाज़ पढ़ें (इसका सवाब उमरा के बराबर है)।"
  },
  "adab.site.madinah-qiblatain": {
    "id": "Renungkan peristiwa perpindahan kiblat ketika salat di sini.",
    "en": "Reflect upon the event of the change of Qiblah when praying here.",
    "ar": "تأمَّلْ في حادثةِ تحويلِ القِبلةِ حينَ تُصلِّي في هذا المكانِ.",
    "fr": "Méditez sur l'événement du changement de la Qibla lorsque vous priez ici.",
    "de": "Besinne dich beim Gebet hier auf das Ereignis der Qiblah-Wende.",
    "es": "Reflexiona sobre el evento del cambio de la Qibla cuando ores aquí.",
    "ru": "Поразмышляй о событии смены Киблы, когда совершаешь здесь молитву.",
    "zh": "在此礼拜时，默想朝向（Qiblah）改变这一历史事件。",
    "ja": "ここで礼拝する際、キブラ（礼拝方向）の転換という出来事を深く省察しなさい。",
    "ko": "이곳에서 기도할 때 키블라(예배 방향) 변경의 사건을 묵상하십시오.",
    "hi": "यहाँ नमाज़ पढ़ते समय क़िब्ले के बदलने की घटना पर गहराई से विचार करें।"
  },
  "adab.site.madinah-uhud": {
    "id": "Doakan para syuhada Uhud, terutama Hamzah bin Abdul Muthalib RA.",
    "en": "Supplicate for the martyrs of Uhud, especially Hamzah ibn Abd al-Muttalib, may Allah be pleased with him.",
    "ar": "ادعُ للشُّهداءِ في أُحُدٍ، وبالأخصِّ لحمزةَ بنِ عبدِ المطَّلبِ رضي الله عنه.",
    "fr": "Invoquez Allah pour les martyrs d'Uhud, en particulier pour Hamzah ibn Abd al-Muttalib, qu'Allah l'agrée.",
    "de": "Bitte für die Märtyrer von Uhud, besonders für Hamzah ibn Abd al-Muttalib, möge Allah mit ihm zufrieden sein.",
    "es": "Suplica por los mártires de Uhud, especialmente por Hamzah ibn Abd al-Muttalib, que Allah esté complacido con él.",
    "ru": "Делай дуа за мучеников Ухуда, особенно за Хамзу ибн Абд аль-Мутталиба, да будет доволен им Аллах.",
    "zh": "为伍侯德（Uhud）的殉道者祈祷，尤其是哈姆扎·本·阿卜杜勒·穆塔利布（愿真主喜悦他）。",
    "ja": "ウフドの殉教者たち、とりわけハムザ・イブン・アブドゥル・ムッタリブ（رضي الله عنه）のために祈りなさい。",
    "ko": "우후드의 순교자들, 특히 함자 이븐 압둘 무탈리브(رضي الله عنه)를 위해 두아를 드리십시오.",
    "hi": "उहुद के शहीदों के लिए दुआ करें, विशेष रूप से हमज़ा बिन अब्दुल मुत्तलिब रज़ियल्लाहु अन्हु के लिए।"
  },
  "adab.site.madinah-baqi": {
    "id": "Doakan para sahabat dan ahli bait Nabi ﷺ yang dimakamkan di sini.",
    "en": "Supplicate for the Companions and the members of the household of the Prophet ﷺ who are buried here.",
    "ar": "ادعُ للصَّحابةِ وأهلِ بيتِ النَّبيِّ ﷺ المدفونينَ في هذا المكانِ.",
    "fr": "Invoquez Allah pour les Compagnons et les membres de la famille du Prophète ﷺ qui sont enterrés ici.",
    "de": "Bitte für die Gefährten und die Angehörigen des Haushalts des Propheten ﷺ, die hier bestattet sind.",
    "es": "Suplica por los Compañeros y los miembros de la familia del Profeta ﷺ que están enterrados aquí.",
    "ru": "Делай дуа за сподвижников и членов семьи Пророка ﷺ, погребённых здесь.",
    "zh": "为安葬于此的圣门弟子（Sahabah）和先知ﷺ的家眷（Ahlul Bayt）祈祷。",
    "ja": "ここに埋葬されている預言者ﷺの教友（サハーバ）とアフル・バイトのために祈りなさい。",
    "ko": "이곳에 묻힌 예언자 ﷺ의 교우들(사하바)과 집안 사람들(아흘 알-바이트)을 위해 두아를 드리십시오.",
    "hi": "यहाँ दफ़न नबी ﷺ के सहाबा और अहले बैत के लिए दुआ करें।"
  },
  "adab.site.madinah-ghamamah": {
    "id": "Kenang salat Id dan salat Istisqa Nabi ﷺ di tempat ini.",
    "en": "Remember the Eid prayer and the Istisqa (rain-seeking) prayer of the Prophet ﷺ performed at this place.",
    "ar": "تذكَّرْ صلاةَ العيدِ وصلاةَ الاستسقاءِ اللَّتينِ أدَّاهما النَّبيُّ ﷺ في هذا المكانِ.",
    "fr": "Rappelez-vous la prière de l'Aïd et la prière de l'Istisqa du Prophète ﷺ accomplies en ce lieu.",
    "de": "Gedenke des Eid-Gebets und des Istisqa-Gebets des Propheten ﷺ, die an diesem Ort verrichtet wurden.",
    "es": "Recuerda la oración del Eid y la oración del Istisqa (petición de lluvia) del Profeta ﷺ realizadas en este lugar.",
    "ru": "Вспомни молитву Ид и молитву Истиска (испрашивание дождя) Пророка ﷺ, совершённые на этом месте.",
    "zh": "缅怀先知ﷺ在此地举行开斋节礼拜（Shalat Id）和求雨礼拜（Istisqa）的历史。",
    "ja": "この場所で行われた預言者ﷺのイード礼拝とイスティスカー（降雨祈願）礼拝を思い起こしなさい。",
    "ko": "이곳에서 예언자 ﷺ께서 드린 이드 예배와 이스티스까(기우제) 예배를 기억하십시오.",
    "hi": "इस स्थान पर नबी ﷺ की ईद की नमाज़ और इस्तिस्क़ा (बारिश की दुआ) की नमाज़ को याद करें।"
  },
  "adab.dua.mosque": {
    "id": "Ya Allah, bukakanlah untukku pintu-pintu rahmat-Mu. (doa masuk masjid)",
    "en": "O Allah, open for me the doors of Your mercy. (supplication upon entering the mosque)",
    "ar": "اللهم افتح لي أبواب رحمتك. (دعاء دخول المسجد)",
    "fr": "Ô Allah, ouvre-moi les portes de Ta miséricorde. (invocation pour entrer dans la mosquée)",
    "de": "O Allah, öffne mir die Tore Deiner Barmherzigkeit. (Bittgebet beim Betreten der Moschee)",
    "es": "Oh Allah, ábreme las puertas de Tu misericordia. (súplica al entrar a la mezquita)",
    "ru": "О Аллах, открой для меня врата Твоей милости. (мольба при входе в мечеть)",
    "zh": "啊，安拉，为我开启您慈悲的大门。（进入清真寺时的祈祷）",
    "ja": "ああ、アッラーよ、私のためにあなたの慈悲の扉を開いてください。（モスクに入る際の祈り）",
    "ko": "오 알라시여, 저를 위해 당신의 자비의 문을 열어 주소서. (마스지드에 들어갈 때의 두아)",
    "hi": "ऐ अल्लाह, मेरे लिए अपनी रहमत के दरवाज़े खोल दे। (मस्जिद में प्रवेश करते समय की दुआ)"
  },
  "adab.dua.cemetery": {
    "id": "Semoga keselamatan atas kalian wahai penghuni kubur dari kaum mukminin dan muslimin; insya Allah kami akan menyusul kalian.",
    "en": "Peace be upon you, O dwellers of the graves from among the believers and Muslims; if Allah wills, we shall join you.",
    "ar": "السلام عليكم أهل الديار من المؤمنين والمسلمين، وإنا إن شاء الله بكم لاحقون.",
    "fr": "Que la paix soit sur vous, ô habitants des tombes parmi les croyants et les musulmans ; si Allah le veut, nous vous rejoindrons.",
    "de": "Friede sei mit euch, ihr Bewohner der Gräber aus den Gläubigen und Muslimen; so Allah will, werden wir euch folgen.",
    "es": "La paz sea con vosotros, oh moradores de las tumbas de entre los creyentes y musulmanes; si Allah quiere, nos reuniremos con vosotros.",
    "ru": "Мир вам, о обитатели могил из числа верующих и мусульман; если пожелает Аллах, мы присоединимся к вам.",
    "zh": "愿平安降临你们，啊，信士与穆斯林们的墓中居民；若安拉意欲，我们将与你们相聚。",
    "ja": "信者とムスリムの中から、墓の住人たちよ、あなたがたに平和あれ。アッラーが御望みであれば、私たちもあなたがたに続くでしょう。",
    "ko": "믿는 자들과 무슬림들 중 무덤의 거주자들이여, 당신들에게 평화가 있기를. 알라께서 원하신다면 우리도 당신들을 따를 것입니다.",
    "hi": "तुम पर सलाम हो, ऐ मोमिनों और मुसलमानों में से कब्रों के वासियो; इन्शा अल्लाह हम भी तुमसे मिलने वाले हैं।"
  },
  "adab.dua.reflect": {
    "id": "Maha Suci Allah, segala puji bagi Allah, tiada tuhan selain Allah, dan Allah Maha Besar.",
    "en": "Glory be to Allah, all praise is for Allah, there is no god but Allah, and Allah is the Greatest.",
    "ar": "سبحان الله، والحمد لله، ولا إله إلا الله، والله أكبر.",
    "fr": "Gloire à Allah, toute louange est à Allah, il n'y a de dieu qu'Allah, et Allah est le Plus Grand.",
    "de": "Gepriesen sei Allah, aller Lobpreis gehört Allah, es gibt keinen Gott außer Allah, und Allah ist der Größte.",
    "es": "Gloria sea a Allah, toda alabanza es para Allah, no hay más dios que Allah, y Allah es el más Grande.",
    "ru": "Пречист Аллах, вся хвала Аллаху, нет бога, кроме Аллаха, и Аллах Велик.",
    "zh": "安拉至纯，一切赞美归于安拉，万物非主，唯有安拉，安拉至大。",
    "ja": "アッラーに栄光あれ、すべての称賛はアッラーのもの、アッラーの他に神はなく、アッラーは最も偉大である。",
    "ko": "알라께 영광이 있으며, 모든 찬미는 알라께 있고, 알라 외에 신은 없으며, 알라는 가장 위대하십니다.",
    "hi": "अल्लाह पाक है, सारी तारीफ़ अल्लाह के लिए है, अल्लाह के सिवा कोई माबूद नहीं, और अल्लाह सबसे बड़ा है।"
  },
  "sunnah.title": {
    "id": "Sholat Sunnah saat Umrah & Haji",
    "en": "Sunnah Prayers during Umrah & Hajj",
    "ar": "صلوات السنة في العمرة والحج",
    "fr": "Prières Sunnah lors de la 'Umrah et du Hajj",
    "de": "Sunnah-Gebete während Umrah & Hajj",
    "es": "Oraciones Sunnah durante la Umrah y el Hajj",
    "ru": "Сунна-намазы во время Умры и Хаджа",
    "zh": "副朝与朝觐期间的逊奈礼拜",
    "ja": "ウムラとハッジにおけるスンナ礼拝",
    "ko": "우므라와 하지 중의 순나 예배",
    "hi": "उमरा और हज के दौरान सुन्नत नमाज़ें"
  },
  "sunnah.subtitle": {
    "id": "Ragam salat sunnah yang dianjurkan selama berada di tanah suci beserta keutamaannya.",
    "en": "Various recommended Sunnah prayers during the stay in the Holy Land and their virtues.",
    "ar": "أنواع صلوات السنة المستحبة أثناء الإقامة في الأراضي المقدسة وفضائلها.",
    "fr": "Diverses prières sunnah recommandées durant le séjour en Terre Sainte et leurs mérites.",
    "de": "Verschiedene empfohlene Sunnah-Gebete während des Aufenthalts im Heiligen Land und ihre Vorzüge.",
    "es": "Diversas oraciones sunnah recomendadas durante la estancia en la Tierra Santa y sus virtudes.",
    "ru": "Различные рекомендуемые сунна-намазы в период пребывания на Священной земле и их достоинства.",
    "zh": "在圣地停留期间所推荐的各类逊奈礼拜及其美德。",
    "ja": "聖地滞在中に推奨されるさまざまなスンナ礼拝とその功徳。",
    "ko": "성지 체류 중 권장되는 다양한 순나 예배와 그 덕목.",
    "hi": "पवित्र भूमि पर प्रवास के दौरान अनुशंसित विभिन्न सुन्नत नमाज़ें और उनकी फ़ज़ीलतें।"
  },
  "sunnah.0.t": {
    "id": "Salat Sunnah Ihram",
    "en": "Sunnah Prayer of Ihram",
    "ar": "صلاة سنة الإحرام",
    "fr": "Prière Sunnah de l'Ihram",
    "de": "Sunnah-Gebet des Ihram",
    "es": "Oración Sunnah del Ihram",
    "ru": "Сунна-намаз Ихрама",
    "zh": "戒衣逊奈礼拜（Ihram）",
    "ja": "イフラームのスンナ礼拝",
    "ko": "이흐람의 순나 예배",
    "hi": "इहराम की सुन्नत नमाज़"
  },
  "sunnah.0.d": {
    "id": "Dua rakaat sebelum berniat ihram di miqat (menurut jumhur ulama), lalu berniat umrah/haji. Sebagian mengaitkannya dengan salat sunnah wudhu.",
    "en": "Two rak'ahs before making the intention of Ihram at the Miqat (according to the majority of scholars), then intending Umrah/Hajj. Some scholars link it to the Sunnah prayer of Wudu.",
    "ar": "ركعتان قبل نية الإحرام عند الميقات (عند جمهور العلماء)، ثم ينوي العمرة أو الحج. ويربطها بعضهم بصلاة سنة الوضوء.",
    "fr": "Deux rak'ahs avant de former l'intention de l'Ihram au Miqat (selon la majorité des savants), puis l'intention d'Umrah/Hajj. Certains la rattachent à la prière sunnah des ablutions.",
    "de": "Zwei Rak'ahs vor der Absicht des Ihram am Miqat (nach der Mehrheit der Gelehrten), dann die Absicht für Umrah/Hajj. Manche verknüpfen sie mit dem Sunnah-Gebet der Wudu.",
    "es": "Dos rak'ahs antes de hacer la intención del Ihram en el Miqat (según la mayoría de los eruditos), luego la intención de Umrah/Hajj. Algunos la relacionan con la oración sunnah de la Wudu.",
    "ru": "Два ракаата перед намерением Ихрама в Микате (по мнению большинства учёных), затем намерение Умры/Хаджа. Некоторые учёные связывают её с сунна-намазом омовения.",
    "zh": "在米卡特做出伊赫兰意图之前礼两拜（根据大多数学者的意见），然后做出副朝/正朝的意图。部分学者将其与小净后的逊奈礼拜相联系。",
    "ja": "ミーカートでイフラームの意図を行う前に2ラクアを礼拝する（多数の学者の見解によれば）、次いでウムラ/ハッジの意図を行う。一部の学者はこれをウドゥーのスンナ礼拝と結び付けている。",
    "ko": "미카트에서 이흐람 의도를 하기 전 2라카아를 예배한 후(대다수 학자의 견해에 따라) 우므라/하지 의도를 한다. 일부 학자들은 이를 우두의 순나 예배와 연결짓기도 한다.",
    "hi": "मीकात पर इहराम की नियत से पहले दो रक'अत (जुमहूर उलमा के अनुसार), फिर उमरा/हज की नियत करें। कुछ उलमा इसे वुदू की सुन्नत नमाज़ से जोड़ते हैं।"
  },
  "sunnah.1.t": {
    "id": "Salat 2 Rakaat di Belakang Maqam Ibrahim",
    "en": "2-Rak'ah Prayer Behind Maqam Ibrahim",
    "ar": "صلاة ركعتين خلف مقام إبراهيم",
    "fr": "Prière de 2 Rak'ahs derrière le Maqam Ibrahim",
    "de": "2-Rak'ah-Gebet hinter dem Maqam Ibrahim",
    "es": "Oración de 2 Rak'ahs detrás del Maqam Ibrahim",
    "ru": "Молитва в 2 ракаата позади Макам Ибрахим",
    "zh": "在麦卡姆·易卜拉欣后方礼两拜",
    "ja": "マカーム・イブラーヒームの後ろでの2ラクアの礼拝",
    "ko": "마캄 이브라힘 뒤에서 2라카아 예배",
    "hi": "मक़ाम इब्राहीम के पीछे 2 रक'अत नमाज़"
  },
  "sunnah.1.d": {
    "id": "Dikerjakan setelah selesai Tawaf, di belakang Maqam Ibrahim jika memungkinkan (atau di mana saja dalam masjid). Rakaat pertama membaca Al-Kafirun, kedua Al-Ikhlas — sesuai sunnah Nabi ﷺ.",
    "en": "Performed after completing Tawaf, behind Maqam Ibrahim if possible (or anywhere in the mosque). In the first rak'ah recite Al-Kafirun, in the second Al-Ikhlas — in accordance with the Sunnah of the Prophet ﷺ.",
    "ar": "تُؤدَّى بعد الانتهاء من الطواف، خلف مقام إبراهيم إن أمكن (أو في أي مكان من المسجد). تُقرأ في الركعة الأولى سورة الكافرون، وفي الثانية سورة الإخلاص — اتباعًا لسنة النبي ﷺ.",
    "fr": "Accomplie après la fin du Tawaf, derrière le Maqam Ibrahim si possible (ou n'importe où dans la mosquée). On récite Al-Kafirun au premier rak'ah et Al-Ikhlas au second — conformément à la Sunnah du Prophète ﷺ.",
    "de": "Verrichtet nach Abschluss des Tawaf, hinter dem Maqam Ibrahim wenn möglich (oder irgendwo in der Moschee). Im ersten Rak'ah wird Al-Kafirun rezitiert, im zweiten Al-Ikhlas — entsprechend der Sunnah des Propheten ﷺ.",
    "es": "Se realiza tras completar el Tawaf, detrás del Maqam Ibrahim si es posible (o en cualquier lugar de la mezquita). En el primer rak'ah se recita Al-Kafirun y en el segundo Al-Ikhlas — conforme a la Sunnah del Profeta ﷺ.",
    "ru": "Совершается после завершения Тавафа, позади Макам Ибрахим по возможности (или в любом месте мечети). В первом ракаате читается сура Аль-Кафирун, во втором — Аль-Ихлас, в соответствии с Сунной Пророка ﷺ.",
    "zh": "在完成塔瓦夫后进行，尽可能在麦卡姆·易卜拉欣后方（或清真寺任意位置）。第一拜诵读《卡菲隆章》，第二拜诵读《忠诚章》——遵循先知ﷺ的逊奈。",
    "ja": "タワーフ終了後にマカーム・イブラーヒームの後ろで（可能であれば、またはモスク内のどこでも）行う。第1ラクアにはアル＝カーフィルーン章、第2ラクアにはアル＝イフラース章を朗誦する——預言者ﷺのスンナに従って。",
    "ko": "타와프를 마친 후 마캄 이브라힘 뒤에서(가능한 경우, 또는 마스지드 어디서든) 행한다. 첫 번째 라카아에서 알-카피룬 장을, 두 번째에서 알-이흘라스 장을 낭송한다——선지자 ﷺ의 순나에 따라.",
    "hi": "तवाफ पूरा होने के बाद मक़ाम इब्राहीम के पीछे (यदि संभव हो, या मस्जिद में कहीं भी) अदा की जाती है। पहली रक'अत में अल-काफिरून और दूसरी में अल-इख़लास पढ़ें — नबी ﷺ की सुन्नत के अनुसार।"
  },
  "sunnah.2.t": {
    "id": "Salat di Hijr Ismail",
    "en": "Prayer in Hijr Ismail",
    "ar": "الصلاة في حِجر إسماعيل",
    "fr": "Prière dans le Hijr Ismail",
    "de": "Gebet im Hijr Ismail",
    "es": "Oración en el Hijr Ismail",
    "ru": "Намаз в Хиджр Исмаил",
    "zh": "在哈提姆（伊斯玛仪围栏）内礼拜",
    "ja": "ヒジュル・イスマーイールでの礼拝",
    "ko": "히즈르 이스마일에서의 예배",
    "hi": "हिज्र इस्माईल में नमाज़"
  },
  "sunnah.2.d": {
    "id": "Salat sunnah di dalam Hijr Ismail (Hathim) sangat utama, karena area ini termasuk bagian dari Ka'bah. Rasulullah ﷺ pernah salat di dalamnya.",
    "en": "Praying Sunnah inside Hijr Ismail (Hathim) is highly virtuous, as this area is considered part of the Ka'bah. The Messenger of Allah ﷺ once prayed inside it.",
    "ar": "الصلاة في داخل حِجر إسماعيل (الحطيم) فضلها عظيم، لأن هذه المنطقة تُعدُّ جزءًا من الكعبة المشرفة. وقد صلَّى رسول الله ﷺ بداخله.",
    "fr": "Prier la Sunnah à l'intérieur du Hijr Ismail (Hathim) est très méritoire, car cette zone est considérée comme faisant partie de la Ka'bah. Le Messager d'Allah ﷺ y a prié un jour.",
    "de": "Das Sunnah-Gebet innerhalb des Hijr Ismail (Hathim) ist besonders verdienstvoll, da dieser Bereich als Teil der Ka'bah gilt. Der Gesandte Allahs ﷺ betete einst darin.",
    "es": "Realizar la oración Sunnah dentro del Hijr Ismail (Hathim) tiene gran mérito, ya que esta zona se considera parte de la Ka'bah. El Mensajero de Allah ﷺ oró allí en cierta ocasión.",
    "ru": "Совершение сунна-намаза внутри Хиджр Исмаил (Хатим) обладает великим достоинством, поскольку эта область считается частью Каабы. Посланник Аллаха ﷺ однажды совершал намаз внутри него.",
    "zh": "在哈提姆（伊斯玛仪围栏）内礼逊奈拜具有极高的德行，因为此区域被视为天房克尔白的一部分。真主的使者ﷺ曾在其中礼拜。",
    "ja": "ヒジュル・イスマーイール（ハティーム）の内部でスンナ礼拝を行うことは非常に功徳が高い。なぜなら、この区域はカアバの一部とみなされているからである。アッラーの使徒ﷺはかつてその中で礼拝された。",
    "ko": "히즈르 이스마일(하팀) 안에서 순나 예배를 드리는 것은 매우 큰 덕목이 있으니, 이 공간은 카으바의 일부로 여겨지기 때문이다. 알라의 사도 ﷺ께서는 일찍이 그 안에서 예배를 드리셨다.",
    "hi": "हिज्र इस्माईल (हतीम) के अंदर सुन्नत नमाज़ अदा करना बहुत फ़ज़ीलत वाला है, क्योंकि यह क्षेत्र का'बा का हिस्सा माना जाता है। अल्लाह के रसूल ﷺ ने एक बार इसके अंदर नमाज़ अदा फ़रमाई थी।"
  },
  "sunnah.3.t": {
    "id": "Salat di Raudhah (Masjid Nabawi)",
    "en": "Prayer in the Raudhah (Masjid Nabawi)",
    "ar": "الصلاة في الروضة (المسجد النبوي)",
    "fr": "Prière dans la Raudhah (Masjid Nabawi)",
    "de": "Gebet in der Raudhah (Masjid Nabawi)",
    "es": "Oración en la Raudhah (Masjid Nabawi)",
    "ru": "Намаз в Рауде (Мечеть Пророка)",
    "zh": "在莱欧达（先知清真寺）礼拜",
    "ja": "ラウダ（マスジド・ナバウィー）での礼拝",
    "ko": "라우다(마스지드 나바위)에서의 예배",
    "hi": "रौज़ा (मस्जिद नबवी) में नमाज़"
  },
  "sunnah.3.d": {
    "id": "Salat sunnah di Raudhah — taman surga antara mimbar dan makam Nabi ﷺ. Sangat dianjurkan bagi yang mendapat kesempatan (dengan izin/tasrih).",
    "en": "Praying Sunnah prayer in the Raudhah — the garden of Paradise between the pulpit and the grave of the Prophet ﷺ. Highly recommended for those who have the opportunity (with a permit/tasrih).",
    "ar": "صلاة السنة في الروضة الشريفة — رياض الجنة بين المنبر وقبر النبي ﷺ. يُستحب بشدة لمن أتيحت له الفرصة (بإذن أو تصريح).",
    "fr": "Accomplir la prière sunnah dans la Raudhah — le jardin du Paradis situé entre le minbar et la tombe du Prophète ﷺ. Fortement recommandé pour ceux qui en ont l'opportunité (avec une autorisation/tasrih).",
    "de": "Das Sunnah-Gebet in der Raudhah verrichten — dem Paradiesgarten zwischen der Kanzel und dem Grab des Propheten ﷺ. Sehr empfohlen für diejenigen, die die Gelegenheit haben (mit Genehmigung/Tasrih).",
    "es": "Realizar la oración sunnah en la Raudhah — el jardín del Paraíso entre el púlpito y la tumba del Profeta ﷺ. Muy recomendable para quienes tengan la oportunidad (con permiso/tasrih).",
    "ru": "Совершение суннат-намаза в Рауде — саду Рая между минбаром и могилой Пророка ﷺ. Настоятельно рекомендуется тем, кто имеет такую возможность (при наличии разрешения/тасрих).",
    "zh": "在罗兹哈（Raudhah）——先知ﷺ讲台与墓室之间的天园花园——礼逊奈拜，强烈建议有机会者前往（须持许可证/Tasrih）。",
    "ja": "ラウダ（Raudhah）——預言者ﷺのミンバルと墓の間にある楽園の庭——でのスンナ礼拝。機会を得た方（許可証/タスリーフあり）には強く推奨されます。",
    "ko": "라우다(Raudhah) — 예언자 ﷺ의 민바르와 묘소 사이에 있는 천국의 정원 — 에서 순나 예배를 드리는 것으로, 기회가 주어진 분(허가증/타스리흐 소지자)에게 강력히 권장됩니다.",
    "hi": "रौज़ह (Raudhah) — नबी ﷺ के मिंबर और मज़ार के बीच जन्नत के बाग़ — में सुन्नत नमाज़ अदा करना। जिन्हें अवसर मिले (अनुमति/तस्रीह के साथ) उनके लिए अत्यंत अनुशंसित है।"
  },
  "sunnah.4.t": {
    "id": "Salat Sunnah di Masjid Quba",
    "en": "Sunnah Prayer at Masjid Quba",
    "ar": "صلاة السنة في مسجد قباء",
    "fr": "Prière sunnah à la Mosquée de Quba",
    "de": "Sunnah-Gebet in der Masjid Quba",
    "es": "Oración sunnah en la Mezquita de Quba",
    "ru": "Суннат-намаз в мечети Куба",
    "zh": "在库巴清真寺（Masjid Quba）礼逊奈拜",
    "ja": "マスジド・クバー（Masjid Quba）でのスンナ礼拝",
    "ko": "마스지드 쿠바(Masjid Quba)에서의 순나 예배",
    "hi": "मस्जिद क़ुबा (Masjid Quba) में सुन्नत नमाज़"
  },
  "sunnah.4.d": {
    "id": "Salat dua rakaat di Masjid Quba berpahala seperti umrah, sebagaimana sabda Nabi ﷺ. Dianjurkan bagi peziarah di Madinah.",
    "en": "Praying two rak'ahs at Masjid Quba carries a reward equivalent to that of Umrah, as stated in the hadith of the Prophet ﷺ. Recommended for visitors in Madinah.",
    "ar": "صلاة ركعتين في مسجد قباء تعدل أجر عمرة، كما جاء في حديث النبي ﷺ. يُستحب لزوار المدينة المنورة.",
    "fr": "Prier deux rak'ahs à la Mosquée de Quba équivaut en récompense à une Umrah, comme l'a déclaré le Prophète ﷺ. Recommandé aux visiteurs de Médine.",
    "de": "Zwei Rak'ahs in der Masjid Quba zu beten, bringt eine Belohnung, die einer Umrah entspricht, wie der Prophet ﷺ überliefert hat. Empfohlen für Besucher in Madinah.",
    "es": "Rezar dos rak'ahs en la Mezquita de Quba tiene una recompensa equivalente a la de una Umrah, según las palabras del Profeta ﷺ. Recomendado para los visitantes de Medina.",
    "ru": "Совершение двух рак'атов в мечети Куба равносильно по награде Умре, как сказано в хадисе Пророка ﷺ. Рекомендуется для паломников, посещающих Медину.",
    "zh": "在库巴清真寺（Masjid Quba）礼两拜，其奖赏如同一次乌姆拉，此乃先知ﷺ圣训所载。推荐在麦地那的访客前往。",
    "ja": "マスジド・クバー（Masjid Quba）での二ラク'アの礼拝は、預言者ﷺのハディースにある通り、ウムラと同等の報奨があります。マディーナを訪れる方々に推奨されます。",
    "ko": "마스지드 쿠바(Masjid Quba)에서 두 라크아(rak'ah) 예배를 드리면 예언자 ﷺ의 하디스에 따라 우므라(Umrah)에 상응하는 보상을 받습니다. 마디나 방문자에게 권장됩니다.",
    "hi": "मस्जिद क़ुबा (Masjid Quba) में दो रक्अत नमाज़ पढ़ने का सवाब उमरह के बराबर है, जैसा कि नबी ﷺ की हदीस में वर्णित है। मदीना के ज़ायरीन के लिए अनुशंसित।"
  },
  "sunnah.5.t": {
    "id": "Salat Tahiyyatul Masjid",
    "en": "Salat Tahiyyatul Masjid (Greeting Prayer of the Mosque)",
    "ar": "صلاة تحية المسجد",
    "fr": "Prière Tahiyyatul Masjid (salutation de la mosquée)",
    "de": "Salat Tahiyyatul Masjid (Begrüßungsgebet der Moschee)",
    "es": "Salat Tahiyyatul Masjid (oración de salutación de la mezquita)",
    "ru": "Намаз Тахиятуль-Масджид (приветственная молитва мечети)",
    "zh": "入寺礼拜（Salat Tahiyyatul Masjid）",
    "ja": "サラート・タヒヤトゥル・マスジド（モスクへの挨拶礼拝）",
    "ko": "살라트 타히야툴 마스지드(Salat Tahiyyatul Masjid, 사원 인사 예배)",
    "hi": "सलात तहिय्यतुल मस्जिद (मस्जिद में दाखिल होने की नमाज़)"
  },
  "sunnah.5.d": {
    "id": "Saat masuk Masjid Nabawi (atau masjid lain), dianjurkan dua rakaat. Adapun di Masjidil Haram, tahiyyatnya adalah Tawaf.",
    "en": "Upon entering Masjid Nabawi (or any other mosque), it is recommended to pray two rak'ahs. As for Masjidil Haram, its greeting is the Tawaf.",
    "ar": "عند دخول المسجد النبوي (أو أي مسجد آخر)، يُستحب صلاة ركعتين. أما في المسجد الحرام، فإن تحيته هي الطواف.",
    "fr": "En entrant dans la Mosquée du Prophète (ou toute autre mosquée), il est recommandé de prier deux rak'ahs. Quant à la Mosquée Al-Haram (Masjidil Haram), sa salutation est le Tawaf.",
    "de": "Beim Betreten der Masjid Nabawi (oder einer anderen Moschee) wird empfohlen, zwei Rak'ahs zu beten. Was die Masjidil Haram betrifft, so ist ihre Begrüßung der Tawaf.",
    "es": "Al entrar en la Mezquita del Profeta (o cualquier otra mezquita), se recomienda orar dos rak'ahs. En cuanto a la Masjidil Haram, su salutación es el Tawaf.",
    "ru": "При входе в Масджид Набави (или любую другую мечеть) рекомендуется совершить два рак'ата. Что касается Масджидуль-Харам, то его приветствием является Таваф.",
    "zh": "进入麦地那先知清真寺（Masjid Nabawi）或其他清真寺时，建议礼两拜。至于麦加禁寺（Masjidil Haram），其入寺礼拜以塔瓦夫（Tawaf）代替。",
    "ja": "マスジド・ナバウィ（Masjid Nabawi）またはその他のモスクに入る際は、二ラク'アの礼拝が推奨されます。マスジディル・ハラム（Masjidil Haram）については、その挨拶礼拝はタワーフ（Tawaf）となります。",
    "ko": "마스지드 나바위(Masjid Nabawi) 또는 다른 사원에 들어갈 때 두 라크아(rak'ah) 예배를 드리는 것이 권장됩니다. 마스지딜 하람(Masjidil Haram)의 경우, 입장 인사는 타와프(Tawaf)입니다.",
    "hi": "मस्जिद नबवी (Masjid Nabawi) या किसी अन्य मस्जिद में प्रवेश करते समय दो रक्अत नमाज़ पढ़ना मुस्तहब है। जहाँ तक मस्जिदुल हराम (Masjidil Haram) का सवाल है, वहाँ तहिय्यत तवाफ़ (Tawaf) है।"
  },
  "sunnah.6.t": {
    "id": "Salat Rawatib",
    "en": "Rawatib Sunnah Prayers",
    "ar": "الصلوات السنن الرواتب",
    "fr": "Prières sunnah rawatib",
    "de": "Rawatib Sunnah-Gebete",
    "es": "Oraciones sunnah rawatib",
    "ru": "Суннат-намазы Рауатиб",
    "zh": "逊奈拉瓦提卜礼拜（Salat Rawatib）",
    "ja": "ラワーティブ・スンナ礼拝（Salat Rawatib）",
    "ko": "라와팁 순나 예배(Salat Rawatib)",
    "hi": "रवातिब सुन्नत नमाज़ें (Salat Rawatib)"
  },
  "sunnah.6.d": {
    "id": "Salat sunnah sebelum/sesudah salat fardhu (Qabliyah & Ba'diyah) tetap dianjurkan selama di tanah suci, kecuali saat safar diringankan.",
    "en": "The Sunnah prayers before/after the obligatory prayers (Qabliyyah & Ba'diyyah) remain recommended throughout the holy land, except that they may be lightened during travel (safar).",
    "ar": "صلوات السنة القبلية والبعدية لا تزال مستحبة في الأراضي المقدسة، إلا أنها تُخفَّف في حال السفر.",
    "fr": "Les prières sunnah avant/après les prières obligatoires (Qabliyyah & Ba'diyyah) restent recommandées dans les lieux saints, sauf qu'elles peuvent être allégées durant le voyage (safar).",
    "de": "Die Sunnah-Gebete vor/nach den Pflichtgebeten (Qabliyyah & Ba'diyyah) bleiben im heiligen Land empfohlen, außer dass sie während der Reise (Safar) erleichtert werden können.",
    "es": "Las oraciones Sunnah antes/después de las oraciones obligatorias (Qabliyyah & Ba'diyyah) siguen siendo recomendadas en la tierra santa, salvo que pueden aligerarse durante el viaje (safar).",
    "ru": "Суннah-намазы до/после обязательных намазов (Кабалиййа и Ба'диййа) по-прежнему рекомендованы на святой земле, за исключением того, что они могут быть облегчены во время путешествия (сафар).",
    "zh": "在圣地期间，义务礼拜前后的逊奈礼拜（Qabliyyah与Ba'diyyah）仍被推荐，但在旅途（safar）中可予以减轻。",
    "ja": "聖地滞在中も、義務礼拝の前後に行うスンナ礼拝（カブリーヤ・バアディーヤ）は引き続き推奨されますが、旅行（サファル）中は軽減が認められます。",
    "ko": "성지에 머무는 동안에도 의무 예배 전후의 순나 예배(Qabliyyah & Ba'diyyah)는 권장되며, 다만 여행(safar) 중에는 경감될 수 있습니다.",
    "hi": "पवित्र भूमि पर रहते हुए भी अनिवार्य नमाज़ों से पहले/बाद की सुन्नत नमाज़ें (Qabliyyah & Ba'diyyah) अनुशंसित रहती हैं, सिवाय इसके कि सफ़र के दौरान इन्हें हल्का किया जा सकता है।"
  },
  "sunnah.7.t": {
    "id": "Salat Dhuha",
    "en": "Dhuha Prayer",
    "ar": "صلاة الضحى",
    "fr": "Prière Dhuha",
    "de": "Dhuha-Gebet",
    "es": "Oración Dhuha",
    "ru": "Намаз Духа",
    "zh": "杜哈礼拜（Dhuha）",
    "ja": "ドゥハー礼拝",
    "ko": "두하 예배",
    "hi": "नमाज़-ए-दुहा"
  },
  "sunnah.7.d": {
    "id": "Dikerjakan setelah matahari naik hingga menjelang zawal, 2–8 rakaat. Momen mustajab untuk memperbanyak ibadah di Masjidil Haram / Nabawi.",
    "en": "Performed after the sun has risen until just before midday (zawal), consisting of 2–8 rak'ahs. It is an auspicious moment to increase worship at Masjid al-Haram or Masjid Nabawi.",
    "ar": "تُؤدَّى بعد ارتفاع الشمس حتى قُبيل الزوال، من ركعتين إلى ثماني ركعات. وهي لحظة مباركة لاستكثار العبادة في المسجد الحرام أو المسجد النبوي.",
    "fr": "Elle se pratique après le lever du soleil jusqu'avant le zénith (zawal), de 2 à 8 rak'ahs. C'est un moment béni pour multiplier les actes d'adoration à la Mosquée al-Haram ou à la Mosquée Nabawi.",
    "de": "Sie wird nach dem Aufgang der Sonne bis kurz vor dem Zenith (Zawal) verrichtet, bestehend aus 2–8 Rak'ahs. Es ist ein gesegneter Moment, um die Anbetung in der Masjid al-Haram oder der Masjid Nabawi zu vermehren.",
    "es": "Se realiza después de que el sol ha salido hasta justo antes del mediodía (zawal), constando de 2 a 8 rak'ahs. Es un momento propicio para aumentar la adoración en la Masjid al-Haram o la Masjid Nabawi.",
    "ru": "Совершается после восхода солнца и до начала зенита (завал), от 2 до 8 ракаатов. Это благодатный момент для умножения поклонения в Масджид аль-Харам или Масджид ан-Набави.",
    "zh": "在太阳升起后至正午（zawal）之前进行，共2至8拉克尔。这是在禁寺（Masjid al-Haram）或先知清真寺（Masjid Nabawi）增加崇拜的吉祥时刻。",
    "ja": "太陽が昇った後から正午直前（ザワール）まで行い、2〜8ラクアで構成されます。マスジド・ハラームまたはマスジド・ナバウィーでの礼拝を増やす恵まれた時間です。",
    "ko": "해가 뜬 후부터 정오(zawal) 직전까지 수행하며, 2~8라크아로 구성됩니다. 마스지드 알-하람이나 마스지드 나바위에서 예배를 늘리기에 좋은 복된 시간입니다.",
    "hi": "सूर्योदय के बाद से दोपहर (zawal) से ठीक पहले तक अदा की जाती है, 2 से 8 रक्'आत। मस्जिद अल-हरम या मस्जिद नबवी में इबादत बढ़ाने का यह एक बरकतवाला मौक़ा है।"
  },
  "sunnah.8.t": {
    "id": "Qiyamullail / Tahajud & Witir",
    "en": "Qiyamullail / Tahajjud & Witr",
    "ar": "قيام الليل / التهجد والوتر",
    "fr": "Qiyamullail / Tahajjud & Witr",
    "de": "Qiyamullail / Tahajjud & Witr",
    "es": "Qiyamullail / Tahajjud & Witr",
    "ru": "Киямуллайл / Тахаджжуд и Витр",
    "zh": "夜间礼拜（Qiyamullail）/ 塔哈朱德与维特尔",
    "ja": "キヤームッライル / タハッジュドとウィトル",
    "ko": "끼얌울라일 / 타핫주드 & 위트르",
    "hi": "क़ियामुल-लैल / तहज्जुद और विर्त"
  },
  "sunnah.8.d": {
    "id": "Salat malam sangat utama, terlebih di Masjidil Haram dan Masjid Nabawi. Ditutup dengan Witir sebagai penutup salat malam.",
    "en": "The night prayer is highly virtuous, especially in Masjid al-Haram and Masjid Nabawi. It is concluded with the Witr prayer as the seal of the night prayers.",
    "ar": "صلاة الليل فضيلتها عظيمة، ولا سيما في المسجد الحرام والمسجد النبوي، وتُختم بصلاة الوتر خاتمةً لصلاة الليل.",
    "fr": "La prière de nuit est d'une grande vertu, surtout dans la Masjid al-Haram et la Masjid Nabawi. Elle se conclut par la prière Witr en tant que sceau des prières nocturnes.",
    "de": "Das Nachtgebet ist hochgradig tugendhaft, besonders in der Masjid al-Haram und der Masjid Nabawi. Es wird mit dem Witr-Gebet als Abschluss der Nachtgebete beendet.",
    "es": "La oración nocturna es muy virtuosa, especialmente en la Masjid al-Haram y la Masjid Nabawi. Se concluye con la oración Witr como sello de las oraciones nocturnas.",
    "ru": "Ночной намаз обладает великим достоинством, особенно в Масджид аль-Харам и Масджид ан-Набави. Завершается намазом Витр как печатью ночных молитв.",
    "zh": "夜间礼拜功德极大，尤其是在禁寺（Masjid al-Haram）和先知清真寺（Masjid Nabawi）。以维特尔礼拜作为夜间礼拜的封印而结束。",
    "ja": "夜の礼拝は大きな功徳があり、特にマスジド・ハラームとマスジド・ナバウィーにおいて顕著です。夜の礼拝の締めくくりとして、ウィトル礼拝で締め括られます。",
    "ko": "야간 예배는 특히 마스지드 알-하람과 마스지드 나바위에서 공덕이 매우 큽니다. 야간 예배의 마무리로 위트르 예배로 끝맺습니다.",
    "hi": "रात की नमाज़ अत्यंत पुण्यकारी है, विशेषकर मस्जिद अल-हरम और मस्जिद नबवी में। इसे रात की नमाज़ों की मुहर के रूप में विर्त नमाज़ के साथ समाप्त किया जाता है।"
  },
  "sunnah.9.t": {
    "id": "Salat Sunnah Wudhu",
    "en": "Sunnah Prayer of Wudu",
    "ar": "صلاة سنة الوضوء",
    "fr": "Prière Sunnah de l'Ablution (Wudu)",
    "de": "Sunnah-Gebet der Wudu (rituellen Waschung)",
    "es": "Oración Sunnah del Wudu",
    "ru": "Суннah-намаз после омовения (Вуду)",
    "zh": "小净后的逊奈礼拜（Wudu）",
    "ja": "ウドゥー（清めの洗い）後のスンナ礼拝",
    "ko": "우두(소정) 후의 순나 예배",
    "hi": "वुज़ू की सुन्नत नमाज़"
  },
  "sunnah.9.d": {
    "id": "Dua rakaat setelah berwudhu; keutamaannya besar dan bisa dilakukan kapan saja selama di tanah suci.",
    "en": "Two rak'ahs after performing wudu; their virtue is immense and they may be performed at any time while in the holy land.",
    "ar": "ركعتان بعد الوضوء؛ فضلهما عظيم ويمكن أداؤهما في أي وقت طوال الإقامة في الأراضي المقدسة.",
    "fr": "Deux rak'ahs après avoir fait les ablutions (wudu) ; leur mérite est immense et elles peuvent être accomplies à tout moment durant le séjour en Terre Sainte.",
    "de": "Zwei Rak'ah nach der Wudu-Waschung; ihre Vorzüglichkeit ist groß und sie können jederzeit während des Aufenthalts im Heiligen Land verrichtet werden.",
    "es": "Dos rak'ahs tras realizar el wudu; su mérito es inmenso y pueden realizarse en cualquier momento durante la estancia en la tierra santa.",
    "ru": "Два рак'ата после совершения вуду; их достоинство огромно, и их можно совершать в любое время пребывания на священной земле.",
    "zh": "在净礼（Wudu）后祈祷两个拜功（Rak'ah）；其美德极大，在圣地逗留期间可随时进行。",
    "ja": "ウドゥー（清め）の後に行う2ラク'ア；その徳は非常に大きく、聖地滞在中はいつでも行うことができます。",
    "ko": "우두(Wudu) 후 두 라크아(Rak'ah)를 드리는 예배; 그 공덕이 크며 성지 체류 중 언제든지 수행할 수 있습니다.",
    "hi": "वुज़ू (Wudu) के बाद दो रक'अत (Rak'ah) नमाज़; इसका पुण्य अत्यंत महान है और इसे पवित्र भूमि में ठहरने के दौरान किसी भी समय अदा किया जा सकता है।"
  },
  "sunnah.10.t": {
    "id": "Salat Jenazah",
    "en": "Funeral Prayer (Salat al-Janazah)",
    "ar": "صلاة الجنازة",
    "fr": "Prière funèbre (Salat al-Janazah)",
    "de": "Totengebet (Salat al-Janazah)",
    "es": "Oración fúnebre (Salat al-Janazah)",
    "ru": "Заупокойная молитва (Салят аль-Джаназа)",
    "zh": "殡礼（Salat al-Janazah）",
    "ja": "葬礼の礼拝（サラート・アル・ジャナーザ）",
    "ko": "장례 예배 (Salat al-Janazah)",
    "hi": "जनाज़े की नमाज़ (Salat al-Janazah)"
  },
  "sunnah.10.d": {
    "id": "Di Masjidil Haram dan Masjid Nabawi hampir setiap waktu fardhu ada salat jenazah. Ikut menyalatkan sangat dianjurkan karena pahalanya besar.",
    "en": "At Masjid al-Haram and Masjid Nabawi, a funeral prayer (Salat al-Janazah) is held after nearly every obligatory prayer. Joining in this prayer is highly recommended due to its immense reward.",
    "ar": "في المسجد الحرام والمسجد النبوي تُقام صلاة الجنازة بعد كل صلاة فريضة تقريباً، والمشاركة فيها مستحبة جداً لعظم أجرها.",
    "fr": "À la Mosquée al-Haram et à la Mosquée du Prophète (Masjid Nabawi), une prière funèbre (Salat al-Janazah) est célébrée après presque chaque prière obligatoire. Il est vivement recommandé d'y participer en raison de son immense récompense.",
    "de": "In der Masjid al-Haram und der Masjid Nabawi wird nach nahezu jedem Pflichtgebet ein Totengebet (Salat al-Janazah) verrichtet. Die Teilnahme daran wird dringend empfohlen, da der Lohn dafür sehr groß ist.",
    "es": "En la Masjid al-Haram y en la Masjid Nabawi se celebra una oración fúnebre (Salat al-Janazah) tras casi cada oración obligatoria. Se recomienda encarecidamente participar en ella debido a su inmensa recompensa.",
    "ru": "В Масджид аль-Харам и Масджид ан-Набави намаз по усопшему (Салят аль-Джаназа) совершается почти после каждой обязательной молитвы. Участие в нём настоятельно рекомендуется ввиду огромного вознаграждения.",
    "zh": "在禁寺（Masjid al-Haram）和先知清真寺（Masjid Nabawi），几乎每次主命礼拜后都会举行殡礼（Salat al-Janazah）。强烈建议加入参与，因其回赐极为巨大。",
    "ja": "マスジド・アル・ハラムとマスジド・ナバウィでは、ほぼすべての義務礼拝の後に葬礼の礼拝（サラート・アル・ジャナーザ）が行われます。その報奨が非常に大きいため、参加することが強く推奨されます。",
    "ko": "마스지드 알-하람(Masjid al-Haram)과 마스지드 나바위(Masjid Nabawi)에서는 거의 모든 의무 예배 후 장례 예배(Salat al-Janazah)가 거행됩니다. 그 보상이 매우 크기 때문에 참여하는 것이 강력히 권장됩니다.",
    "hi": "मस्जिद अल-हराम (Masjid al-Haram) और मस्जिद नबवी (Masjid Nabawi) में लगभग हर फ़र्ज़ नमाज़ के बाद जनाज़े की नमाज़ (Salat al-Janazah) अदा की जाती है। इसमें शामिल होना अत्यंत अनुशंसित है क्योंकि इसका अज्र बहुत बड़ा है।"
  },
  "baqi.title": {
    "id": "Makam Al-Baqi'",
    "en": "Al-Baqi' Cemetery",
    "ar": "مقبرة البقيع",
    "fr": "Cimetière Al-Baqi'",
    "de": "Friedhof Al-Baqi'",
    "es": "Cementerio Al-Baqi'",
    "ru": "Кладбище Аль-Баки'",
    "zh": "白齐伊（Al-Baqi'）墓地",
    "ja": "アル・バキー廟地（Al-Baqi'）",
    "ko": "알-바키으(Al-Baqi') 묘지",
    "hi": "अल-बक़ी' (Al-Baqi') क़ब्रिस्तान"
  },
  "baqi.subtitle": {
    "id": "Jannatul Baqi' (Baqi' al-Gharqad) — pemakaman utama Madinah, tepat di sisi tenggara Masjid Nabawi.",
    "en": "Jannatul Baqi' (Baqi' al-Gharqad) — the principal cemetery of Madinah, located immediately to the southeast of Masjid Nabawi.",
    "ar": "جنة البقيع (بقيع الغرقد) — المقبرة الرئيسية في المدينة المنورة، تقع مباشرةً إلى الجنوب الشرقي من المسجد النبوي.",
    "fr": "Jannatul Baqi' (Baqi' al-Gharqad) — le principal cimetière de Médine, situé immédiatement au sud-est de la Mosquée du Prophète (Masjid Nabawi).",
    "de": "Jannatul Baqi' (Baqi' al-Gharqad) — der bedeutendste Friedhof von Madinah, unmittelbar südöstlich der Masjid Nabawi gelegen.",
    "es": "Jannatul Baqi' (Baqi' al-Gharqad) — el principal cementerio de Medina, ubicado inmediatamente al sureste de la Masjid Nabawi.",
    "ru": "Джаннатуль-Баки' (Баки' аль-Гаркад) — главное кладбище Медины, расположенное непосредственно к юго-востоку от Масджид ан-Набави.",
    "zh": "仙园白齐伊（Jannatul Baqi'，即Baqi' al-Gharqad）——麦地那最主要的墓地，紧邻先知清真寺（Masjid Nabawi）东南侧。",
    "ja": "ジャンナトゥル・バキー（Jannatul Baqi'、バキー・アル・ガルカド）— マディーナの主要な墓地で、マスジド・ナバウィのすぐ南東に位置しています。",
    "ko": "잔나툴 바키으(Jannatul Baqi', Baqi' al-Gharqad) — 마디나의 주요 묘지로, 마스지드 나바위(Masjid Nabawi) 바로 남동쪽에 위치해 있습니다.",
    "hi": "जन्नतुल बक़ी' (Jannatul Baqi', बक़ी' अल-ग़रक़द) — मदीना का प्रमुख क़ब्रिस्तान, जो मस्जिद नबवी (Masjid Nabawi) के ठीक दक्षिण-पूर्व में स्थित है।"
  },
  "baqi.mapCaption": {
    "id": "Peta skematik: Masjid Nabawi berada tepat di sebelah barat, dan Al-Baqi' di sisi timur/tenggara. Peziarah biasanya masuk melalui gerbang di dekat area pemakaman.",
    "en": "Schematic map: Masjid Nabawi lies directly to the west, and Al-Baqi' on the eastern/southeastern side. Pilgrims usually enter through the gate near the cemetery area.",
    "ar": "خريطة تخطيطية: يقع المسجد النبوي مباشرةً إلى الغرب، وتقع مقبرة البقيع في الجهة الشرقية/الجنوبية الشرقية. يدخل الزوار عادةً من البوابة المجاورة لمنطقة المقبرة.",
    "fr": "Carte schématique : la Masjid Nabawi se trouve directement à l'ouest, et Al-Baqi' du côté est/sud-est. Les pèlerins entrent généralement par la porte située près de la zone du cimetière.",
    "de": "Schematische Karte: Die Masjid Nabawi liegt direkt im Westen und Al-Baqi' auf der östlichen/südöstlichen Seite. Pilger betreten den Friedhof in der Regel durch das Tor in der Nähe des Friedhofsbereichs.",
    "es": "Mapa esquemático: la Masjid Nabawi se encuentra directamente al oeste y Al-Baqi' en el lado este/sureste. Los peregrinos suelen entrar por la puerta cercana al área del cementerio.",
    "ru": "Схематическая карта: Масджид ан-Набави находится непосредственно к западу, а Аль-Баки' — с восточной/юго-восточной стороны. Паломники обычно входят через ворота вблизи территории кладбища.",
    "zh": "示意图：先知清真寺（Masjid Nabawi）位于正西方，Al-Baqi'位于东侧/东南侧。朝觉者通常从靠近墓地区域的大门进入。",
    "ja": "概略図：マスジド・ナバウィはちょうど西側に位置し、アル・バキーは東側・南東側にあります。巡礼者は通常、墓地エリア近くの門から入場します。",
    "ko": "개략도: 마스지드 나바위(Masjid Nabawi)는 바로 서쪽에 위치하며, 알-바키으(Al-Baqi')는 동쪽/남동쪽에 있습니다. 순례자들은 보통 묘지 구역 근처의 문을 통해 입장합니다.",
    "hi": "模式图：मस्जिद नबवी (Masjid Nabawi) ठीक पश्चिम में स्थित है, और अल-बक़ी' (Al-Baqi') पूर्व/दक्षिण-पूर्व दिशा में है। ज़ायरीन आमतौर पर क़ब्रिस्तान क्षेत्र के पास स्थित दरवाज़े से प्रवेश करते हैं।"
  },
  "baqi.svgGate": {
    "id": "Gerbang Baqi'",
    "en": "Baqi' Gate",
    "ar": "بوابة البقيع",
    "fr": "Porte du Baqi'",
    "de": "Baqi'-Tor",
    "es": "Puerta del Baqi'",
    "ru": "Ворота Баки'",
    "zh": "巴基门",
    "ja": "バキーの門",
    "ko": "바키' 문",
    "hi": "बक़ी' द्वार"
  },
  "baqi.buriedTitle": {
    "id": "Siapa yang Dimakamkan di Sana",
    "en": "Who Is Buried There",
    "ar": "من دُفن هناك",
    "fr": "Qui y est enterré",
    "de": "Wer dort begraben ist",
    "es": "Quiénes están enterrados allí",
    "ru": "Кто там похоронен",
    "zh": "谁被安葬在那里",
    "ja": "そこに埋葬されている人々",
    "ko": "그곳에 묻힌 이들",
    "hi": "वहाँ कौन दफ़न है"
  },
  "baqi.buried.0.n": {
    "id": "Utsman bin Affan RA",
    "en": "Uthman bin Affan RA",
    "ar": "عثمان بن عفان رضي الله عنه",
    "fr": "Uthman ibn Affan RA",
    "de": "Uthman bin Affan RA",
    "es": "Uthmán bin Affán RA",
    "ru": "Усман бин Аффан РА",
    "zh": "奥斯曼·本·阿凡（愿主喜悦之）",
    "ja": "ウスマーン・ビン・アッファーン（RA）",
    "ko": "우스만 빈 아판 RA",
    "hi": "उस्मान बिन अफ़्फ़ान रज़ि०"
  },
  "baqi.buried.0.d": {
    "id": "Khalifah ketiga, menantu Rasulullah ﷺ (Dzun Nurain).",
    "en": "The third Caliph, son-in-law of the Messenger of Allah ﷺ (Dhun Nurayn).",
    "ar": "الخليفة الثالث، صهر رسول الله ﷺ (ذو النورين).",
    "fr": "Le troisième calife, gendre du Messager d'Allah ﷺ (Dhun Nurayn).",
    "de": "Der dritte Kalif, Schwiegersohn des Gesandten Allahs ﷺ (Dhun Nurayn).",
    "es": "El tercer califa, yerno del Mensajero de Allah ﷺ (Dhun Nurayn).",
    "ru": "Третий халиф, зять Посланника Аллаха ﷺ (Зун-Нурайн).",
    "zh": "第三任哈里发，真主使者ﷺ的女婿（\"双光之主\"祖·努莱因）。",
    "ja": "第三代カリフ、アッラーの使徒ﷺの義息子（ズン・ヌーライン）。",
    "ko": "세 번째 칼리파이자 알라의 사도 ﷺ의 사위 (준 누라인).",
    "hi": "तीसरे खलीफा, अल्लाह के रसूल ﷺ के दामाद (ज़ुन्नूरैन)।"
  },
  "baqi.buried.1.n": {
    "id": "Ummahatul Mukminin",
    "en": "Ummahatul Mu'minin",
    "ar": "أمهات المؤمنين",
    "fr": "Ummahatul Mu'minin",
    "de": "Ummahatul Mu'minin",
    "es": "Ummahatul Mu'minin",
    "ru": "Уммахатул-Му'минин",
    "zh": "穆民之母（众信士之母）",
    "ja": "ウンマハートゥル・ムウミニーン",
    "ko": "움마하툴 무으미닌",
    "hi": "उम्महातुल मुअमिनीन"
  },
  "baqi.buried.1.d": {
    "id": "Para istri Nabi ﷺ seperti Aisyah, Hafshah, Ummu Salamah, dan lainnya.",
    "en": "The wives of the Prophet ﷺ such as Aisha, Hafsa, Umm Salamah, and others.",
    "ar": "زوجات النبي ﷺ كعائشة وحفصة وأم سلمة وغيرهن.",
    "fr": "Les épouses du Prophète ﷺ telles que Aïcha, Hafsa, Oum Salama et d'autres.",
    "de": "Die Ehefrauen des Propheten ﷺ wie Aisha, Hafsa, Umm Salamah und andere.",
    "es": "Las esposas del Profeta ﷺ como Aisha, Hafsa, Umm Salamah y otras.",
    "ru": "Жёны Пророка ﷺ, такие как Аиша, Хафса, Умм Саляма и другие.",
    "zh": "先知ﷺ的妻子们，如阿伊莎、哈芙莎、乌姆·萨拉玛等。",
    "ja": "アーイシャ、ハフサ、ウンム・サラマなど、預言者ﷺの妻たち。",
    "ko": "아이샤, 합사, 움므 살라마 등 예언자 ﷺ의 부인들.",
    "hi": "नबी ﷺ की पत्नियाँ जैसे आइशा, हफ़सा, उम्मे सलमा और अन्य।"
  },
  "baqi.buried.2.n": {
    "id": "Putra-putri Nabi ﷺ",
    "en": "Children of the Prophet ﷺ",
    "ar": "أبناء وبنات النبي ﷺ",
    "fr": "Enfants du Prophète ﷺ",
    "de": "Kinder des Propheten ﷺ",
    "es": "Hijos e hijas del Profeta ﷺ",
    "ru": "Дети Пророка ﷺ",
    "zh": "先知ﷺ的子女",
    "ja": "預言者ﷺの子どもたち",
    "ko": "예언자 ﷺ의 자녀들",
    "hi": "नबी ﷺ के पुत्र-पुत्रियाँ"
  },
  "baqi.buried.2.d": {
    "id": "Ibrahim (putra beliau), serta putri-putri beliau termasuk Ruqayyah, Ummu Kultsum, dan Zainab RA.",
    "en": "Ibrahim (his son), and his daughters including Ruqayyah, Ummu Kultsum, and Zainab RA.",
    "ar": "إبراهيم (ابنه)، وبناته منهن رقية، وأم كلثوم، وزينب رضي الله عنهن.",
    "fr": "Ibrahim (son fils), et ses filles dont Ruqayyah, Ummu Kultsum et Zainab RA.",
    "de": "Ibrahim (sein Sohn) sowie seine Töchter, darunter Ruqayyah, Ummu Kultsum und Zainab RA.",
    "es": "Ibrahim (su hijo), y sus hijas incluyendo Ruqayyah, Ummu Kultsum y Zainab RA.",
    "ru": "Ибрахим (его сын), а также его дочери, в том числе Рукайя, Умму Кульсум и Зайнаб RA.",
    "zh": "易卜拉欣（他的儿子），以及他的女儿们，包括鲁盖叶、乌姆·库勒苏姆和宰纳布（愿真主喜悦她们）。",
    "ja": "イブラーヒーム（息子）、およびルカイヤ、ウンム・クルスーム、ザイナブ RA を含む娘たち。",
    "ko": "이브라힘(그의 아들)과 루카이야, 움무 쿨숨, 자이납 RA를 포함한 그의 딸들.",
    "hi": "इब्राहीम (उनके पुत्र), तथा उनकी पुत्रियाँ जिनमें रुक़य्या, उम्मु कुलसूम और ज़ैनब RA शामिल हैं।"
  },
  "baqi.buried.3.n": {
    "id": "Hasan bin Ali RA",
    "en": "Hasan bin Ali RA",
    "ar": "الحسن بن علي رضي الله عنه",
    "fr": "Hasan bin Ali RA",
    "de": "Hasan bin Ali RA",
    "es": "Hasan bin Ali RA",
    "ru": "Хасан бин Али RA",
    "zh": "哈桑·本·阿里（愿真主喜悦他）",
    "ja": "ハサン・ビン・アリー RA",
    "ko": "하산 빈 알리 RA",
    "hi": "हसन बिन अली RA"
  },
  "baqi.buried.3.d": {
    "id": "Cucu kesayangan Rasulullah ﷺ, pemimpin pemuda ahli surga.",
    "en": "The beloved grandson of the Messenger of Allah ﷺ, the leader of the youth of Paradise.",
    "ar": "حفيد رسول الله ﷺ الحبيب، سيد شباب أهل الجنة.",
    "fr": "Le petit-fils bien-aimé du Messager d'Allah ﷺ, le maître des jeunes du Paradis.",
    "de": "Der geliebte Enkel des Gesandten Allahs ﷺ, der Anführer der Jugend des Paradieses.",
    "es": "El amado nieto del Mensajero de Allah ﷺ, el líder de los jóvenes del Paraíso.",
    "ru": "Любимый внук Посланника Аллаха ﷺ, предводитель молодёжи Рая.",
    "zh": "真主使者ﷺ最钟爱的孙子，天园青年之领袖。",
    "ja": "アッラーの使徒ﷺの最愛の孫、楽園の若者たちの長。",
    "ko": "알라의 사도 ﷺ의 사랑받는 손자이자 천국 청년들의 지도자.",
    "hi": "अल्लाह के रसूल ﷺ के प्रिय पोते, जन्नत के युवाओं के नेता।"
  },
  "baqi.buried.4.n": {
    "id": "Abbas bin Abdul Muthalib RA",
    "en": "Abbas bin Abdul Muttalib RA",
    "ar": "العباس بن عبد المطلب رضي الله عنه",
    "fr": "Abbas bin Abdul Muttalib RA",
    "de": "Abbas bin Abdul Muttalib RA",
    "es": "Abbas bin Abdul Muttalib RA",
    "ru": "Аббас бин Абдул-Мутталиб RA",
    "zh": "阿巴斯·本·阿卜杜勒·穆塔里布（愿真主喜悦他）",
    "ja": "アッバース・ビン・アブドゥル・ムッタリブ RA",
    "ko": "압바스 빈 압둘 무탈리브 RA",
    "hi": "अब्बास बिन अब्दुल मुत्तलिब RA"
  },
  "baqi.buried.4.d": {
    "id": "Paman Nabi ﷺ.",
    "en": "The uncle of the Prophet ﷺ.",
    "ar": "عم النبي ﷺ.",
    "fr": "L'oncle du Prophète ﷺ.",
    "de": "Der Onkel des Propheten ﷺ.",
    "es": "El tío del Profeta ﷺ.",
    "ru": "Дядя Пророка ﷺ.",
    "zh": "先知ﷺ的叔父。",
    "ja": "預言者ﷺの叔父。",
    "ko": "예언자 ﷺ의 삼촌.",
    "hi": "नबी ﷺ के चाचा।"
  },
  "baqi.buried.5.n": {
    "id": "Shafiyyah binti Abdul Muthalib RA",
    "en": "Shafiyyah bint Abdul Muttalib RA",
    "ar": "صفية بنت عبد المطلب رضي الله عنها",
    "fr": "Shafiyyah bint Abdul Muttalib RA",
    "de": "Shafiyyah bint Abdul Muttalib RA",
    "es": "Shafiyyah bint Abdul Muttalib RA",
    "ru": "Сафиййа бинт Абдул-Мутталиб РА",
    "zh": "沙菲叶·宾特·阿卜杜勒-穆塔利卜（愿主喜悦她）",
    "ja": "シャフィーヤ・ビント・アブドゥル・ムッタリブ（RA）",
    "ko": "샤피야 빈트 압둘 무탈리브 RA",
    "hi": "शफ़ीयया बिन्त अब्दुल मुत्तलिब रज़ियल्लाहु अन्हा"
  },
  "baqi.buried.5.d": {
    "id": "Bibi Nabi ﷺ, ibunda Zubair bin Awwam.",
    "en": "Aunt of the Prophet ﷺ, and the mother of Zubayr ibn al-Awwam.",
    "ar": "عمة النبي ﷺ، وأم الزبير بن العوام.",
    "fr": "Tante du Prophète ﷺ et mère de Zubayr ibn al-Awwam.",
    "de": "Tante des Propheten ﷺ und Mutter von Zubayr ibn al-Awwam.",
    "es": "Tía del Profeta ﷺ y madre de Zubayr ibn al-Awwam.",
    "ru": "Тётя Пророка ﷺ, мать Зубайра ибн аль-Аввама.",
    "zh": "先知ﷺ的姑母，祖拜尔·本·阿瓦姆的母亲。",
    "ja": "預言者ﷺの叔母であり、ズバイル・イブン・アッワームの母。",
    "ko": "예언자 ﷺ의 고모이자 주바이르 이븐 알-아왐의 어머니.",
    "hi": "नबी ﷺ की चाची और ज़ुबैर बिन अव्वाम की माँ।"
  },
  "baqi.buried.6.n": {
    "id": "Ribuan Sahabat & Tabi'in",
    "en": "Thousands of Companions & Tabi'in",
    "ar": "آلاف الصحابة والتابعين",
    "fr": "Des milliers de Compagnons & Tabi'in",
    "de": "Tausende von Gefährten & Tabi'in",
    "es": "Miles de Compañeros & Tabi'in",
    "ru": "Тысячи сподвижников и таби'ин",
    "zh": "数千名圣门弟子与塔比欧因",
    "ja": "数千人のサハーバとターヒウーン",
    "ko": "수천 명의 사하바와 타비인",
    "hi": "हज़ारों सहाबा और ताबिईन"
  },
  "baqi.buried.6.d": {
    "id": "Diperkirakan lebih dari 10.000 sahabat dimakamkan di Baqi', termasuk Imam Malik bin Anas.",
    "en": "It is estimated that more than 10,000 Companions are buried in Baqi', including Imam Malik ibn Anas.",
    "ar": "يُقدَّر أن أكثر من ١٠٫٠٠٠ صحابي مدفون في البقيع، من بينهم الإمام مالك بن أنس.",
    "fr": "On estime que plus de 10 000 Compagnons sont enterrés à Baqi', dont l'Imam Malik ibn Anas.",
    "de": "Es wird geschätzt, dass mehr als 10.000 Gefährten in Baqi' begraben sind, darunter Imam Malik ibn Anas.",
    "es": "Se estima que más de 10.000 Compañeros están enterrados en Baqi', incluido el Imam Malik ibn Anas.",
    "ru": "По оценкам, в Баки' погребено более 10 000 сподвижников, в том числе имам Малик ибн Анас.",
    "zh": "据估计，超过一万名圣门弟子长眠于扎纳图·巴齐，其中包括伊玛目马利克·本·阿纳斯。",
    "ja": "バキーには推定1万人以上のサハーバが埋葬されており、イマーム・マーリク・イブン・アナスもその一人です。",
    "ko": "자나툴 바키에는 이맘 말리크 이븐 아나스를 포함하여 1만 명 이상의 사하바가 묻혀 있는 것으로 추정됩니다.",
    "hi": "अनुमान है कि बक़ी' में 10,000 से अधिक सहाबा दफ़न हैं, जिनमें इमाम मालिक बिन अनस भी शामिल हैं।"
  },
  "baqi.doaTitle": {
    "id": "Doa yang Dianjurkan",
    "en": "Recommended Supplication",
    "ar": "الدعاء المستحب",
    "fr": "Invocation Recommandée",
    "de": "Empfohlenes Gebet",
    "es": "Súplica Recomendada",
    "ru": "Рекомендуемая мольба",
    "zh": "推荐的祈祷",
    "ja": "推奨される祈り",
    "ko": "권장 두아",
    "hi": "अनुशंसित दुआ"
  },
  "baqi.doa.0.text": {
    "id": "Salam sejahtera atas kalian, wahai penghuni kubur dari kalangan mukminin dan muslimin. Insya Allah kami akan menyusul kalian. Kami memohon kepada Allah keselamatan bagi kami dan kalian. (Salam ziarah yang diajarkan Rasulullah ﷺ)",
    "en": "Peace be upon you, O dwellers of the graves from among the believers and Muslims. Indeed, if Allah wills, we will join you. We ask Allah for wellbeing for us and for you. (The greeting of visiting graves taught by the Messenger of Allah ﷺ)",
    "ar": "السلام عليكم يا أهل القبور من المؤمنين والمسلمين، وإنا إن شاء الله بكم لاحقون، نسأل الله لنا ولكم العافية. (تحية زيارة القبور التي علّمها رسول الله ﷺ)",
    "fr": "Que la paix soit sur vous, ô habitants des tombes parmi les croyants et les musulmans. Si Allah le veut, nous vous rejoindrons. Nous demandons à Allah le salut pour nous et pour vous. (Le salut lors de la visite des tombes tel qu'enseigné par le Messager d'Allah ﷺ)",
    "de": "Friede sei mit euch, ihr Bewohner der Gräber unter den Gläubigen und Muslimen. Wenn Allah es will, werden wir euch folgen. Wir bitten Allah um Wohlergehen für uns und für euch. (Der Gruß beim Gräberbesuch, gelehrt vom Gesandten Allahs ﷺ)",
    "es": "La paz sea con vosotros, oh moradores de las tumbas entre los creyentes y musulmanes. Si Allah quiere, nos reuniremos con vosotros. Pedimos a Allah bienestar para nosotros y para vosotros. (El saludo al visitar las tumbas enseñado por el Mensajero de Allah ﷺ)",
    "ru": "Мир вам, о обитатели могил из числа верующих и мусульман. Поистине, если пожелает Аллах, мы присоединимся к вам. Мы просим Аллаха о благополучии для нас и для вас. (Приветствие при посещении могил, которому обучил Посланник Аллаха ﷺ)",
    "zh": "愿平安降临于你们，墓中的信士与穆斯林们。如果真主意欲，我们必将与你们相聚。我们祈求真主赐予我们和你们平安。（这是真主的使者ﷺ所教导的探墓问候语）",
    "ja": "あなたがたに平和がありますように、信者・イスラム教徒の中の墓の住人たちよ。アッラーが御望みであれば、私たちもあなたがたの後に続くでしょう。私たちはアッラーに、私たちとあなたがたのための平安を願います。（アッラーの使徒ﷺが教えられた墓参りの挨拶）",
    "ko": "평화가 당신들에게 있기를, 무덤에 잠든 믿는 자들과 무슬림들이여. 알라께서 뜻하신다면, 우리도 당신들의 뒤를 따를 것입니다. 우리는 우리와 당신들을 위해 알라께 평안을 구합니다. (알라의 사도 ﷺ께서 가르치신 묘지 방문 인사)",
    "hi": "तुम पर सलामती हो, ऐ मोमिनों और मुसलमानों में से क़ब्र वालो। इंशाअल्लाह हम भी तुमसे मिलने वाले हैं। हम अल्लाह से अपने लिए और तुम्हारे लिए आफ़ियत मांगते हैं। (यह क़ब्रों की ज़ियारत का वह सलाम है जो रसूलुल्लाह ﷺ ने सिखाया)"
  },
  "baqi.doa.1.text": {
    "id": "Ya Allah, ampunilah para penghuni Baqi' al-Gharqad. (Doa Nabi ﷺ ketika menziarahi Baqi')",
    "en": "O Allah, forgive the inhabitants of Baqi' al-Gharqad. (The supplication of the Prophet ﷺ when visiting Baqi')",
    "ar": "اللهم اغفر لأهل البقيع الغرقد. (دعاء النبي ﷺ عند زيارة البقيع)",
    "fr": "Ô Allah, pardonne aux habitants de Baqi' al-Gharqad. (La supplication du Prophète ﷺ lors de la visite de Baqi')",
    "de": "O Allah, vergib den Bewohnern von Baqi' al-Gharqad. (Das Gebet des Propheten ﷺ beim Besuchen von Baqi')",
    "es": "Oh Allah, perdona a los habitantes de Baqi' al-Gharqad. (La súplica del Profeta ﷺ al visitar Baqi')",
    "ru": "О Аллах, прости обитателей Баки' аль-Гаркад. (Ду'а Пророка ﷺ при посещении Баки')",
    "zh": "求真主啊，饶恕白格尔·古尔格德（Baqi' al-Gharqad）的居民。（先知ﷺ探访白格尔时的祈祷）",
    "ja": "ああアッラーよ、バキー・アル=ガルカドの住人をお赦しください。（バキーを訪問した際の預言者ﷺの祈り）",
    "ko": "오 알라여, 바키' 알-가르카드의 주민들을 용서하소서. (바키'를 방문할 때 예언자 ﷺ의 두아)",
    "hi": "ऐ अल्लाह, बक़ी' अल-ग़र्क़द के निवासियों को माफ़ फ़रमा। (बक़ी' की ज़ियारत के समय नबी ﷺ की दुआ)"
  },
  "baqi.doa.2.text": {
    "id": "Ya Allah, ampunilah mereka, rahmatilah, selamatkan, dan maafkanlah mereka.",
    "en": "O Allah, forgive them, have mercy on them, grant them safety, and pardon them.",
    "ar": "اللهم اغفر لهم وارحمهم وعافهم واعف عنهم.",
    "fr": "Ô Allah, pardonne-leur, aie pitié d'eux, accorde-leur le salut et pardonne-leur.",
    "de": "O Allah, vergib ihnen, erbarme Dich ihrer, gewähre ihnen Wohlergehen und vergib ihnen.",
    "es": "Oh Allah, perdónalos, ten misericordia de ellos, concédeles bienestar y absuelve sus faltas.",
    "ru": "О Аллах, прости их, помилуй их, даруй им благополучие и прости им их прегрешения.",
    "zh": "求真主啊，饶恕他们，怜悯他们，赐他们平安，宽恕他们。",
    "ja": "ああアッラーよ、彼らをお赦しください、彼らをお慈しみください、彼らにご加護を与え、彼らをお許しください。",
    "ko": "오 알라여, 그들을 용서하시고, 그들에게 자비를 베푸시고, 그들을 보호하시고, 그들의 죄를 사하여 주소서.",
    "hi": "ऐ अल्लाह, उन्हें माफ़ कर, उन पर रहम कर, उन्हें सलामती दे और उन्हें मुआफ़ फ़रमा।"
  },
  "baqi.larTitle": {
    "id": "Larangan yang Harus Dihindari",
    "en": "Prohibitions to Be Avoided",
    "ar": "المحظورات الواجب اجتنابها",
    "fr": "Interdictions à Éviter",
    "de": "Zu vermeidende Verbote",
    "es": "Prohibiciones que Deben Evitarse",
    "ru": "Запреты, которых следует избегать",
    "zh": "必须避免的禁止事项",
    "ja": "避けるべき禁止事項",
    "ko": "반드시 피해야 할 금지 사항",
    "hi": "जिन निषेधों से बचना आवश्यक है"
  },
  "baqi.lar.0": {
    "id": "Berdoa atau meminta kepada penghuni kubur (mayit); doa hanya ditujukan kepada Allah semata.",
    "en": "Supplicating to or asking the occupants of graves (the deceased) for anything; supplication (du'a) is directed to Allah alone.",
    "ar": "الدعاء أو طلب الحاجات من أصحاب القبور (الأموات)؛ فالدعاء يُوجَّه إلى الله وحده.",
    "fr": "Supplier ou demander quoi que ce soit aux occupants des tombes (les défunts) ; la supplication (du'a) est adressée à Allah seul.",
    "de": "Das Bittgebet an oder das Ersuchen von Grabinhabern (Verstorbenen); das Bittgebet (Du'a) ist allein an Allah zu richten.",
    "es": "Suplicar o pedir algo a los ocupantes de las tumbas (los difuntos); la súplica (du'a) se dirige únicamente a Allah.",
    "ru": "Совершение ду'а или обращение с просьбами к обитателям могил (умершим); ду'а обращается исключительно к Аллаху.",
    "zh": "向墓穴中的亡者祈祷或求取任何事物；祈祷（du'a）只应向真主提出。",
    "ja": "墓の住人（故人）に祈ったり何かを求めること；ドゥアー（祈願）はアッラーのみに向けられるべきである。",
    "ko": "무덤의 주인(망자)에게 기도하거나 무언가를 요청하는 것; 두아(기도)는 오직 알라께만 드려야 한다.",
    "hi": "क़ब्र के निवासियों (मृतकों) से दुआ माँगना या कुछ माँगना; दुआ केवल अल्लाह से ही की जाती है।"
  },
  "baqi.lar.1": {
    "id": "Beristighatsah / memohon pertolongan, keberkahan, atau hajat kepada orang yang telah wafat.",
    "en": "Performing istighasah — seeking help, blessings, or the fulfillment of needs from those who have passed away.",
    "ar": "الاستغاثة بالأموات أو طلب العون والبركة وقضاء الحاجات منهم.",
    "fr": "Pratiquer l'istighasah — chercher de l'aide, des bénédictions ou la satisfaction de ses besoins auprès des défunts.",
    "de": "Das Praktizieren von Istighasah — das Ersuchen um Hilfe, Segen oder die Erfüllung von Bedürfnissen bei Verstorbenen.",
    "es": "Practicar la istighasah — buscar ayuda, bendiciones o la satisfacción de necesidades de los fallecidos.",
    "ru": "Совершение истигасы — обращение за помощью, благодатью или исполнением нужд к умершим.",
    "zh": "行使求援（Istighasah）——向已故之人寻求帮助、祝福或满足需求。",
    "ja": "イスティガーサを行うこと——亡くなった人に助け、祝福、または必要の充足を求めること。",
    "ko": "이스티가사를 행하는 것 — 세상을 떠난 자들에게 도움, 축복, 또는 필요의 충족을 구하는 것.",
    "hi": "इस्तिग़ासा करना — वफ़ात-याफ्ता लोगों से मदद, बरकत या हाजत पूरी करने की माँग करना।"
  },
  "baqi.lar.2": {
    "id": "Thawaf (mengelilingi) makam, mengusap-usap, atau mencium kubur untuk ngalap berkah.",
    "en": "Performing Tawaf (circumambulating) around graves, wiping or kissing graves to seek blessings (tabarruk).",
    "ar": "الطواف حول القبور، أو مسحها أو تقبيلها طلبًا للتبرك.",
    "fr": "Effectuer le Tawaf (circumambulation) autour des tombes, les frotter ou les embrasser pour en obtenir des bénédictions (tabarruk).",
    "de": "Das Durchführen von Tawaf (Umrunden) um Gräber, das Reiben oder Küssen von Gräbern zur Segenssuche (Tabarruk).",
    "es": "Realizar el Tawaf (circunambulación) alrededor de las tumbas, frotar o besar las tumbas para obtener bendiciones (tabarruk).",
    "ru": "Совершение Тавафа (обхода) вокруг могил, поглаживание или целование могил с целью получения благодати (табаррук).",
    "zh": "围绕坟墓行塔瓦夫（Tawaf，绕行），抚摸或亲吻坟墓以求取祝福（Tabarruk）。",
    "ja": "墓の周りをタワーフ（周回）すること、祝福（タバッルク）を求めて墓を撫でたり口づけしたりすること。",
    "ko": "무덤 주위를 타와프(Tawaf, 순회)하거나, 축복(타바룩)을 구하기 위해 무덤을 쓰다듬거나 입 맞추는 것.",
    "hi": "क़ब्रों के चारों ओर तवाफ़ (परिक्रमा) करना, बरकत (तबर्रुक) के लिए क़ब्रों को छूना या चूमना।"
  },
  "baqi.lar.3": {
    "id": "Menjadikan kubur sebagai tempat salat atau sujud ke arahnya.",
    "en": "Making graves a place of prayer or prostrating towards them.",
    "ar": "اتخاذ القبور مساجد أو السجود نحوها.",
    "fr": "Faire des tombes un lieu de prière ou se prosterner vers elles.",
    "de": "Gräber zu Gebetsorten zu machen oder sich in ihre Richtung niederzuwerfen.",
    "es": "Hacer de las tumbas un lugar de oración o postrarse hacia ellas.",
    "ru": "Превращать могилы в места намаза или совершать земной поклон в их сторону.",
    "zh": "将坟墓作为礼拜之地或朝向坟墓叩拜。",
    "ja": "墓を礼拝の場所にしたり、墓に向かってスジュードしたりすること。",
    "ko": "무덤을 예배 장소로 삼거나 무덤을 향해 절하는 것.",
    "hi": "क़ब्रों को नमाज़ की जगह बनाना या उनकी तरफ़ सजदा करना।"
  },
  "baqi.lar.4": {
    "id": "Duduk di atas kubur, menginjak, atau berjalan di antara kubur tanpa adab.",
    "en": "Sitting on graves, stepping on them, or walking among them without proper etiquette.",
    "ar": "الجلوس على القبور أو الوطء عليها أو المشي بينها بلا أدب.",
    "fr": "S'asseoir sur les tombes, marcher dessus ou entre elles sans respect.",
    "de": "Auf Gräbern sitzen, sie betreten oder ohne Respekt zwischen ihnen gehen.",
    "es": "Sentarse sobre las tumbas, pisarlas o caminar entre ellas sin el debido respeto.",
    "ru": "Сидеть на могилах, наступать на них или ходить между ними без должного уважения.",
    "zh": "坐在坟墓上、踩踏坟墓或在坟墓之间行走时缺乏礼仪。",
    "ja": "墓の上に座ったり、踏んだり、作法なく墓の間を歩いたりすること。",
    "ko": "무덤 위에 앉거나, 밟거나, 예의 없이 무덤 사이를 걷는 것.",
    "hi": "क़ब्रों पर बैठना, उन्हें रौंदना, या बिना अदब के क़ब्रों के बीच चलना।"
  },
  "baqi.lar.5": {
    "id": "Menyembelih hewan atau bernazar di kuburan.",
    "en": "Slaughtering animals or making vows at graves.",
    "ar": "ذبح الحيوانات أو النذر عند القبور.",
    "fr": "Égorger des animaux ou faire des vœux aux tombes.",
    "de": "Tiere an Gräbern zu schlachten oder Gelübde an Gräbern abzulegen.",
    "es": "Sacrificar animales o hacer votos en las tumbas.",
    "ru": "Закалывать животных или давать обеты у могил.",
    "zh": "在坟墓旁宰杀牲畜或许愿。",
    "ja": "墓で動物を屠殺したり、誓願を立てたりすること。",
    "ko": "무덤에서 동물을 도살하거나 서원을 하는 것.",
    "hi": "क़ब्रों पर जानवर ज़बह करना या मन्नत माँगना।"
  },
  "baqi.lar.6": {
    "id": "Meratapi (niyahah), menangis histeris, atau berbuat gaduh.",
    "en": "Wailing (niyahah), crying hysterically, or causing uproar.",
    "ar": "النياحة والبكاء الهستيري أو إحداث الضوضاء والصخب.",
    "fr": "Se lamenter (niyahah), pleurer hystériquement ou causer du vacarme.",
    "de": "Klagen (Niyahah), hysterisches Weinen oder Lärm verursachen.",
    "es": "Lamentarse (niyahah), llorar histéricamente o causar alboroto.",
    "ru": "Голосить (ниях), рыдать в истерике или поднимать шум.",
    "zh": "嚎啕大哭（niyahah）、歇斯底里地哭泣或喧哗吵闹。",
    "ja": "嘆き泣き（ニヤーハ）、ヒステリックな号泣、または騒ぎを起こすこと。",
    "ko": "통곡(niyahah), 히스테리성 울음, 또는 소란을 피우는 것.",
    "hi": "नियाहा (विलाप), हिस्टेरिकल रोना, या शोर-गुल मचाना।"
  },
  "baqi.lar.7": {
    "id": "Membangun, mengecat, atau menghias kubur secara berlebihan.",
    "en": "Building, painting, or excessively decorating graves.",
    "ar": "البناء على القبور أو تجصيصها أو زخرفتها بشكل مبالغ فيه.",
    "fr": "Construire, peindre ou décorer excessivement les tombes.",
    "de": "Gräber zu bauen, zu streichen oder übermäßig zu schmücken.",
    "es": "Construir, pintar o decorar excesivamente las tumbas.",
    "ru": "Возводить постройки на могилах, красить их или чрезмерно украшать.",
    "zh": "在坟墓上建造、涂漆或过度装饰。",
    "ja": "墓を建設したり、塗装したり、過度に装飾したりすること。",
    "ko": "무덤을 건축하거나 페인트칠하거나 과도하게 장식하는 것.",
    "hi": "क़ब्रों पर निर्माण करना, रंग-पोत करना, या अत्यधिक सजावट करना।"
  },
  "nabawi.title": {
    "id": "Peta Masjid Nabawi",
    "en": "Map of Masjid an-Nabawi",
    "ar": "خريطة المسجد النبوي",
    "fr": "Plan de la Mosquée du Prophète (Masjid Nabawi)",
    "de": "Karte der Prophetenmoschee (Masjid Nabawi)",
    "es": "Mapa de la Mezquita del Profeta (Masjid Nabawi)",
    "ru": "Карта Мечети Пророка (Масджид ан-Набави)",
    "zh": "先知清真寺（Masjid Nabawi）地图",
    "ja": "預言者モスク（マスジド・ナバウィ）の地図",
    "ko": "예언자 모스크(Masjid Nabawi) 지도",
    "hi": "मस्जिद नबवी का नक्शा"
  },
  "nabawi.subtitle": {
    "id": "Denah skematik Masjid Nabawi beserta bagian-bagian penting di dalamnya.",
    "en": "Schematic plan of Masjid Nabawi and its important sections.",
    "ar": "مخطط تخطيطي للمسجد النبوي وأقسامه المهمة.",
    "fr": "Plan schématique de la Mosquée du Prophète et de ses sections importantes.",
    "de": "Schematischer Grundriss der Moschee des Propheten und ihrer wichtigen Bereiche.",
    "es": "Plano esquemático de la Mezquita del Profeta y sus secciones importantes.",
    "ru": "Схематический план Мечети Пророка и её важных разделов.",
    "zh": "先知清真寺示意图及其重要区域。",
    "ja": "マスジド・ナバウィの概略図とその重要な区画。",
    "ko": "마스지드 나바위의 개략 도면과 중요한 구역들.",
    "hi": "मस्जिद नबवी का模式图 और उसके महत्वपूर्ण खंड।"
  },
  "nabawi.mapCaption": {
    "id": "Denah skematik (bukan skala sebenarnya): pelataran berpayung di sisi barat, ruang salat utama di sisi timur, dengan Raudhah, mimbar, dan Makam Nabi ﷺ di bawah Kubah Hijau pada sudut kiblat.",
    "en": "Schematic plan (not to scale): the umbrella-shaded courtyard on the west side, the main prayer hall on the east side, with the Raudhah, the pulpit, and the Tomb of the Prophet ﷺ beneath the Green Dome at the Qibla corner.",
    "ar": "مخطط تخطيطي (غير مقياس رسم): الفناء المظلل بالمظلات في الجهة الغربية، وقاعة الصلاة الرئيسية في الجهة الشرقية، مع الروضة الشريفة والمنبر وضريح النبي ﷺ تحت القبة الخضراء في ركن القبلة.",
    "fr": "Plan schématique (non à l'échelle) : la cour ombragée par des parasols du côté ouest, la salle de prière principale du côté est, avec la Raudhah, le minbar et le Tombeau du Prophète ﷺ sous le Dôme Vert au coin de la Qibla.",
    "de": "Schematischer Grundriss (nicht maßstabsgetreu): Der überdachte Innenhof mit Schirmen auf der Westseite, der Hauptgebetsraum auf der Ostseite, mit der Raudhah, dem Minbar und dem Grab des Propheten ﷺ unter der Grünen Kuppel an der Qibla-Ecke.",
    "es": "Plano esquemático (sin escala): el patio con sombra de parasoles en el lado oeste, la sala de oración principal en el lado este, con la Raudhah, el púlpito y la Tumba del Profeta ﷺ bajo la Cúpula Verde en el rincón de la Qibla.",
    "ru": "Схематический план (не в масштабе): двор под зонтичными навесами на западной стороне, главный молитвенный зал на восточной стороне, с Рауда, минбаром и гробницей Пророка ﷺ под Зелёным куполом у угла Киблы.",
    "zh": "示意图（非按比例）：西侧为遮阳伞庭院，东侧为主礼拜大厅，绿色圆顶下朝向礼拜方向的一角设有莱道、讲台及先知ﷺ的圣墓。",
    "ja": "概略図（縮尺なし）：西側に日除けパラソルのある中庭、東側にメインの礼拝堂、キブラの角にある緑のドームの下にラウダ、ミンバル、預言者ﷺの御廟があります。",
    "ko": "개략 도면(축척 무시): 서쪽에는 파라솔이 드리워진 중정, 동쪽에는 주요 예배 공간이 있으며, 끼블라 방향 모서리의 녹색 돔 아래에 라우다, 민바르, 예언자ﷺ의 묘소가 위치합니다.",
    "hi": "模式图（वास्तविक पैमाने पर नहीं）: पश्चिम दिशा में छत्र-छायांकित प्रांगण, पूर्व दिशा में मुख्य礼拜 कक्ष, तथा क़िब्ला कोने पर हरे गुम्बद के नीचे रौज़ा, मिम्बर और नबी ﷺ का मक़बरा।"
  },
  "nabawi.featuresTitle": {
    "id": "Bagian-bagian Penting di Dalamnya",
    "en": "Important Sections Within It",
    "ar": "الأقسام المهمة في داخله",
    "fr": "Les Sections Importantes en Son Sein",
    "de": "Wichtige Bereiche in seinem Inneren",
    "es": "Secciones Importantes en su Interior",
    "ru": "Важные разделы внутри него",
    "zh": "内部重要区域",
    "ja": "内部の重要な区画",
    "ko": "내부의 중요한 구역들",
    "hi": "इसके भीतर के महत्वपूर्ण खंड"
  },
  "nabawi.svgCourtyard": {
    "id": "Pelataran & Payung",
    "en": "Courtyard & Umbrellas",
    "ar": "الفناء والمظلات",
    "fr": "Cour & Parasols",
    "de": "Innenhof & Schirme",
    "es": "Patio y Parasoles",
    "ru": "Двор и Зонты",
    "zh": "庭院与遮阳伞",
    "ja": "中庭とパラソル",
    "ko": "중정과 파라솔",
    "hi": "प्रांगण और छत्र"
  },
  "nabawi.svgQibla": {
    "id": "↑ Arah Kiblat",
    "en": "↑ Qibla Direction",
    "ar": "↑ اتجاه القبلة",
    "fr": "↑ Direction de la Qibla",
    "de": "↑ Qibla-Richtung",
    "es": "↑ Dirección de la Qibla",
    "ru": "↑ Направление Киблы",
    "zh": "↑ 朝拜方向（Qibla）",
    "ja": "↑ キブラの方向",
    "ko": "↑ 끼블라 방향",
    "hi": "↑ क़िब्ला की दिशा"
  },
  "nabawi.feat.raudhah.t": {
    "id": "Raudhah Syarifah",
    "en": "Raudhah Sharifah",
    "ar": "الروضة الشريفة",
    "fr": "Raudhah Sharifah",
    "de": "Raudhah Sharifah",
    "es": "Raudhah Sharifah",
    "ru": "Рауда аш-Шарифа",
    "zh": "莱道·沙里法（Raudhah Sharifah）",
    "ja": "ラウダ・シャリーファ",
    "ko": "라우다 샤리파",
    "hi": "रौज़ा शरीफ़ा"
  },
  "nabawi.feat.raudhah.d": {
    "id": "Area berkarpet hijau di antara rumah (makam) Nabi ﷺ dan mimbar beliau. Rasulullah ﷺ bersabda, 'Antara rumahku dan mimbarku adalah salah satu taman dari taman-taman surga.' Kini akses diatur dengan sistem tasrih (izin) melalui aplikasi Nusuk.",
    "en": "The green-carpeted area between the house (tomb) of the Prophet ﷺ and his pulpit. The Messenger of Allah ﷺ said, 'Between my house and my pulpit is one of the gardens of Paradise.' Access is now regulated through the tasrih (permit) system via the Nusuk application.",
    "ar": "المنطقة المفروشة بالسجاد الأخضر بين حجرة (مقام) النبي ﷺ ومنبره. قال رسول الله ﷺ: «ما بين بيتي ومنبري روضةٌ من رياض الجنة». ويُنظَّم الوصول إليها حالياً عبر نظام التصاريح من خلال تطبيق نُسُك.",
    "fr": "La zone recouverte de tapis verts entre la demeure (tombeau) du Prophète ﷺ et son minbar. Le Messager d'Allah ﷺ a dit : « Entre ma maison et mon minbar se trouve l'un des jardins du Paradis. » L'accès est désormais réglementé par le système de tasrih (autorisation) via l'application Nusuk.",
    "de": "Der grün beteppichte Bereich zwischen dem Haus (Grab) des Propheten ﷺ und seiner Kanzel. Der Gesandte Allahs ﷺ sagte: „Zwischen meinem Haus und meiner Kanzel befindet sich ein Garten der Gärten des Paradieses.\" Der Zugang wird nun über das Tasrih-(Erlaubnis-)System durch die Nusuk-App geregelt.",
    "es": "El área alfombrada en verde entre la casa (tumba) del Profeta ﷺ y su púlpito. El Mensajero de Allah ﷺ dijo: «Entre mi casa y mi púlpito hay uno de los jardines del Paraíso.» El acceso ahora está regulado mediante el sistema de tasrih (permiso) a través de la aplicación Nusuk.",
    "ru": "Область с зелёным ковром между домом (гробницей) Пророка ﷺ и его минбаром. Посланник Аллаха ﷺ сказал: «Между моим домом и моим минбаром — один из садов Рая». Доступ ныне регулируется через систему тасрих (разрешений) посредством приложения Nusuk.",
    "zh": "先知ﷺ的居所（陵墓）与其讲台之间铺有绿色地毯的区域。真主的使者ﷺ说：\"我的家与我的讲台之间是天园中的一座花园。\"目前，入场须通过Nusuk应用程序的塔斯利赫（许可）系统进行管理。",
    "ja": "預言者ﷺの御居所（御廟）とミンバルの間の緑のカーペットが敷かれた区域。アッラーの使徒ﷺは「私の家とミンバルの間は楽園の庭園のひとつである」と仰せになりました。現在、入場はNusukアプリによるタスリーフ（許可）制度で管理されています。",
    "ko": "예언자ﷺ의 거처(묘소)와 민바르 사이에 녹색 카펫이 깔린 구역입니다. 알라의 사도ﷺ께서 \"나의 집과 민바르 사이는 낙원의 정원 중 하나이다\"라고 말씀하셨습니다. 현재 입장은 Nusuk 앱의 타스리흐(허가) 시스템을 통해 관리됩니다.",
    "hi": "नबी ﷺ के घर (मज़ार) और उनके मिम्बर के बीच हरे कालीन से ढका क्षेत्र। अल्लाह के रसूल ﷺ ने फ़रमाया: \"मेरे घर और मेरे मिम्बर के बीच जन्नत के बागों में से एक बाग है।\" अब इस स्थान पर पहुँच Nusuk ऐप के माध्यम से तसरीह (अनुमति) प्रणाली द्वारा नियंत्रित की जाती है।"
  },
  "nabawi.feat.makam.t": {
    "id": "Makam Rasulullah ﷺ",
    "en": "The Tomb of the Messenger of Allah ﷺ",
    "ar": "مقام رسول الله ﷺ",
    "fr": "Le Tombeau du Messager d'Allah ﷺ",
    "de": "Das Grab des Gesandten Allahs ﷺ",
    "es": "La Tumba del Mensajero de Allah ﷺ",
    "ru": "Гробница Посланника Аллаха ﷺ",
    "zh": "真主使者ﷺ的陵墓",
    "ja": "アッラーの使徒ﷺの御廟",
    "ko": "알라의 사도ﷺ의 묘소",
    "hi": "अल्लाह के रसूल ﷺ का मज़ार"
  },
  "nabawi.feat.makam.d": {
    "id": "Terletak di bawah Kubah Hijau, di dalam bilik (Hujrah) bekas kamar Aisyah RA. Di sisi beliau dimakamkan dua sahabat & khalifah: Abu Bakar ash-Shiddiq RA dan Umar bin Khattab RA.",
    "en": "Located beneath the Green Dome, inside the chamber (Hujrah) of the former room of Aisha RA. Beside him are buried two companions and caliphs: Abu Bakr ash-Siddiq RA and Umar ibn al-Khattab RA.",
    "ar": "يقع تحت القبة الخضراء، داخل الحجرة النبوية الشريفة، وهي الغرفة التي كانت تسكنها السيدة عائشة رضي الله عنها. وإلى جانبه دُفن صاحبان وخليفتان: أبو بكر الصديق رضي الله عنه، وعمر بن الخطاب رضي الله عنه.",
    "fr": "Situé sous le Dôme Vert, à l'intérieur de la chambre (Hujrah) qui était autrefois la chambre d'Aisha RA. À ses côtés sont enterrés deux compagnons et califes : Abu Bakr ash-Siddiq RA et Umar ibn al-Khattab RA.",
    "de": "Er befindet sich unter der Grünen Kuppel, im Inneren des Gemachs (Hujrah), dem ehemaligen Zimmer von Aisha RA. Neben ihm sind zwei Gefährten und Kalifen begraben: Abu Bakr ash-Siddiq RA und Umar ibn al-Khattab RA.",
    "es": "Situado bajo la Cúpula Verde, dentro de la cámara (Hujrah) que fue el aposento de Aisha RA. A su lado están enterrados dos compañeros y califas: Abu Bakr ash-Siddiq RA y Umar ibn al-Khattab RA.",
    "ru": "Находится под Зелёным куполом, внутри покоя (Худжра) — бывшей комнаты Аиши, да будет доволен ею Аллах. Рядом с ним погребены два сподвижника и халифа: Абу Бакр ас-Сиддик, да будет доволен им Аллах, и Умар ибн аль-Хаттаб, да будет доволен им Аллах.",
    "zh": "位于绿色穹顶之下，在原阿伊莎RA卧室的小室（胡杰拉）内。其旁安葬着两位圣门弟子兼哈里发：艾布·伯克尔·萨迪克RA和欧麦尔·本·赫塔布RA。",
    "ja": "グリーンドームの真下、かつてのアーイシャRA（アッラーが彼女に満悦されんことを）の居室であった小部屋（フジュラ）の中にあります。その傍らには二人の聖伴と哈里发、アブー・バクル・アッ＝スィッディークRAとウマル・イブン・アル＝ハッターブRAが埋葬されています。",
    "ko": "녹색 돔 아래, 아이샤RA의 옛 방이었던 방(후즈라) 안에 위치합니다. 그 옆에는 두 명의 교우이자 칼리파인 아부 바크르 앗-시디크RA와 우마르 이븐 알-하타브RA가 안장되어 있습니다.",
    "hi": "हरे गुम्बद के नीचे, हज़रत आइशा RA के पूर्व कक्ष (हुजरह) के भीतर स्थित है। उनके पहलू में दो सहाबी एवं खलीफा दफ़न हैं: हज़रत अबू बक्र अस-सिद्दीक़ RA और हज़रत उमर बिन खत्ताब RA।"
  },
  "nabawi.feat.kubah.t": {
    "id": "Kubah Hijau (Green Dome)",
    "en": "Green Dome (Al-Qubbah al-Khadra')",
    "ar": "القبة الخضراء",
    "fr": "Le Dôme Vert (Al-Qubbah al-Khadra')",
    "de": "Die Grüne Kuppel (Al-Qubbah al-Khadra')",
    "es": "La Cúpula Verde (Al-Qubbah al-Khadra')",
    "ru": "Зелёный купол (Аль-Куббат аль-Хадра')",
    "zh": "绿色穹顶（Al-Qubbah al-Khadra'）",
    "ja": "グリーンドーム（アル＝クッバ・アル＝ハドラー）",
    "ko": "녹색 돔 (Al-Qubbah al-Khadra')",
    "hi": "हरा गुम्बद (अल-क़ुब्बह अल-ख़ज़रा)"
  },
  "nabawi.feat.kubah.d": {
    "id": "Kubah ikonik berwarna hijau yang menaungi Hujrah Nabawiyah. Menjadi penanda utama letak makam Rasulullah ﷺ dari kejauhan.",
    "en": "The iconic green dome that covers the Hujrah Nabawiyyah. It serves as the primary landmark indicating the location of the tomb of the Messenger of Allah ﷺ from a distance.",
    "ar": "القبة الخضراء الشهيرة التي تعلو الحجرة النبوية الشريفة، وتُعدّ العلامة الرئيسية الدالة على موضع مقام رسول الله ﷺ من بُعد.",
    "fr": "Le dôme vert emblématique qui surplombe la Hujrah Nabawiyyah. Il constitue le principal repère indiquant l'emplacement du tombeau du Messager d'Allah ﷺ de loin.",
    "de": "Die ikonische grüne Kuppel, die die Hujrah Nabawiyyah überdacht. Sie dient als wichtigstes Wahrzeichen, das den Standort des Grabes des Gesandten Allahs ﷺ aus der Ferne anzeigt.",
    "es": "La icónica cúpula verde que cubre la Hujrah Nabawiyyah. Es el principal hito que indica la ubicación del sepulcro del Mensajero de Allah ﷺ desde la distancia.",
    "ru": "Знаменитый зелёный купол, возвышающийся над Худжрой Набавиййей. Он служит главным ориентиром, указывающим издалека на место погребения Посланника Аллаха ﷺ.",
    "zh": "覆盖着纳巴维胡杰拉（Hujrah Nabawiyyah）的标志性绿色穹顶，是从远处指示真主使者ﷺ陵墓位置的主要地标。",
    "ja": "フジュラ・ナバウィッヤを覆う象徴的な緑のドームで、遠くからアッラーの使徒ﷺの御廟の位置を示す主要なランドマークとなっています。",
    "ko": "후즈라 나바위야(Hujrah Nabawiyyah)를 덮고 있는 상징적인 녹색 돔으로, 멀리서도 알라의 사도ﷺ 묘소의 위치를 알려주는 주요 랜드마크입니다.",
    "hi": "यह प्रतिष्ठित हरा गुम्बद हुजरह नबविय्यह को ढकता है और दूर से ही अल्लाह के रसूल ﷺ के मज़ार की स्थिति दर्शाने वाला प्रमुख चिह्न है।"
  },
  "nabawi.feat.mihrab.t": {
    "id": "Mihrab Nabawi",
    "en": "Mihrab Nabawi (The Prophet's Prayer Niche)",
    "ar": "المحراب النبوي",
    "fr": "Mihrab Nabawi (La niche de prière du Prophète)",
    "de": "Mihrab Nabawi (Die Gebetsnische des Propheten)",
    "es": "Mihrab Nabawi (El nicho de oración del Profeta)",
    "ru": "Михраб Набави (Молитвенная ниша Пророка)",
    "zh": "先知米哈拉布（Mihrab Nabawi）",
    "ja": "ミフラーブ・ナバウィー（預言者のミフラーブ）",
    "ko": "미흐랍 나바위 (예언자의 기도 벽감)",
    "hi": "मिहराब नबवी (नबी ﷺ का नमाज़ का स्थान)"
  },
  "nabawi.feat.mihrab.d": {
    "id": "Menandai tempat Rasulullah ﷺ berdiri mengimami salat. Terdapat pula Mihrab Utsmani yang digunakan imam masa kini.",
    "en": "Marks the spot where the Prophet ﷺ stood leading the prayer. There is also the Uthmani Mihrab used by the imam today.",
    "ar": "يُحدِّد المكانَ الذي كان فيه النبيُّ ﷺ يقف إمامًا في الصلاة، ويوجد أيضًا المحراب العثماني الذي يستخدمه الإمام في عصرنا الحاضر.",
    "fr": "Marque l'endroit où le Prophète ﷺ se tenait pour diriger la prière. Il existe également le Mihrab Uthmani utilisé par l'imam de nos jours.",
    "de": "Markiert den Platz, an dem der Prophet ﷺ das Gebet als Imam leitete. Es gibt auch den Uthmani-Mihrab, der vom heutigen Imam verwendet wird.",
    "es": "Señala el lugar donde el Profeta ﷺ se encontraba dirigiendo la oración. También existe el Mihrab Utsmani utilizado por el imán en la actualidad.",
    "ru": "Отмечает место, где Пророк ﷺ стоял, ведя молитву в качестве имама. Здесь также находится Усманский михраб, которым пользуется имам по сей день.",
    "zh": "标志着先知ﷺ站立领拜的地方。此外还有今日伊玛目使用的奥斯曼米哈拉布。",
    "ja": "預言者ﷺがイマームとして礼拝を導く際に立っていた場所を示します。また、現在のイマームが使用するウスマーニー・ミフラーブもあります。",
    "ko": "예언자 ﷺ께서 이맘으로서 예배를 인도하며 서셨던 자리를 표시합니다. 현재의 이맘이 사용하는 우스마니 미흐랍도 있습니다.",
    "hi": "उस स्थान को चिह्नित करता है जहाँ पैगंबर ﷺ नमाज़ में इमामत करते हुए खड़े होते थे। यहाँ उस्मानी मिहराब भी है जिसे आज के इमाम उपयोग करते हैं।"
  },
  "nabawi.feat.mimbar.t": {
    "id": "Mimbar Nabi ﷺ",
    "en": "The Prophet's Minbar ﷺ",
    "ar": "مِنبر النبيِّ ﷺ",
    "fr": "Le Minbar du Prophète ﷺ",
    "de": "Der Minbar des Propheten ﷺ",
    "es": "El Minbar del Profeta ﷺ",
    "ru": "Минбар Пророка ﷺ",
    "zh": "先知ﷺ的敏拜尔",
    "ja": "預言者ﷺのミンバル",
    "ko": "예언자 ﷺ의 민바르",
    "hi": "नबी ﷺ का मिम्बर"
  },
  "nabawi.feat.mimbar.d": {
    "id": "Tempat Rasulullah ﷺ menyampaikan khutbah. Mimbar asli dari kayu; kini berupa mimbar marmer indah di posisi yang sama.",
    "en": "The place where the Prophet ﷺ delivered his sermons. The original Minbar was made of wood; it is now a beautiful marble Minbar in the same position.",
    "ar": "المكان الذي كان النبيُّ ﷺ يُلقي منه خُطَبه. كان المنبر الأصلي مصنوعًا من الخشب، وهو الآن منبرٌ رخامي بديع في الموضع ذاته.",
    "fr": "L'endroit où le Prophète ﷺ prononçait ses sermons. Le Minbar d'origine était en bois ; il est aujourd'hui remplacé par un magnifique Minbar en marbre au même emplacement.",
    "de": "Der Ort, an dem der Prophet ﷺ seine Predigten hielt. Der ursprüngliche Minbar bestand aus Holz; heute steht an derselben Stelle ein prachtvoller Minbar aus Marmor.",
    "es": "El lugar donde el Profeta ﷺ pronunciaba sus sermones. El Minbar original era de madera; ahora es un hermoso Minbar de mármol en la misma posición.",
    "ru": "Место, откуда Пророк ﷺ произносил свои проповеди. Первоначальный минбар был деревянным; ныне на том же месте стоит великолепный мраморный минбар.",
    "zh": "先知ﷺ发表演讲的地方。原来的敏拜尔由木头制成，如今在同一位置是一座精美的大理石敏拜尔。",
    "ja": "預言者ﷺがフトバを行った場所です。元々のミンバルは木製でしたが、現在は同じ位置に美しい大理石のミンバルが置かれています。",
    "ko": "예언자 ﷺ께서 쿠트바를 전하시던 곳입니다. 원래의 민바르는 나무로 만들어졌으며, 지금은 같은 위치에 아름다운 대리석 민바르가 있습니다.",
    "hi": "वह स्थान जहाँ पैगंबर ﷺ खुत्बा दिया करते थे। मूल मिम्बर लकड़ी का था; अब उसी स्थान पर एक सुंदर संगमरमर का मिम्बर है।"
  },
  "nabawi.feat.ustuwanah.t": {
    "id": "Tiang-tiang Bersejarah (Ustuwanah)",
    "en": "Historic Pillars (Ustuwanah)",
    "ar": "الأعمدة التاريخية (الأسطوانات)",
    "fr": "Les piliers historiques (Ustuwanah)",
    "de": "Historische Säulen (Ustuwanah)",
    "es": "Los pilares históricos (Ustuwanah)",
    "ru": "Исторические колонны (Устуванах)",
    "zh": "历史柱（乌斯图瓦纳）",
    "ja": "歴史的な柱（ウスツワーナ）",
    "ko": "역사적인 기둥들 (우스투와나)",
    "hi": "ऐतिहासिक स्तंभ (उस्तुवानाह)"
  },
  "nabawi.feat.ustuwanah.d": {
    "id": "Antara lain: Ustuwanah Hannanah (batang kurma yang menangis rindu kepada Nabi ﷺ), Ustuwanah Aisyah/Muhajirin, Ustuwanah Taubah (Abu Lubabah), Ustuwanah Sarir, Ustuwanah Wufud (tempat menerima delegasi), dan Ustuwanah Haras (penjagaan).",
    "en": "These include: Ustuwanah Hannanah (the palm trunk that wept with longing for the Prophet ﷺ), Ustuwanah Aishah/Muhajirin, Ustuwanah Tawbah (Abu Lubabah), Ustuwanah Sarir, Ustuwanah Wufud (where delegations were received), and Ustuwanah Haras (the guard post).",
    "ar": "تشمل: أسطوانة الحنّانة (جذع النخلة الذي حنَّ شوقًا إلى النبيِّ ﷺ)، وأسطوانة عائشة/المهاجرين، وأسطوانة التوبة (أبو لبابة)، وأسطوانة السرير، وأسطوانة الوفود (مكان استقبال الوفود)، وأسطوانة الحرس.",
    "fr": "Elles comprennent : l'Ustuwanah Hannanah (le tronc de palmier qui pleurait de nostalgie pour le Prophète ﷺ), l'Ustuwanah Aishah/Muhajirin, l'Ustuwanah Tawbah (Abu Lubabah), l'Ustuwanah Sarir, l'Ustuwanah Wufud (lieu de réception des délégations) et l'Ustuwanah Haras (poste de garde).",
    "de": "Dazu gehören: Ustuwanah Hannanah (der Palmstamm, der sich aus Sehnsucht nach dem Propheten ﷺ weinend neigte), Ustuwanah Aishah/Muhajirin, Ustuwanah Tawbah (Abu Lubabah), Ustuwanah Sarir, Ustuwanah Wufud (Empfangsort für Delegationen) und Ustuwanah Haras (Wachposten).",
    "es": "Estas incluyen: Ustuwanah Hannanah (el tronco de palmera que lloró de anhelo por el Profeta ﷺ), Ustuwanah Aishah/Muhajirin, Ustuwanah Tawbah (Abu Lubabah), Ustuwanah Sarir, Ustuwanah Wufud (lugar de recepción de delegaciones) y Ustuwanah Haras (puesto de guardia).",
    "ru": "В их числе: Устуванах Ханнана (ствол пальмы, рыдавший в тоске по Пророку ﷺ), Устуванах Аиши/Мухаджирин, Устуванах Тауба (Абу Лубаба), Устуванах Сарир, Устуванах Вуфуд (место приёма делегаций) и Устуванах Харас (сторожевой пост).",
    "zh": "包括：乌斯图瓦纳·哈纳纳（因思念先知ﷺ而哭泣的枣椰树干）、乌斯图瓦纳·阿伊莎/穆哈吉林、乌斯图瓦纳·陶巴（阿布·卢巴巴）、乌斯图瓦纳·萨利尔、乌斯图瓦纳·乌福德（接见代表团之处）和乌斯图瓦纳·哈拉斯（守卫柱）。",
    "ja": "これらには次のものが含まれます：ウスツワーナ・ハンナーナ（預言者ﷺへの慕情から泣いたナツメヤシの幹）、ウスツワーナ・アーイシャ/ムハージリン、ウスツワーナ・タウバ（アブー・ルバーバ）、ウスツワーナ・サリール、ウスツワーナ・ウフード（代表団を迎えた場所）、ウスツワーナ・ハラス（護衛の柱）。",
    "ko": "이에는 다음이 포함됩니다: 우스투와나 한나나(예언자 ﷺ를 그리워하며 울었던 대추야자 줄기), 우스투와나 아이샤/무하지린, 우스투와나 타우바(아부 루바바), 우스투와나 사리르, 우스투와나 우푸드(사절단을 맞이하던 곳), 우스투와나 하라스(경비 기둥).",
    "hi": "इनमें शामिल हैं: उस्तुवानाह हन्नाना (वह खजूर का तना जो नबी ﷺ की याद में रोया), उस्तुवानाह आइशा/मुहाजिरीन, उस्तुवानाह तौबा (अबू लुबाबा), उस्तुवानाह सरीर, उस्तुवानाह वुफूद (प्रतिनिधिमंडल प्राप्त करने का स्थान), और उस्तुवानाह हरस (पहरे का स्थान)।"
  },
  "nabawi.feat.pintu.t": {
    "id": "Pintu-pintu Utama (Bab)",
    "en": "Main Entrances (Bab)",
    "ar": "الأبواب الرئيسية (الأبواب)",
    "fr": "Les entrées principales (Bab)",
    "de": "Haupteingänge (Bab)",
    "es": "Entradas principales (Bab)",
    "ru": "Главные врата (Баб)",
    "zh": "主要入口（巴布）",
    "ja": "主要な入口（バーブ）",
    "ko": "주요 출입문 (바브)",
    "hi": "मुख्य द्वार (बाब)"
  },
  "nabawi.feat.pintu.d": {
    "id": "Bab As-Salam, Bab Jibril, Bab An-Nisa (khusus jamaah wanita), dan Bab Baqi'. Perluasan modern menambah gerbang besar seperti Bab King Fahd dan Bab King Abdul Aziz.",
    "en": "Bab As-Salam, Bab Jibril, Bab An-Nisa (exclusively for female pilgrims), and Bab Baqi'. Modern expansions added grand gates such as Bab King Fahd and Bab King Abdul Aziz.",
    "ar": "باب السلام، وباب جبريل، وباب النساء (مخصص للجماعة من النساء)، وباب البقيع. وقد أضافت التوسعات الحديثة بوابات كبرى كباب الملك فهد وباب الملك عبد العزيز.",
    "fr": "Bab As-Salam, Bab Jibril, Bab An-Nisa (réservé aux pèlerines), et Bab Baqi'. Les extensions modernes ont ajouté de grandes portes telles que Bab King Fahd et Bab King Abdul Aziz.",
    "de": "Bab As-Salam, Bab Jibril, Bab An-Nisa (ausschließlich für Pilgerinnen) und Bab Baqi'. Moderne Erweiterungen fügten große Tore wie Bab King Fahd und Bab King Abdul Aziz hinzu.",
    "es": "Bab As-Salam, Bab Jibril, Bab An-Nisa (exclusivamente para peregrinas) y Bab Baqi'. Las expansiones modernas añadieron grandes puertas como Bab King Fahd y Bab King Abdul Aziz.",
    "ru": "Баб ас-Салам, Баб Джибриль, Баб ан-Ниса (исключительно для паломниц) и Баб аль-Баки. Современные расширения добавили большие ворота, такие как Баб Кинг Фахд и Баб Кинг Абдул Азиз.",
    "zh": "萨拉姆门（Bab As-Salam）、吉卜利勒门（Bab Jibril）、女宾门（Bab An-Nisa，专供女性朝觐者使用）和巴基门（Bab Baqi'）。现代扩建增添了法赫德国王门（Bab King Fahd）和阿卜杜勒-阿齐兹国王门（Bab King Abdul Aziz）等宏伟大门。",
    "ja": "バーブ・アッサラーム、バーブ・ジブリール、バーブ・アンニサー（女性巡礼者専用）、バーブ・バキー。現代の拡張工事により、バーブ・キング・ファハドやバーブ・キング・アブドゥル・アジーズなどの大門が加えられました。",
    "ko": "바브 앗살람, 바브 지브릴, 바브 안니사(여성 순례자 전용), 바브 바키. 현대 확장 공사로 바브 킹 파흐드, 바브 킹 압둘 아지즈 같은 대형 문이 추가되었습니다.",
    "hi": "बाब अस-सलाम, बाब जिब्रील, बाब अन-निसा (केवल महिला हाजियों के लिए), और बाब बकी'। आधुनिक विस्तार में बाब किंग फहद और बाब किंग अब्दुल अज़ीज़ जैसे भव्य द्वार जोड़े गए।"
  },
  "nabawi.feat.payung.t": {
    "id": "Payung Raksasa & Pelataran",
    "en": "Giant Umbrellas & Courtyard",
    "ar": "المظلات العملاقة والصحن",
    "fr": "Parasols Géants & Esplanade",
    "de": "Riesenschirme & Innenhof",
    "es": "Sombrillas Gigantes & Explanada",
    "ru": "Гигантские зонты и двор",
    "zh": "巨型电动遮阳伞与广场",
    "ja": "巨大パラソルと中庭",
    "ko": "거대 전동 파라솔과 광장",
    "hi": "विशाल छाते और प्रांगण"
  },
  "nabawi.feat.payung.d": {
    "id": "Pelataran (sahn) dilengkapi payung elektrik raksasa yang membuka otomatis untuk menaungi jamaah dari terik, serta kipas pengabut untuk mendinginkan udara.",
    "en": "The courtyard (sahn) is equipped with giant electric umbrellas that open automatically to shade pilgrims from the scorching heat, as well as mist fans to cool the air.",
    "ar": "يُزوَّد الصحن بمظلات كهربائية عملاقة تُفتح تلقائياً لتوفير الظل للحجاج من حرارة الشمس الحارقة، فضلاً عن مراوح ضبابية لتلطيف الهواء.",
    "fr": "L'esplanade (sahn) est équipée de parasols électriques géants qui s'ouvrent automatiquement pour protéger les pèlerins de la chaleur accablante, ainsi que de ventilateurs à brumisation pour rafraîchir l'air.",
    "de": "Der Innenhof (Sahn) ist mit riesigen elektrischen Schirmen ausgestattet, die sich automatisch öffnen, um die Pilger vor der sengenden Hitze zu schützen, sowie mit Nebelgebläsen zur Luftkühlung.",
    "es": "La explanada (sahn) está equipada con enormes sombrillas eléctricas que se abren automáticamente para proteger a los peregrinos del calor abrasador, así como ventiladores de nebulización para refrescar el ambiente.",
    "ru": "Двор (сахн) оснащён гигантскими электрическими зонтами, которые автоматически раскрываются, чтобы укрыть паломников от палящего зноя, а также туманообразующими вентиляторами для охлаждения воздуха.",
    "zh": "广场（sahn）配备了巨型电动遮阳伞，可自动展开为朝觐者遮挡烈日，同时设有喷雾风扇以降低气温、冷却空气。",
    "ja": "中庭（サフン）には、炎天下から巡礼者を守るために自動で開く巨大な電動パラソルが設置されており、空気を冷やすためのミストファンも備えられています。",
    "ko": "광장(사흔)에는 순례자들을 뜨거운 햇볕으로부터 보호하기 위해 자동으로 펼쳐지는 대형 전동 파라솔이 설치되어 있으며, 공기를 식히는 미스트 팬도 갖춰져 있습니다.",
    "hi": "प्रांगण (सह्न) में विशाल विद्युत छाते लगे हैं जो स्वचालित रूप से खुलकर हाजियों को कड़ी धूप से बचाते हैं, साथ ही हवा को ठंडा करने के लिए मिस्ट फैन भी लगाए गए हैं।"
  },
  "haram.title": {
    "id": "Peta Masjidil Haram",
    "en": "Map of Masjid Al-Haram",
    "ar": "خريطة المسجد الحرام",
    "fr": "Carte de la Mosquée Al-Haram",
    "de": "Karte der Masjid Al-Haram",
    "es": "Mapa de la Mezquita Al-Haram",
    "ru": "Карта Масджид аль-Харам",
    "zh": "麦斯吉德·哈拉姆（禁寺）地图",
    "ja": "マスジド・アル・ハラームの地図",
    "ko": "마스지드 알하람 지도",
    "hi": "मस्जिद अल-हराम का नक्शा"
  },
  "haram.subtitle": {
    "id": "Denah skematik Masjidil Haram di Makkah beserta bagian-bagian penting di dalamnya.",
    "en": "A schematic layout of Masjid Al-Haram in Makkah along with its important sections.",
    "ar": "مخطط تخطيطي للمسجد الحرام في مكة المكرمة مع أبرز أجزائه ومعالمه.",
    "fr": "Plan schématique de la Mosquée Al-Haram à La Mecque avec ses sections importantes.",
    "de": "Ein schematischer Grundriss der Masjid Al-Haram in Makkah mit ihren wichtigen Bereichen.",
    "es": "Plano esquemático de la Mezquita Al-Haram en La Meca junto con sus secciones importantes.",
    "ru": "Схематический план Масджид аль-Харам в Мекке с указанием его важнейших частей.",
    "zh": "麦加禁寺（麦斯吉德·哈拉姆）的示意平面图及其重要区域说明。",
    "ja": "マッカにあるマスジド・アル・ハラームの概略図と主要な各部の説明。",
    "ko": "마카에 위치한 마스지드 알하람의 개략적인 배치도와 주요 구역 안내.",
    "hi": "मक्का में मस्जिद अल-हराम का योजनाबद्ध नक्शा तथा उसके महत्वपूर्ण भागों का विवरण।"
  },
  "haram.mapCaption": {
    "id": "Denah skematik (bukan skala sebenarnya): Ka'bah di pusat dikelilingi Mataf, dengan Maqam Ibrahim, Hijr Ismail, sumur Zamzam, serta lorong Sa'i (Safa–Marwah) di sisi timur.",
    "en": "Schematic layout (not to actual scale): the Ka'bah at the center surrounded by the Mataf, with Maqam Ibrahim, Hijr Ismail, the Zamzam well, and the Sa'i corridor (Safa–Marwah) on the eastern side.",
    "ar": "مخطط تخطيطي (ليس بمقياس رسم حقيقي): الكعبة المشرفة في المركز محاطةً بالمطاف، مع مقام إبراهيم، وحِجر إسماعيل، وبئر زمزم، ومسعى الصفا والمروة في الجانب الشرقي.",
    "fr": "Plan schématique (hors échelle réelle) : la Ka'bah au centre entourée du Mataf, avec le Maqam Ibrahim, le Hijr Ismail, le puits de Zamzam, et le couloir du Sa'i (Safa–Marwah) côté est.",
    "de": "Schematischer Grundriss (nicht maßstabsgetreu): die Ka'bah im Mittelpunkt, umgeben vom Mataf, mit Maqam Ibrahim, Hijr Ismail, dem Zamzam-Brunnen und dem Sa'i-Korridor (Safa–Marwah) auf der Ostseite.",
    "es": "Plano esquemático (no a escala real): la Ka'bah en el centro rodeada por el Mataf, con el Maqam Ibrahim, el Hijr Ismail, el pozo de Zamzam y el corredor del Sa'i (Safa–Marwah) en el lado este.",
    "ru": "Схематический план (не в реальном масштабе): Кааба в центре, окружённая Матафом, с Макам Ибрахимом, Хиджр Исмаилом, колодцем Замзам и коридором Са'и (Сафа–Марва) на восточной стороне.",
    "zh": "示意平面图（非实际比例）：卡尔白（Ka'bah）居中，周围为塔瓦夫区（Mataf），东侧设有易卜拉欣站（Maqam Ibrahim）、伊斯玛仪围墙（Hijr Ismail）、渗渗泉（Zamzam）井及赛跑走廊（萨法—麦尔瓦，Sa'i）。",
    "ja": "概略図（実際の縮尺ではありません）：カアバ（Ka'bah）を中心にマタフ（Mataf）が取り囲み、東側にはマカーム・イブラーヒーム（Maqam Ibrahim）、ヒジュル・イスマーイール（Hijr Ismail）、ザムザムの井戸（Zamzam）、およびサイー回廊（サファー–マルワ、Sa'i）があります。",
    "ko": "개략도(실제 축척 아님): 카바(Ka'bah)가 중앙에 위치하고 마타프(Mataf)가 둘러싸고 있으며, 동쪽에 마캄 이브라힘(Maqam Ibrahim), 히즈르 이스마일(Hijr Ismail), 잠잠 우물(Zamzam), 사이 통로(사파–마르와, Sa'i)가 있습니다.",
    "hi": "योजनाबद्ध नक्शा (वास्तविक पैमाने पर नहीं): Ka'bah केंद्र में, चारों ओर मतफ (Mataf), तथा पूर्व दिशा में Maqam Ibrahim, Hijr Ismail, ज़मज़म कुआँ और Sa'i गलियारा (सफा–मरवा) स्थित हैं।"
  },
  "haram.featuresTitle": {
    "id": "Bagian-bagian Penting di Dalamnya",
    "en": "Important Parts Within It",
    "ar": "الأجزاء المهمة بداخله",
    "fr": "Les parties importantes en son sein",
    "de": "Wichtige Teile darin",
    "es": "Partes importantes en su interior",
    "ru": "Важные части внутри него",
    "zh": "其中的重要部分",
    "ja": "内部の重要な部分",
    "ko": "내부의 중요한 부분",
    "hi": "इसके भीतर के महत्वपूर्ण भाग"
  },
  "haram.feat.kabah.t": {
    "id": "Ka'bah",
    "en": "Ka'bah",
    "ar": "الكعبة المشرفة",
    "fr": "Ka'bah",
    "de": "Ka'bah",
    "es": "Ka'bah",
    "ru": "Кааба",
    "zh": "天房（Ka'bah）",
    "ja": "カアバ（Ka'bah）",
    "ko": "카아바（Ka'bah）",
    "hi": "काबा (Ka'bah)"
  },
  "haram.feat.kabah.d": {
    "id": "Bangunan kubus di pusat masjid, kiblat seluruh umat Islam, ditutup kain hitam bersulam emas (Kiswah). Terdapat pintu Ka'bah dari emas dan Mizab (talang) di atasnya.",
    "en": "A cubic structure at the center of the mosque, the Qiblah of all Muslims, covered by a black embroidered gold cloth (Kiswah). It has a golden door and the Mizab (water spout) above it.",
    "ar": "بناءٌ مكعب الشكل في مركز المسجد، وهو قبلة جميع المسلمين، يُغطَّى بكسوةٍ سوداء مطرَّزة بالذهب. يضمُّ بابًا من الذهب ويعلوه الميزاب.",
    "fr": "Une structure cubique au centre de la mosquée, la Qiblah de tous les musulmans, recouverte d'un tissu noir brodé d'or (Kiswah). Elle possède une porte en or et le Mizab (gargouille) au-dessus.",
    "de": "Ein würfelförmiges Gebäude im Zentrum der Moschee, die Qiblah aller Muslime, bedeckt mit einem schwarz-goldbestickten Tuch (Kiswah). Es hat eine goldene Tür und den Mizab (Wasserspeier) darüber.",
    "es": "Una estructura cúbica en el centro de la mezquita, la Qiblah de todos los musulmanes, cubierta con una tela negra bordada en oro (Kiswah). Tiene una puerta de oro y el Mizab (canalón) encima.",
    "ru": "Кубическое строение в центре мечети, Кибла всех мусульман, покрытое чёрным вышитым золотом полотном (Кисва). Имеет золотые врата и Мизаб (водосток) над ними.",
    "zh": "位于清真寺中心的立方体建筑，是全体穆斯林的朝拜方向（Qiblah），覆盖着绣有金线的黑色基斯瓦（Kiswah）。设有黄金门，其上方有排水槽（Mizab）。",
    "ja": "モスクの中心にある立方体の建造物で、全ムスリムのキブラ（礼拝方向）。金糸刺繍の黒いキスワ（Kiswah）で覆われており、黄金の扉とその上にミザーブ（雨樋）がある。",
    "ko": "모스크 중앙에 위치한 정육면체 건물로, 모든 무슬림의 끼블라(Qiblah)이며 금수 자수가 새겨진 검은 천(키스와, Kiswah)으로 덮여 있습니다. 황금 문이 있고 그 위에 미자브(Mizab, 홈통)가 있습니다.",
    "hi": "मस्जिद के केंद्र में एक घनाकार संरचना, समस्त मुसलमानों का क़िब्ला, सोने की कढ़ाई वाले काले वस्त्र (किस्वा, Kiswah) से ढकी हुई। इसमें सोने का दरवाज़ा और ऊपर मीज़ाब (Mizab, नाली) है।"
  },
  "haram.feat.hajar.t": {
    "id": "Hajar Aswad",
    "en": "Hajar Aswad",
    "ar": "الحجر الأسود",
    "fr": "Hajar Aswad",
    "de": "Hajar Aswad",
    "es": "Hajar Aswad",
    "ru": "Хаджар аль-Асвад",
    "zh": "黑石（Hajar Aswad）",
    "ja": "ハジャル・アスワド（Hajar Aswad）",
    "ko": "하자르 아스와드（Hajar Aswad）",
    "hi": "हजरे अस्वद (Hajar Aswad)"
  },
  "haram.feat.hajar.d": {
    "id": "Batu hitam di sudut tenggara Ka'bah, titik awal & akhir setiap putaran Tawaf. Disunnahkan menciumnya atau memberi isyarat (istilam) bila padat.",
    "en": "The black stone at the southeastern corner of the Ka'bah, the starting and ending point of every circuit of Tawaf. It is Sunnah to kiss it or to gesture toward it (Istilam) when crowded.",
    "ar": "حجرٌ أسود في الركن الجنوبي الشرقي من الكعبة المشرفة، وهو نقطة البداية والنهاية لكل شوطٍ من أشواط الطواف. يُسنُّ تقبيله أو الإشارة إليه (الاستلام) عند الازدحام.",
    "fr": "La pierre noire située à l'angle sud-est de la Ka'bah, point de départ et d'arrivée de chaque tour du Tawaf. Il est Sunnah de l'embrasser ou de faire un geste vers elle (Istilam) en cas d'affluence.",
    "de": "Der schwarze Stein an der südöstlichen Ecke der Ka'bah, der Start- und Endpunkt jeder Runde des Tawaf. Es ist Sunnah, ihn zu küssen oder ihm zuzuwinken (Istilam), wenn es voll ist.",
    "es": "La piedra negra en la esquina sureste de la Ka'bah, punto de inicio y fin de cada vuelta del Tawaf. Es Sunnah besarla o hacer un gesto hacia ella (Istilam) cuando hay mucha afluencia.",
    "ru": "Чёрный камень в юго-восточном углу Каабы, начальная и конечная точка каждого круга Тавафа. По Сунне его следует поцеловать или сделать жест в его сторону (Истилам) при большом скоплении людей.",
    "zh": "位于天房（Ka'bah）东南角的黑石，是每圈塔瓦夫（Tawaf）的起点与终点。人多拥挤时，应遵循圣行（Sunnah）亲吻它或以手势示意（伊斯提拉姆，Istilam）。",
    "ja": "カアバ（Ka'bah）の南東の角にある黒石で、タワーフ（Tawaf）の各周回の開始点・終了点である。混雑時にはキスするか、もしくはイスティラーム（Istilam）の合図をすることがスンナ（Sunnah）である。",
    "ko": "카아바(Ka'bah)의 남동쪽 모서리에 있는 검은 돌로, 타와프(Tawaf) 각 바퀴의 시작점이자 끝점입니다. 혼잡할 때는 키스하거나 손짓으로 이스틸람(Istilam)하는 것이 순나(Sunnah)입니다.",
    "hi": "काबा (Ka'bah) के दक्षिण-पूर्वी कोने में स्थित काला पत्थर, तवाफ़ (Tawaf) के प्रत्येक चक्कर का प्रारंभ और अंत बिंदु। भीड़ होने पर इसे चूमना या इशारा करना (इस्तिलाम, Istilam) सुन्नत है।"
  },
  "haram.feat.yamani.t": {
    "id": "Rukun Yamani",
    "en": "Rukun Yamani",
    "ar": "الركن اليماني",
    "fr": "Rukun Yamani",
    "de": "Rukun Yamani",
    "es": "Rukun Yamani",
    "ru": "Рукн Ямани",
    "zh": "也门角（Rukun Yamani）",
    "ja": "ルクン・ヤマーニー（Rukun Yamani）",
    "ko": "루쿤 야마니（Rukun Yamani）",
    "hi": "रुकन यमानी (Rukun Yamani)"
  },
  "haram.feat.yamani.d": {
    "id": "Sudut Ka'bah sebelum Hajar Aswad; disunnahkan mengusapnya (tanpa mencium). Di antara Rukun Yamani dan Hajar Aswad dibaca doa sapu jagat.",
    "en": "The corner of the Ka'bah before the Hajar Aswad; it is Sunnah to wipe it (without kissing). Between the Rukun Yamani and the Hajar Aswad, the universally encompassing supplication (dua sapu jagat) is recited.",
    "ar": "ركن الكعبة الذي يسبق الحجر الأسود؛ يُسنّ استلامه باليد دون تقبيله. وبين الركن اليماني والحجر الأسود يُقرأ الدعاء الجامع المأثور.",
    "fr": "L'angle de la Ka'bah situé avant le Hajar Aswad ; il est Sunna de le toucher de la main (sans l'embrasser). Entre le Rukun Yamani et le Hajar Aswad, on récite la supplication universelle (dua sapu jagat).",
    "de": "Die Ecke der Ka'bah vor dem Hajar Aswad; es ist Sunnah, sie (mit der Hand) zu berühren (ohne sie zu küssen). Zwischen dem Rukun Yamani und dem Hajar Aswad wird das allumfassende Bittgebet (Dua sapu jagat) gesprochen.",
    "es": "El ángulo de la Ka'bah antes del Hajar Aswad; es Sunnah tocarlo con la mano (sin besarlo). Entre el Rukun Yamani y el Hajar Aswad se recita la súplica universal (dua sapu jagat).",
    "ru": "Угол Каабы перед Хаджар аль-Асвад; по Сунне его следует касаться рукой (не целуя). Между Рукн аль-Ямани и Хаджар аль-Асвад читается всеобъемлющая дуа (dua sapu jagat).",
    "zh": "这是朝觐中卡尔白（Ka'bah）在哈贾尔·艾斯瓦德（Hajar Aswad）之前的一角；按逊奈（Sunnah），应用手抚摸它（不必亲吻）。在鲁昆叶马尼（Rukun Yamani）与哈贾尔·艾斯瓦德之间，诵读涵盖今后两世的综合性祈祷文。",
    "ja": "ハジャル・アスワド（Hajar Aswad）の手前にあるカアバ（Ka'bah）の角であり、スンナとして（キスせずに）手で撫でることが推奨される。ルクン・ヤマニ（Rukun Yamani）とハジャル・アスワドの間では、現世と来世を包括するドゥアー（dua sapu jagat）が唱えられる。",
    "ko": "하자르 아스와드(Hajar Aswad) 앞에 위치한 카바(Ka'bah)의 모서리로, 순나(Sunnah)에 따라 손으로 어루만지는 것이 권장된다(입 맞춤 없이). 루쿤 야마니(Rukun Yamani)와 하자르 아스와드 사이에서는 현세와 내세를 아우르는 포괄적인 두아(dua sapu jagat)를 낭독한다.",
    "hi": "यह Ka'bah का वह कोना है जो Hajar Aswad से पहले पड़ता है; इसे हाथ से छूना (बिना चूमे) सुन्नत है। Rukun Yamani और Hajar Aswad के बीच दुनिया व आख़िरत की भलाई की व्यापक दुआ (dua sapu jagat) पढ़ी जाती है।"
  },
  "haram.feat.multazam.t": {
    "id": "Multazam",
    "en": "Multazam",
    "ar": "الملتزم",
    "fr": "Multazam",
    "de": "Multazam",
    "es": "Multazam",
    "ru": "Мультазам",
    "zh": "穆勒塔扎姆（Multazam）",
    "ja": "ムルタザム（Multazam）",
    "ko": "물타잠（Multazam）",
    "hi": "मुल्तज़म (Multazam)"
  },
  "haram.feat.multazam.d": {
    "id": "Bagian dinding Ka'bah antara Hajar Aswad dan pintu Ka'bah — tempat mustajab untuk berdoa sambil menempelkan dada dan wajah.",
    "en": "The section of the Ka'bah's wall between the Hajar Aswad and the door of the Ka'bah — a blessed place for supplication while pressing one's chest and face against it.",
    "ar": "الجزء من جدار الكعبة الواقع بين الحجر الأسود وباب الكعبة — وهو موضع مستجاب للدعاء، يُستحبّ أن يُلصق المرء صدره ووجهه به.",
    "fr": "La partie du mur de la Ka'bah située entre le Hajar Aswad et la porte de la Ka'bah — un lieu béni pour la supplication en y appliquant sa poitrine et son visage.",
    "de": "Der Abschnitt der Ka'bah-Wand zwischen dem Hajar Aswad und der Tür der Ka'bah — ein gesegneter Ort für das Bittgebet, bei dem man Brust und Gesicht dagegen drückt.",
    "es": "La sección del muro de la Ka'bah entre el Hajar Aswad y la puerta de la Ka'bah — un lugar bendito para la súplica mientras se apoya el pecho y el rostro contra él.",
    "ru": "Часть стены Каабы между Хаджар аль-Асвад и дверью Каабы — благословенное место для мольбы, прижимая к нему грудь и лицо.",
    "zh": "穆勒塔扎姆（Multazam）是卡尔白（Ka'bah）墙壁上位于哈贾尔·艾斯瓦德（Hajar Aswad）与卡尔白大门之间的部分——此处是祈祷被应允的圣地，祈祷时应将胸口和面部贴于其上。",
    "ja": "ムルタザム（Multazam）は、ハジャル・アスワド（Hajar Aswad）とカアバ（Ka'bah）の扉の間にあるカアバの壁の部分であり、胸と顔をその壁に押し当てながら祈願するための祝福された場所である。",
    "ko": "물타잠(Multazam)은 하자르 아스와드(Hajar Aswad)와 카바(Ka'bah) 문 사이에 위치한 카바 벽의 일부로, 가슴과 얼굴을 벽에 밀착시키며 기도하는 응답받기 좋은 복된 장소이다.",
    "hi": "Multazam, Ka'bah की दीवार का वह हिस्सा है जो Hajar Aswad और Ka'bah के दरवाज़े के बीच स्थित है — यह दुआ क़बूल होने की बरकत वाली जगह है, जहाँ सीना और चेहरा दीवार से लगाकर दुआ माँगी जाती है।"
  },
  "haram.feat.hijr.t": {
    "id": "Hijr Ismail (Hathim)",
    "en": "Hijr Ismail (Hatim)",
    "ar": "حِجر إسماعيل (الحطيم)",
    "fr": "Hijr Ismail (Hatim)",
    "de": "Hijr Ismail (Hatim)",
    "es": "Hijr Ismail (Hatim)",
    "ru": "Хиджр Исмаил (Хатим)",
    "zh": "伊斯玛仪围墙（Hijr Ismail）／哈提姆（Hatim）",
    "ja": "ヒジュル・イスマイル（Hijr Ismail）／ハティム（Hatim）",
    "ko": "히즈르 이스마일(Hijr Ismail) / 하팀(Hatim)",
    "hi": "हिज्र इस्माइल (Hatim)"
  },
  "haram.feat.hijr.d": {
    "id": "Area setengah lingkaran berpagar rendah di sisi utara Ka'bah; termasuk bagian dari Ka'bah. Salat di dalamnya seperti salat di dalam Ka'bah.",
    "en": "A semicircular low-walled area on the northern side of the Ka'bah; it is considered part of the Ka'bah itself. Praying inside it is equivalent to praying inside the Ka'bah.",
    "ar": "مساحة نصف دائرية محاطة بجدار قصير على الجانب الشمالي من الكعبة، وهي تُعدّ جزءاً من الكعبة المشرّفة. والصلاة فيها كالصلاة داخل الكعبة.",
    "fr": "Une zone semi-circulaire entourée d'un muret bas sur le côté nord de la Ka'bah ; elle est considérée comme faisant partie de la Ka'bah elle-même. Prier à l'intérieur équivaut à prier à l'intérieur de la Ka'bah.",
    "de": "Ein halbkreisförmiger, von einer niedrigen Mauer umgebener Bereich auf der Nordseite der Ka'bah; er gilt als Teil der Ka'bah selbst. Das Beten darin entspricht dem Beten im Inneren der Ka'bah.",
    "es": "Un área semicircular rodeada por un muro bajo en el lado norte de la Ka'bah; se considera parte de la Ka'bah misma. Rezar dentro de ella equivale a rezar en el interior de la Ka'bah.",
    "ru": "Полукруглая огороженная невысокой стеной площадь на северной стороне Каабы; она считается частью самой Каабы. Молитва внутри неё равнозначна молитве внутри Каабы.",
    "zh": "这是位于卡尔白（Ka'bah）北侧、由低矮围墙环绕的半圆形区域，被视为卡尔白本身的一部分。在其中礼拜，等同于在卡尔白内部礼拜。",
    "ja": "カアバ（Ka'bah）の北側にある低い壁で囲まれた半円形の区画であり、カアバの一部とみなされる。その中での礼拝はカアバの内部での礼拝に等しい。",
    "ko": "카바(Ka'bah) 북쪽에 낮은 담으로 둘러싸인 반원형 구역으로, 카바 자체의 일부로 여겨진다. 이 안에서 드리는 예배는 카바 내부에서 드리는 예배와 동일한 것으로 간주된다.",
    "hi": "यह Ka'bah के उत्तरी हिस्से में एक अर्धवृत्ताकार, नीची दीवार से घिरा क्षेत्र है; इसे Ka'bah ही का हिस्सा माना जाता है। इसके अंदर नमाज़ पढ़ना Ka'bah के भीतर नमाज़ पढ़ने के समान है।"
  },
  "haram.feat.maqam.t": {
    "id": "Maqam Ibrahim",
    "en": "Maqam Ibrahim",
    "ar": "مقام إبراهيم",
    "fr": "Maqam Ibrahim",
    "de": "Maqam Ibrahim",
    "es": "Maqam Ibrahim",
    "ru": "Макам Ибрахим",
    "zh": "易卜拉欣站立处（Maqam Ibrahim）",
    "ja": "マカーム・イブラーヒーム（Maqam Ibrahim）",
    "ko": "마캄 이브라힘(Maqam Ibrahim)",
    "hi": "मक़ाम इब्राहीम (Maqam Ibrahim)"
  },
  "haram.feat.maqam.d": {
    "id": "Batu berbekas jejak kaki Nabi Ibrahim saat membangun Ka'bah, kini dalam kubah kaca-emas. Di belakangnya disunnahkan salat 2 rakaat setelah Tawaf.",
    "en": "A stone bearing the footprints of Prophet Ibrahim when he built the Ka'bah, now enclosed in a gold-glass dome. It is Sunnah to pray 2 rak'ahs behind it after Tawaf.",
    "ar": "حجر يحمل أثر قدمَي النبي إبراهيم عليه السلام حين بنى الكعبة، محفوظ الآن في قبة من الذهب والزجاج. يُسنّ أداء ركعتين خلفه بعد الطواف.",
    "fr": "Une pierre portant les empreintes du Prophète Ibrahim lors de la construction de la Ka'bah, désormais enchâssée dans un dôme de verre doré. Il est Sunna d'y prier 2 rak'ahs derrière elle après le Tawaf.",
    "de": "Ein Stein mit den Fußabdrücken des Propheten Ibrahim beim Bau der Ka'bah, heute unter einer Gold-Glas-Kuppel. Es ist Sunnah, nach dem Tawaf 2 Rak'ahs dahinter zu beten.",
    "es": "Una piedra que lleva las huellas del Profeta Ibrahim al construir la Ka'bah, ahora resguardada en una cúpula de vidrio dorado. Es Sunna rezar 2 rak'ahs detrás de ella tras el Tawaf.",
    "ru": "Камень со следами ног Пророка Ибрахима, оставленными при строительстве Каабы, ныне заключён в золото-стеклянный купол. Сунной является совершение 2 ракаатов позади него после Тавафа.",
    "zh": "这块石头留有先知易卜拉欣建造克尔白时的脚印，现置于金玻璃罩内。在完成塔瓦夫后，于其后方礼2拜是圣行。",
    "ja": "カアバを建設したときのイブラーヒーム預言者の足跡が残る石で、現在は金のガラスドームに収められています。タワーフの後にその後ろで2ラクアの礼拝を行うことがスンナです。",
    "ko": "이브라힘 예언자께서 카으바를 건설하실 때 남긴 발자국이 있는 돌로, 현재는 금빛 유리 돔 안에 보존되어 있습니다. 타와프 후 그 뒤에서 2라크아 예배를 드리는 것이 순나입니다.",
    "hi": "यह वह पत्थर है जिसमें Ka'bah के निर्माण के समय नबी इब्राहीम के पैरों के निशान हैं, जो अब सोने-कांच के गुंबद में सुरक्षित है। Tawaf के बाद इसके पीछे 2 रक'आत नमाज़ पढ़ना सुन्नत है।"
  },
  "haram.feat.zamzam.t": {
    "id": "Air Zamzam",
    "en": "Zamzam Water",
    "ar": "ماء زمزم",
    "fr": "Eau de Zamzam",
    "de": "Zamzam-Wasser",
    "es": "Agua de Zamzam",
    "ru": "Вода Замзам",
    "zh": "渗渗泉水",
    "ja": "ザムザムの水",
    "ko": "잠잠 성수",
    "hi": "ज़मज़म का पानी"
  },
  "haram.feat.zamzam.d": {
    "id": "Sumur mata air penuh berkah yang memancar sejak zaman Hajar & Ismail. Kini didistribusikan lewat ribuan dispenser di seluruh area masjid.",
    "en": "A blessed spring well that has flowed since the time of Hajar and Ismail. It is now distributed through thousands of dispensers throughout the mosque area.",
    "ar": "بئر مباركة تتدفق منذ عهد هاجر وإسماعيل عليهما السلام، وتُوزَّع مياهها الآن عبر آلاف الصنابير في جميع أنحاء المسجد.",
    "fr": "Un puits de source béni qui coule depuis l'époque de Hajar et Ismail. Il est aujourd'hui distribué via des milliers de distributeurs dans toute l'enceinte de la mosquée.",
    "de": "Ein gesegneter Quellbrunnen, der seit der Zeit von Hajar und Ismail fließt. Das Wasser wird heute über Tausende von Spendern in der gesamten Moscheefläche verteilt.",
    "es": "Un pozo de manantial bendito que brota desde la época de Hajar e Ismail. Actualmente se distribuye a través de miles de dispensadores en toda el área de la mezquita.",
    "ru": "Благословенный родниковый колодец, бьющий со времён Хаджар и Исмаила. Сегодня его вода распределяется через тысячи диспенсеров по всей территории мечети.",
    "zh": "这口充满祝福的泉井自哈哲尔与伊斯玛仪时代涌流至今，现通过遍布清真寺各处的数千台饮水机向众人供应。",
    "ja": "ハージャルとイスマーイールの時代から湧き続ける祝福された泉の井戸で、現在はモスク全域の数千台のディスペンサーを通じて配布されています。",
    "ko": "하자르와 이스마일 시대부터 솟아난 축복받은 샘물로, 현재는 모스크 전역의 수천 개의 디스펜서를 통해 공급되고 있습니다.",
    "hi": "यह Hajar और Ismail के समय से बहने वाला एक बरकत वाला चश्मा है। अब इसे मस्जिद के पूरे क्षेत्र में हजारों डिस्पेंसरों के माध्यम से वितरित किया जाता है।"
  },
  "haram.feat.mataf.t": {
    "id": "Mataf",
    "en": "Mataf",
    "ar": "المطاف",
    "fr": "Mataf",
    "de": "Mataf",
    "es": "Mataf",
    "ru": "Матаф",
    "zh": "塔瓦夫广场（Mataf）",
    "ja": "マタフ",
    "ko": "마타프",
    "hi": "मताफ़"
  },
  "haram.feat.mataf.d": {
    "id": "Pelataran marmer putih mengelilingi Ka'bah, tempat pelaksanaan Tawaf. Terdapat lantai bertingkat dan jalur kursi roda.",
    "en": "The white marble courtyard surrounding the Ka'bah where Tawaf is performed. It features multi-level floors and wheelchair-accessible lanes.",
    "ar": "الساحة الرخامية البيضاء المحيطة بالكعبة المشرفة، وهي المكان الذي يُؤدَّى فيه الطواف، وتشتمل على طوابق متعددة ومسارات مخصصة لكراسي الجلوس المتحركة.",
    "fr": "La cour en marbre blanc entourant la Ka'bah, lieu d'exécution du Tawaf. Elle dispose de plusieurs niveaux et de voies accessibles aux fauteuils roulants.",
    "de": "Der weiße Marmorplatz, der die Ka'bah umgibt und auf dem der Tawaf durchgeführt wird. Er verfügt über mehrere Ebenen und rollstuhlgerechte Spuren.",
    "es": "El patio de mármol blanco que rodea la Ka'bah, donde se realiza el Tawaf. Cuenta con pisos de varios niveles y carriles accesibles para sillas de ruedas.",
    "ru": "Белый мраморный двор вокруг Каабы, где совершается Таваф. Здесь предусмотрены многоуровневые площадки и дорожки для инвалидных колясок.",
    "zh": "环绕克尔白的白色大理石广场，是举行塔瓦夫的场所，设有多层楼面及轮椅专用通道。",
    "ja": "カアバを取り囲む白い大理石の広場で、タワーフが行われる場所です。複数階のフロアと車椅子用レーンが設けられています。",
    "ko": "카으바를 둘러싼 흰 대리석 광장으로 타와프가 거행되는 곳입니다. 다층 구조의 바닥과 휠체어 전용 통로가 마련되어 있습니다.",
    "hi": "Ka'bah के चारों ओर सफेद संगमरमर का वह चबूतरा जहाँ Tawaf अदा किया जाता है। यहाँ बहु-स्तरीय फर्श और व्हीलचेयर लेन की सुविधा है।"
  },
  "haram.feat.masa.t": {
    "id": "Bukit Safa & Marwah (Mas'a)",
    "en": "Safa & Marwah Hills (Mas'a)",
    "ar": "جبلا الصفا والمروة (المسعى)",
    "fr": "Collines de Safa & Marwah (Mas'a)",
    "de": "Hügel Safa & Marwah (Mas'a)",
    "es": "Colinas de Safa y Marwah (Mas'a)",
    "ru": "Холмы Сафа и Марва (Мас'а)",
    "zh": "萨法与麦尔瓦山丘（Mas'a）",
    "ja": "サファーとマルワーの丘（マスア）",
    "ko": "사파와 마르와 언덕 (마스아)",
    "hi": "सफ़ा और मरवा की पहाड़ियाँ (Mas'a)"
  },
  "haram.feat.masa.d": {
    "id": "Dua bukit yang kini berada di dalam lorong panjang (Mas'a) tempat Sa'i tujuh kali, mengenang perjuangan Hajar mencari air untuk Ismail.",
    "en": "Two hills now located within the long corridor (Mas'a) where Sa'i is performed seven times, commemorating Hajar's struggle to find water for Ismail.",
    "ar": "تلّان يقعان الآن داخل الممر الطويل (المسعى) حيث يُؤدَّى السعي سبع مرات، إحياءً لذكرى سعي هاجر بحثاً عن الماء لإسماعيل.",
    "fr": "Deux collines situées désormais dans le long couloir (Mas'a) où le Sa'i est accompli sept fois, en mémoire de la quête d'eau de Hajar pour Ismail.",
    "de": "Zwei Hügel, die sich nun im langen Korridor (Mas'a) befinden, wo der Sa'i siebenmal vollzogen wird, zum Gedenken an Hajars Suche nach Wasser für Ismail.",
    "es": "Dos colinas que se encuentran ahora dentro del largo corredor (Mas'a) donde se realiza el Sa'i siete veces, en memoria del esfuerzo de Hajar por encontrar agua para Ismail.",
    "ru": "Два холма, ныне расположенных в длинном коридоре (Мас'а), где Са'и совершается семь раз в память о поиске Хаджар воды для Исмаила.",
    "zh": "两座山丘现位于长廊（Mas'a）内，萨依在此往返七次，以纪念哈哲尔为伊斯玛仪寻找水源的艰辛历程。",
    "ja": "現在長い回廊（マスア）の中にある二つの丘で、イスマーイールのために水を求めたハージャルの奮闘を偲び、サアイが七回行われる場所です。",
    "ko": "현재 긴 복도(마스아) 안에 위치한 두 언덕으로, 이스마일을 위해 물을 찾았던 하자르의 노력을 기념하며 사이를 일곱 번 수행하는 곳입니다.",
    "hi": "दो पहाड़ियाँ जो अब लंबे गलियारे (मस'अ) के भीतर स्थित हैं, जहाँ इस्माइल के लिए पानी की तलाश में हाजर की संघर्षगाथा की स्मृति में सा'ई सात बार किया जाता है।"
  },
  "haram.feat.pintu.t": {
    "id": "Pintu-pintu Utama (Bab)",
    "en": "Main Gates (Bab)",
    "ar": "الأبواب الرئيسية (الأبواب)",
    "fr": "Portes Principales (Bab)",
    "de": "Haupttore (Bab)",
    "es": "Puertas Principales (Bab)",
    "ru": "Главные врата (Баб)",
    "zh": "主要大门（Bab）",
    "ja": "主要門（バーブ）",
    "ko": "주요 문(밥, Bab)",
    "hi": "मुख्य द्वार (बाब)"
  },
  "haram.feat.pintu.d": {
    "id": "Antara lain Bab As-Salam, Bab Abdul Aziz, Bab King Fahd, Bab Umrah, dan Bab Al-Fath. Masjid memiliki puluhan gerbang dan banyak menara.",
    "en": "These include Bab As-Salam, Bab Abdul Aziz, Bab King Fahd, Bab Umrah, and Bab Al-Fath. The mosque has dozens of gates and many minarets.",
    "ar": "تشمل باب السلام، وباب عبد العزيز، وباب الملك فهد، وباب العمرة، وباب الفتح. وللمسجد عشرات الأبواب ومنائر عديدة.",
    "fr": "Parmi eux figurent Bab As-Salam, Bab Abdul Aziz, Bab King Fahd, Bab Umrah et Bab Al-Fath. La mosquée possède des dizaines de portes et de nombreux minarets.",
    "de": "Dazu gehören Bab As-Salam, Bab Abdul Aziz, Bab King Fahd, Bab Umrah und Bab Al-Fath. Die Moschee verfügt über Dutzende von Toren und viele Minarette.",
    "es": "Entre ellas se encuentran Bab As-Salam, Bab Abdul Aziz, Bab King Fahd, Bab Umrah y Bab Al-Fath. La mezquita cuenta con decenas de puertas y numerosos minaretes.",
    "ru": "В их числе Баб ас-Салам, Баб Абдул Азиз, Баб Кинг Фахд, Баб Умра и Баб аль-Фатх. Мечеть имеет десятки ворот и множество минаретов.",
    "zh": "包括萨拉姆门（Bab As-Salam）、阿卜杜勒-阿齐兹门、法赫德国王门、副朝门（Bab Umrah）和法泰赫门（Bab Al-Fath）。清真寺拥有数十座大门和许多宣礼塔。",
    "ja": "バーブ・アッサラーム、バーブ・アブドゥルアジーズ、バーブ・キング・ファハド、バーブ・ウムラ、バーブ・アルファトフなどがあります。モスクには数十の門と多くのミナレットがあります。",
    "ko": "바브 앗살람, 바브 압둘 아지즈, 바브 킹 파흐드, 바브 우므라, 바브 알파트흐 등이 있습니다. 이 모스크에는 수십 개의 문과 많은 미나렛이 있습니다.",
    "hi": "इनमें बाब अस-सलाम, बाब अब्दुल अज़ीज़, बाब किंग फ़हद, बाब उमरह और बाब अल-फ़त्ह शामिल हैं। मस्जिद में दर्जनों द्वार और अनेक मीनारें हैं।"
  },
  "jenazah.title": {
    "id": "Panduan Sholat Jenazah",
    "en": "Funeral Prayer Guide",
    "ar": "دليل صلاة الجنازة",
    "fr": "Guide de la Prière Funèbre",
    "de": "Leitfaden zum Totengebet",
    "es": "Guía de la Oración Fúnebre",
    "ru": "Руководство по заупокойной молитве (Салят аль-Джаназа)",
    "zh": "殡礼（丧礼祈祷）指南",
    "ja": "ジャナーザ礼拝ガイド",
    "ko": "장례 기도(살라툴 자나자) 안내",
    "hi": "जनाज़ा नमाज़ मार्गदर्शिका"
  },
  "jenazah.subtitle": {
    "id": "Tata cara lengkap beserta niat & doa untuk jenazah laki-laki, wanita, anak laki-laki, dan anak perempuan.",
    "en": "Complete procedures along with intentions and supplications for the funeral prayer of a male, female, boy, and girl.",
    "ar": "الإجراءات الكاملة مع النيات والأدعية لصلاة الجنازة على الذكر والأنثى والولد والبنت.",
    "fr": "Procédures complètes avec les intentions et les invocations pour la prière funèbre d'un homme, d'une femme, d'un garçon et d'une fille.",
    "de": "Vollständige Anleitung mit Absichten und Bittgebeten für das Totengebet für einen Mann, eine Frau, einen Jungen und ein Mädchen.",
    "es": "Procedimientos completos junto con las intenciones y súplicas para la oración fúnebre de un hombre, una mujer, un niño y una niña.",
    "ru": "Полный порядок совершения с намерениями и мольбами для заупокойной молитвы по мужчине, женщине, мальчику и девочке.",
    "zh": "包含男性、女性、男孩和女孩殡礼的完整程序及意念与祈祷文。",
    "ja": "男性、女性、男の子、女の子のジャナーザ礼拝における完全な手順とニーヤ（意図）・ドゥアーを記載しています。",
    "ko": "남성, 여성, 남아, 여아에 대한 장례 기도의 완전한 절차와 니야트 및 두아를 포함합니다.",
    "hi": "पुरुष, महिला, लड़के और लड़की के जनाज़े की नमाज़ के लिए पूर्ण विधि, नीयत और दुआ सहित।"
  },
  "jenazah.info1": {
    "id": "Sholat jenazah hukumnya fardhu kifayah, dikerjakan berdiri, terdiri dari 4 takbir tanpa ruku dan sujud, lalu diakhiri salam.",
    "en": "The funeral prayer (Sholat Jenazah) is fardhu kifayah; it is performed standing, consisting of 4 takbirs without ruku' and sujud, and concluded with salam.",
    "ar": "صلاة الجنازة فرض كفاية، تُؤدَّى قياماً، وتتكون من 4 تكبيرات دون ركوع أو سجود، وتُختتم بالسلام.",
    "fr": "La prière funèbre (Sholat Jenazah) est un fardhu kifayah ; elle est accomplie debout, comprenant 4 takbirs sans ruku' ni sujud, et se termine par le salam.",
    "de": "Das Totengebet (Sholat Jenazah) ist fardhu kifayah; es wird im Stehen verrichtet, besteht aus 4 Takbirs ohne Ruku' und Sujud und wird mit dem Salam abgeschlossen.",
    "es": "La oración fúnebre (Sholat Jenazah) es fardhu kifayah; se realiza de pie, consta de 4 takbirs sin ruku' ni sujud, y concluye con el salam.",
    "ru": "Заупокойная молитва (Шалят Джаназа) является фардом кифая; она совершается стоя, состоит из 4 такбиров без руку' и саджды и завершается салямом.",
    "zh": "殡礼（Sholat Jenazah）属于集体义务（fardhu kifayah），站立进行，由4个塔克比尔组成，无鞠躬（ruku'）和叩头（sujud），最后以色兰结束。",
    "ja": "ジャナーザ礼拝（Sholat Jenazah）はファルドゥ・キファーヤ（集団義務）であり、立って行われ、ルクーウとスジュードなしの4回のタクビールで構成され、サラームで締めくくられます。",
    "ko": "장례 기도(Sholat Jenazah)는 파르두 키파야(집단 의무)이며, 서서 수행하고, 루쿠'와 수주드 없이 4번의 타크비르로 구성되며, 살람으로 마칩니다.",
    "hi": "शोलात जनाज़ा (जनाज़े की नमाज़) फ़र्ज़ किफ़ाया है; यह खड़े होकर अदा की जाती है, इसमें रुकू और सजदे के बिना 4 तकबीर होती हैं, और सलाम से समाप्त होती है।"
  },
  "jenazah.info2": {
    "id": "Posisi imam: sejajar kepala untuk jenazah laki-laki, dan sejajar tengah badan (pinggang) untuk jenazah perempuan.",
    "en": "Imam's position: aligned with the head for a male deceased, and aligned with the middle of the body (waist) for a female deceased.",
    "ar": "موقف الإمام: يقف عند رأس الميت إذا كان ذكراً، ويقف عند وسط بدنها (الوسط) إذا كانت أنثى.",
    "fr": "Position de l'imam : aligné avec la tête pour un défunt masculin, et aligné avec le milieu du corps (taille) pour une défunte féminine.",
    "de": "Position des Imams: auf Höhe des Kopfes bei einem männlichen Verstorbenen und auf Höhe der Körpermitte (Taille) bei einer weiblichen Verstorbenen.",
    "es": "Posición del imán: alineado con la cabeza para el fallecido masculino, y alineado con la mitad del cuerpo (cintura) para la fallecida femenina.",
    "ru": "Положение имама: напротив головы для умершего мужчины и напротив середины тела (пояса) для умершей женщины.",
    "zh": "伊玛目的位置：男性亡者时与头部齐平，女性亡者时与身体中部（腰部）齐平。",
    "ja": "イマームの位置：男性の故人の場合は頭部に、女性の故人の場合は身体の中央（腰部）に合わせます。",
    "ko": "이맘의 위치: 남성 고인의 경우 머리 부분에, 여성 고인의 경우 몸의 중간(허리) 부분에 나란히 섭니다.",
    "hi": "इमाम की स्थिति: पुरुष मृतक के लिए सिर के बराबर, और महिला मृतक के लिए शरीर के मध्य (कमर) के बराबर।"
  },
  "jenazah.choose": {
    "id": "Pilih jenis jenazah:",
    "en": "Select the type of deceased:",
    "ar": "اختر نوع الميت:",
    "fr": "Sélectionnez le type de défunt :",
    "de": "Wählen Sie die Art des Verstorbenen:",
    "es": "Seleccione el tipo de fallecido:",
    "ru": "Выберите категорию умершего:",
    "zh": "请选择亡者类型：",
    "ja": "故人の種類を選択してください：",
    "ko": "고인의 유형을 선택하세요:",
    "hi": "मृतक का प्रकार चुनें:"
  },
  "jenazah.cat.pria": {
    "id": "Laki-laki",
    "en": "Male",
    "ar": "ذكر",
    "fr": "Homme",
    "de": "Mann",
    "es": "Hombre",
    "ru": "Мужчина",
    "zh": "男性",
    "ja": "男性",
    "ko": "남성",
    "hi": "पुरुष"
  },
  "jenazah.cat.wanita": {
    "id": "Wanita",
    "en": "Female",
    "ar": "أنثى",
    "fr": "Femme",
    "de": "Frau",
    "es": "Mujer",
    "ru": "Женщина",
    "zh": "女性",
    "ja": "女性",
    "ko": "여성",
    "hi": "महिला"
  },
  "jenazah.cat.anak-l": {
    "id": "Anak Laki-laki",
    "en": "Boy",
    "ar": "طفل ذكر",
    "fr": "Garçon",
    "de": "Junge",
    "es": "Niño",
    "ru": "Мальчик",
    "zh": "男孩",
    "ja": "男の子",
    "ko": "남자 어린이",
    "hi": "लड़का"
  },
  "jenazah.cat.anak-p": {
    "id": "Anak Perempuan",
    "en": "Girl",
    "ar": "طفلة أنثى",
    "fr": "Fille",
    "de": "Mädchen",
    "es": "Niña",
    "ru": "Девочка",
    "zh": "女孩",
    "ja": "女の子",
    "ko": "여자 어린이",
    "hi": "लड़की"
  },
  "jenazah.niatLabel": {
    "id": "Niat",
    "en": "Intention (Niyyah)",
    "ar": "النية",
    "fr": "Intention (Niyyah)",
    "de": "Absicht (Niyyah)",
    "es": "Intención (Niyyah)",
    "ru": "Намерение (Ният)",
    "zh": "意念（Niyyah）",
    "ja": "意図（ニーヤ）",
    "ko": "의도 (니야)",
    "hi": "नीयत (Niyyah)"
  },
  "jenazah.step1": {
    "id": "Takbir Pertama — Al-Fatihah",
    "en": "First Takbir — Al-Fatihah",
    "ar": "التكبير الأول — الفاتحة",
    "fr": "Premier Takbir — Al-Fatiha",
    "de": "Erster Takbir — Al-Fatihah",
    "es": "Primer Takbir — Al-Fatiha",
    "ru": "Первый Такбир — Аль-Фатиха",
    "zh": "第一声台比尔 — 法蒂哈章",
    "ja": "第一タクビール — アル＝ファーティハ",
    "ko": "첫 번째 타크비르 — 알파티하",
    "hi": "पहली तकबीर — अल-फातिहा"
  },
  "jenazah.step2": {
    "id": "Takbir Kedua — Shalawat",
    "en": "Second Takbir — Salawat",
    "ar": "التكبير الثاني — الصلاة على النبي ﷺ",
    "fr": "Deuxième Takbir — Salawat",
    "de": "Zweiter Takbir — Salawat",
    "es": "Segundo Takbir — Salawat",
    "ru": "Второй Такбир — Салават",
    "zh": "第二声台比尔 — 赞颂先知ﷺ（萨拉瓦特）",
    "ja": "第二タクビール — サラワート（預言者ﷺへの祝福）",
    "ko": "두 번째 타크비르 — 살라와트",
    "hi": "दूसरी तकबीर — सलावात"
  },
  "jenazah.step3": {
    "id": "Takbir Ketiga — Doa untuk Jenazah",
    "en": "Third Takbir — Du'a for the Deceased",
    "ar": "التكبير الثالث — الدعاء للميت",
    "fr": "Troisième Takbir — Du'a pour le défunt",
    "de": "Dritter Takbir — Du'a für den Verstorbenen",
    "es": "Tercer Takbir — Du'a por el difunto",
    "ru": "Третий Такбир — Ду'а за усопшего",
    "zh": "第三声台比尔 — 为亡者祈祷（杜阿）",
    "ja": "第三タクビール — 故人のためのドゥアー",
    "ko": "세 번째 타크비르 — 고인을 위한 두아",
    "hi": "तीसरी तकबीर — मय्यित के लिए दुआ"
  },
  "jenazah.step4": {
    "id": "Takbir Keempat — Doa & Salam",
    "en": "Fourth Takbir — Du'a & Salam",
    "ar": "التكبير الرابع — الدعاء والسلام",
    "fr": "Quatrième Takbir — Du'a & Salam",
    "de": "Vierter Takbir — Du'a & Salam",
    "es": "Cuarto Takbir — Du'a y Salam",
    "ru": "Четвёртый Такбир — Ду'а и Салям",
    "zh": "第四声台比尔 — 祈祷与色兰",
    "ja": "第四タクビール — ドゥアーとサラーム",
    "ko": "네 번째 타크비르 — 두아 & 살람",
    "hi": "चौथी तकबीर — दुआ और सलाम"
  },
  "jenazah.fatihah": {
    "id": "Membaca Surah Al-Fatihah (setelah takbir pertama, dibaca lirih).",
    "en": "Recite Surah Al-Fatihah (after the first Takbir, recited silently).",
    "ar": "تُقرأ سورة الفاتحة (بعد التكبير الأول، وتُقرأ سرًّا).",
    "fr": "Réciter la sourate Al-Fatiha (après le premier Takbir, récitée à voix basse).",
    "de": "Surah Al-Fatihah rezitieren (nach dem ersten Takbir, leise gelesen).",
    "es": "Recitar la sura Al-Fatiha (tras el primer Takbir, recitada en voz baja).",
    "ru": "Читать суру Аль-Фатиха (после первого Такбира, читается тихо).",
    "zh": "诵读法蒂哈章（在第一声台比尔之后，默诵）。",
    "ja": "第一タクビールの後に、スーラ・アル＝ファーティハを静かに朗誦する。",
    "ko": "수라 알파티하를 낭송한다 (첫 번째 타크비르 이후, 조용히 낭송).",
    "hi": "सूरह अल-फातिहा पढ़ें (पहली तकबीर के बाद, धीरे से पढ़ें)।"
  },
  "jenazah.salamNote": {
    "id": "Kemudian mengucapkan salam ke kanan dan ke kiri:",
    "en": "Then say the salutation (salam) to the right and to the left:",
    "ar": "ثم يقول السلام عن اليمين وعن الشمال:",
    "fr": "Puis prononcer le salut (salam) à droite et à gauche :",
    "de": "Dann den Salam nach rechts und nach links sprechen:",
    "es": "Luego pronunciar el saludo (salam) hacia la derecha y hacia la izquierda:",
    "ru": "Затем произносится салам направо и налево:",
    "zh": "然后向右和向左道色兰（salam）：",
    "ja": "次に右と左にサラームを唱える：",
    "ko": "그런 다음 오른쪽과 왼쪽으로 살람을 한다:",
    "hi": "फिर दाईं और बाईं ओर सलाम कहें:"
  },
  "jenazah.niat.pria": {
    "id": "Aku niat salat atas jenazah (laki-laki) ini empat takbir fardhu kifayah sebagai makmum karena Allah Ta'ala.",
    "en": "I intend to pray over this (male) deceased with four takbirs as fardhu kifayah, as a follower (makmum), for the sake of Allah Ta'ala.",
    "ar": "أنوي الصلاة على هذا الميت (الذكر) أربع تكبيرات فرض كفاية مأموماً لله تعالى.",
    "fr": "J'ai l'intention de prier sur ce défunt (homme) avec quatre takbirs, fardhu kifayah, en tant que makmum, pour l'amour d'Allah Ta'ala.",
    "de": "Ich beabsichtige, das Gebet über diesen (männlichen) Verstorbenen mit vier Takbir als Fardhu Kifayah, als Makmum, um Allahs willen zu verrichten.",
    "es": "Tengo la intención de rezar sobre este difunto (hombre) con cuatro takbirs como fardhu kifayah, como makmum, por la gracia de Allah Ta'ala.",
    "ru": "Я намереваюсь совершить молитву над этим (мужчиной) усопшим с четырьмя такбирами как фардху кифайя, в качестве мамума, ради Аллаха Та'аля.",
    "zh": "我意图为这位（男性）亡者以四个台比尔礼拜，作为法尔杜·基法亚（fardhu kifayah），以马蒙（makmum）身份，为了真主至高。",
    "ja": "私はこの（男性の）故人のために、アッラー・タアーラのためにマクムーム（makmum）としてファルドゥ・キファーヤ（fardhu kifayah）として四回のタクビール（takbir）で礼拝を行う意図をする。",
    "ko": "나는 알라 타알라를 위해 마크뭄(makmum)으로서 파르두 키파야(fardhu kifayah)로 이 (남성) 고인을 위해 네 번의 타크비르(takbir)로 예배드릴 것을 의도한다.",
    "hi": "मैं इस (पुरुष) मृतक पर चार तकबीर के साथ फ़र्ज़ू किफ़ाया के रूप में, मक्मूम के रूप में, अल्लाह ता'आला के लिए नमाज़ की नियत करता हूँ।"
  },
  "jenazah.niat.wanita": {
    "id": "Aku niat salat atas jenazah (perempuan) ini empat takbir fardhu kifayah sebagai makmum karena Allah Ta'ala.",
    "en": "I intend to pray over this (female) deceased with four takbirs as fardhu kifayah, as a follower (makmum), for the sake of Allah Ta'ala.",
    "ar": "أنوي الصلاة على هذه الميتة (الأنثى) أربع تكبيرات فرض كفاية مأموماً لله تعالى.",
    "fr": "J'ai l'intention de prier sur cette défunte (femme) avec quatre takbirs, fardhu kifayah, en tant que makmum, pour l'amour d'Allah Ta'ala.",
    "de": "Ich beabsichtige, das Gebet über diese (weibliche) Verstorbene mit vier Takbir als Fardhu Kifayah, als Makmum, um Allahs willen zu verrichten.",
    "es": "Tengo la intención de rezar sobre esta difunta (mujer) con cuatro takbirs como fardhu kifayah, como makmum, por la gracia de Allah Ta'ala.",
    "ru": "Я намереваюсь совершить молитву над этой (женщиной) усопшей с четырьмя такбирами как фардху кифайя, в качестве мамума, ради Аллаха Та'аля.",
    "zh": "我意图为这位（女性）亡者以四个台比尔礼拜，作为法尔杜·基法亚（fardhu kifayah），以马蒙（makmum）身份，为了真主至高。",
    "ja": "私はこの（女性の）故人のために、アッラー・タアーラのためにマクムーム（makmum）としてファルドゥ・キファーヤ（fardhu kifayah）として四回のタクビール（takbir）で礼拝を行う意図をする。",
    "ko": "나는 알라 타알라를 위해 마크뭄(makmum)으로서 파르두 키파야(fardhu kifayah)로 이 (여성) 고인을 위해 네 번의 타크비르(takbir)로 예배드릴 것을 의도한다.",
    "hi": "मैं इस (महिला) मृतक पर चार तकबीर के साथ फ़र्ज़ू किफ़ाया के रूप में, मक्मूम के रूप में, अल्लाह ता'आला के लिए नमाज़ की नियत करती हूँ।"
  },
  "jenazah.niat.anak-l": {
    "id": "Aku niat salat atas jenazah anak (laki-laki) ini empat takbir fardhu kifayah sebagai makmum karena Allah Ta'ala.",
    "en": "I intend to pray over this (male) child deceased with four takbirs as fardhu kifayah, as a follower (makmum), for the sake of Allah Ta'ala.",
    "ar": "أنوي الصلاة على جنازة هذا الطفل (الذكر) أربع تكبيرات فرض كفاية مأموماً لله تعالى.",
    "fr": "J'ai l'intention de prier sur la dépouille de cet enfant (garçon) avec quatre takbirs, fardhu kifayah, en tant que makmum, pour l'amour d'Allah Ta'ala.",
    "de": "Ich beabsichtige, das Gebet über dieses (männliche) verstorbene Kind mit vier Takbir als Fardhu Kifayah, als Makmum, um Allahs willen zu verrichten.",
    "es": "Tengo la intención de rezar sobre el difunto de este niño (varón) con cuatro takbirs como fardhu kifayah, como makmum, por la gracia de Allah Ta'ala.",
    "ru": "Я намереваюсь совершить молитву над этим (мальчиком) усопшим ребёнком с четырьмя такбирами как фардху кифайя, в качестве мамума, ради Аллаха Та'аля.",
    "zh": "我意图为这位（男）孩亡者以四个台比尔礼拜，作为法尔杜·基法亚（fardhu kifayah），以马蒙（makmum）身份，为了真主至高。",
    "ja": "私はこの（男の子の）故人のために、アッラー・タアーラのためにマクムーム（makmum）としてファルドゥ・キファーヤ（fardhu kifayah）として四回のタクビール（takbir）で礼拝を行う意図をする。",
    "ko": "나는 알라 타알라를 위해 마크뭄(makmum)으로서 파르두 키파야(fardhu kifayah)로 이 (남자) 아이 고인을 위해 네 번의 타크비르(takbir)로 예배드릴 것을 의도한다.",
    "hi": "मैं इस (लड़के) बच्चे के मृतक पर चार तकबीर के साथ फ़र्ज़ू किफ़ाया के रूप में, मक्मूम के रूप में, अल्लाह ता'आला के लिए नमाज़ की नियत करता हूँ।"
  },
  "jenazah.niat.anak-p": {
    "id": "Aku niat salat atas jenazah anak (perempuan) ini empat takbir fardhu kifayah sebagai makmum karena Allah Ta'ala.",
    "en": "I intend to pray over this (female) child deceased with four takbirs as fardhu kifayah, as a follower (makmum), for the sake of Allah Ta'ala.",
    "ar": "أنوي الصلاة على جنازة هذه الطفلة (الأنثى) أربع تكبيرات فرض كفاية مأموماً لله تعالى.",
    "fr": "J'ai l'intention de prier sur la dépouille de cette enfant (fille) avec quatre takbirs, fardhu kifayah, en tant que makmum, pour l'amour d'Allah Ta'ala.",
    "de": "Ich beabsichtige, das Gebet über dieses (weibliche) verstorbene Kind mit vier Takbir als Fardhu Kifayah, als Makmum, um Allahs willen zu verrichten.",
    "es": "Tengo la intención de rezar sobre la difunta de esta niña (mujer) con cuatro takbirs como fardhu kifayah, como makmum, por la gracia de Allah Ta'ala.",
    "ru": "Я намереваюсь совершить молитву над этим (девочкой) усопшим ребёнком с четырьмя такбирами как фардху кифайя, в качестве мамума, ради Аллаха Та'аля.",
    "zh": "我意图为这位（女）孩亡者以四个台比尔礼拜，作为法尔杜·基法亚（fardhu kifayah），以马蒙（makmum）身份，为了真主至高。",
    "ja": "私はこの（女の子の）故人のために、アッラー・タアーラのためにマクムーム（makmum）としてファルドゥ・キファーヤ（fardhu kifayah）として四回のタクビール（takbir）で礼拝を行う意図をする。",
    "ko": "나는 알라 타알라를 위해 마크뭄(makmum)으로서 파르두 키파야(fardhu kifayah)로 이 (여자) 아이 고인을 위해 네 번의 타크비르(takbir)로 예배드릴 것을 의도한다.",
    "hi": "मैं इस (लड़की) बच्ची के मृतक पर चार तकबीर के साथ फ़र्ज़ू किफ़ाया के रूप में, मक्मूम के रूप में, अल्लाह ता'आला के लिए नमाज़ की नियत करता हूँ।"
  },
  "jenazah.doa3.pria": {
    "id": "Ya Allah, ampunilah ia, rahmatilah ia, selamatkanlah dan maafkanlah ia, muliakanlah tempat tinggalnya, luaskanlah kuburnya, dan cucilah ia dengan air, salju, dan embun.",
    "en": "O Allah, forgive him, have mercy on him, grant him safety and pardon him, honor his dwelling place, expand his grave, and cleanse him with water, snow, and dew.",
    "ar": "اللهم اغفر له وارحمه وعافِهِ واعفُ عنه وأكرم نُزُلَه ووسِّع مدخله واغسله بالماء والثلج والبَرَد.",
    "fr": "Ô Allah, pardonne-lui, aie pitié de lui, accorde-lui le salut et pardonne-lui, honore sa demeure, élargis sa tombe et lave-le avec de l'eau, de la neige et de la rosée.",
    "de": "O Allah, vergib ihm, erbarme dich seiner, schütze und vergib ihm, ehre seine Wohnstätte, weite sein Grab und reinige ihn mit Wasser, Schnee und Tau.",
    "es": "Oh Allah, perdónale, ten misericordia de él, concédele bienestar y perdónale, honra su morada, amplía su tumba y purifícale con agua, nieve y rocío.",
    "ru": "О Аллах, прости его, помилуй его, убереги его и прости его, возвысь его обитель, расширь его могилу и очисти его водой, снегом и росой.",
    "zh": "哦，真主啊，饶恕他，怜悯他，赐他平安并宽恕他，尊荣他的居所，拓宽他的墓穴，用水、雪和露水洗涤他。",
    "ja": "ああアッラーよ、彼を赦し、彼を慈しみ、彼を守り許し、彼の住まいを高め、彼の墓を広げ、水と雪と露で彼を清めてください。",
    "ko": "오 알라여, 그를 용서하시고, 그를 자비로이 여기시고, 그를 보호하시고 용서하시며, 그의 거처를 영예롭게 하시고, 그의 무덤을 넓혀 주시고, 물과 눈과 이슬로 그를 정결하게 하소서.",
    "hi": "ऐ अल्लाह, उसे माफ़ कर, उस पर रहम कर, उसे सलामत रख और उसे माफ़ कर दे, उसके ठिकाने को शरफ़ अता कर, उसकी क़ब्र को फ़राख़ कर, और उसे पानी, बर्फ़ और ओस से धो दे।"
  },
  "jenazah.doa3.wanita": {
    "id": "Ya Allah, ampunilah ia (perempuan), rahmatilah, selamatkan dan maafkanlah ia, muliakanlah tempat tinggalnya, luaskanlah kuburnya, dan cucilah ia dengan air, salju, dan embun.",
    "en": "O Allah, forgive her, have mercy on her, keep her safe and pardon her, honour her resting place, expand her grave, and wash her with water, snow, and dew.",
    "ar": "اللهم اغفر لها وارحمها وعافها واعفُ عنها وأكرم نزلها ووسِّع مدخلها واغسلها بالماء والثلج والبَرَد.",
    "fr": "Ô Allah, pardonne-lui (à elle), fais-lui miséricorde, préserve-la et pardonne-lui, honore sa demeure, élargis sa tombe, et lave-la avec de l'eau, de la neige et de la rosée.",
    "de": "O Allah, vergib ihr, erbarme Dich über sie, bewahre sie und vergib ihr, ehre ihre Ruhestätte, weite ihr Grab und wasche sie mit Wasser, Schnee und Tau.",
    "es": "Oh Allah, perdónala, ten misericordia de ella, protégela y discúlpala, honra su morada, amplía su tumba y lávala con agua, nieve y rocío.",
    "ru": "О Аллах, прости её, помилуй её, убереги её и извини её, почти её место пребывания, расширь её могилу и омой её водой, снегом и росой.",
    "zh": "哦，安拉，请饶恕她，怜悯她，保全她并宽恕她，尊荣她的居所，扩展她的坟墓，并以水、雪和露水洗涤她。",
    "ja": "ああアッラーよ、彼女をお赦しください、憐れんでください、守り保ち許してください、彼女の宿りを称え、墓を広げ、水と雪と露で彼女をお洗いください。",
    "ko": "오 알라시여, 그녀를 용서하시고, 자비를 베푸시며, 보호하시고 사면하시며, 그녀의 거처를 존귀하게 하시고, 묘를 넓히시며, 물과 눈과 이슬로 그녀를 씻어 주소서.",
    "hi": "ऐ अल्लाह, उसे (स्त्री को) माफ़ कर, उस पर रहम कर, उसे सलामत रख और उसे क्षमा कर, उसके निवास को सम्मानित कर, उसकी कब्र को फैला दे, और उसे पानी, बर्फ और ओस से धो दे।"
  },
  "jenazah.doa3.anak-l": {
    "id": "Ya Allah, jadikanlah ia (anak ini) sebagai simpanan pahala, pendahulu, dan tabungan bagi kedua orang tuanya, pelajaran, dan pemberi syafaat. Beratkanlah timbangan (kebaikan) keduanya dan curahkanlah kesabaran ke dalam hati keduanya.",
    "en": "O Allah, make him (this child) a stored reward, a forerunner, and a treasure for his parents, a lesson, and an intercessor. Make heavy the scales of their good deeds and pour patience into their hearts.",
    "ar": "اللهم اجعله لهما فَرَطاً وسَلَفاً وذُخراً وعِظةً واعتباراً وشفيعاً، وثقِّل به موازينهما وأَفرغ الصبرَ على قلبيهما.",
    "fr": "Ô Allah, fais de lui (cet enfant) une récompense mise en réserve, un précurseur et un trésor pour ses parents, un enseignement et un intercesseur. Alourdit la balance de leurs bonnes œuvres et répands la patience dans leurs cœurs.",
    "de": "O Allah, mache ihn (dieses Kind) zu einem gespeicherten Lohn, einem Vorläufer und einem Schatz für seine Eltern, einer Lektion und einem Fürsprecher. Schwere die Waage ihrer guten Taten auf und gieße Geduld in ihre Herzen.",
    "es": "Oh Allah, haz de él (este niño) una recompensa almacenada, un precursor y un tesoro para sus padres, una lección y un intercesor. Haz pesar la balanza de sus buenas obras y derrama paciencia en sus corazones.",
    "ru": "О Аллах, сделай его (этого ребёнка) накопленной наградой, предшественником и сокровищем для его родителей, назиданием и заступником. Утяжели весы их благих дел и излей терпение в их сердца.",
    "zh": "哦，安拉，使他（这个孩子）成为父母的储备报酬、先驱和积蓄，成为教训和代祷者。加重他们善行的砝码，并将耐心倾注于他们的心中。",
    "ja": "ああアッラーよ、彼（この子）を両親のための蓄えられた報酬、先駆者、そして宝とし、教訓と執り成し手としてください。両親の善行の秤を重くし、彼らの心に忍耐を注いでください。",
    "ko": "오 알라시여, 그(이 아이)를 부모를 위한 저장된 보상, 선구자, 그리고 보물로 삼으시고, 교훈과 중재자로 삼아 주소서. 그들의 선행의 저울을 무겁게 하시고 그들의 마음에 인내를 부어 주소서.",
    "hi": "ऐ अल्लाह, उसे (इस बच्चे को) उसके माता-पिता के लिए संचित पुण्य, अग्रदूत और खज़ाना बना, सीख और सिफारिशी बना। उन दोनों के (नेकी के) तराज़ू को भारी कर और उन दोनों के दिलों में सब्र उंडेल दे।"
  },
  "jenazah.doa3.anak-p": {
    "id": "Ya Allah, jadikanlah ia (anak perempuan ini) sebagai simpanan pahala, pendahulu, dan tabungan bagi kedua orang tuanya, pelajaran, dan pemberi syafaat. Beratkanlah timbangan (kebaikan) keduanya dan curahkanlah kesabaran ke dalam hati keduanya.",
    "en": "O Allah, make her (this girl) a stored reward, a forerunner, and a treasure for her parents, a lesson, and an intercessor. Make heavy the scales of their good deeds and pour patience into their hearts.",
    "ar": "اللهم اجعلها لهما فَرَطاً وسَلَفاً وذُخراً وعِظةً واعتباراً وشفيعةً، وثقِّل به موازينهما وأَفرغ الصبرَ على قلبيهما.",
    "fr": "Ô Allah, fais d'elle (cette fillette) une récompense mise en réserve, une précurseure et un trésor pour ses parents, un enseignement et une intercesseure. Alourdit la balance de leurs bonnes œuvres et répands la patience dans leurs cœurs.",
    "de": "O Allah, mache sie (dieses Mädchen) zu einem gespeicherten Lohn, einer Vorläuferin und einem Schatz für ihre Eltern, einer Lektion und einer Fürsprecherin. Schwere die Waage ihrer guten Taten auf und gieße Geduld in ihre Herzen.",
    "es": "Oh Allah, haz de ella (esta niña) una recompensa almacenada, una precursora y un tesoro para sus padres, una lección y una intercesora. Haz pesar la balanza de sus buenas obras y derrama paciencia en sus corazones.",
    "ru": "О Аллах, сделай её (эту девочку) накопленной наградой, предшественницей и сокровищем для её родителей, назиданием и заступницей. Утяжели весы их благих дел и излей терпение в их сердца.",
    "zh": "哦，安拉，使她（这个女孩）成为父母的储备报酬、先驱和积蓄，成为教训和代祷者。加重他们善行的砝码，并将耐心倾注于他们的心中。",
    "ja": "ああアッラーよ、彼女（この女の子）を両親のための蓄えられた報酬、先駆者、そして宝とし、教訓と執り成し手としてください。両親の善行の秤を重くし、彼らの心に忍耐を注いでください。",
    "ko": "오 알라시여, 그녀(이 여자아이)를 부모를 위한 저장된 보상, 선구자, 그리고 보물로 삼으시고, 교훈과 중재자로 삼아 주소서. 그들의 선행의 저울을 무겁게 하시고 그들의 마음에 인내를 부어 주소서.",
    "hi": "ऐ अल्लाह, उसे (इस बच्ची को) उसके माता-पिता के लिए संचित पुण्य, अग्रदूत और खज़ाना बना, सीख और सिफारिशी बना। उन दोनों के (नेकी के) तराज़ू को भारी कर और उन दोनों के दिलों में सब्र उंडेल दे।"
  },
  "jenazah.doa4.pria": {
    "id": "Ya Allah, janganlah Engkau haramkan kami dari pahalanya, jangan Engkau beri kami fitnah sepeninggalnya, dan ampunilah kami serta ia.",
    "en": "O Allah, do not deprive us of his reward, do not afflict us with trial after him, and forgive us as well as him.",
    "ar": "اللهم لا تحرمنا أجره ولا تفتنا بعده واغفر لنا وله.",
    "fr": "Ô Allah, ne nous prive pas de sa récompense, ne nous éprouve pas après lui et pardonne-nous ainsi qu'à lui.",
    "de": "O Allah, beraubt uns nicht seines Lohnes, prüfe uns nicht nach ihm und vergib uns sowie ihm.",
    "es": "Oh Allah, no nos prives de su recompensa, no nos pongas a prueba tras él y perdónanos a nosotros y a él.",
    "ru": "О Аллах, не лишай нас его награды, не подвергай нас испытанию после него и прости нас, а также его.",
    "zh": "哦，安拉，不要使我们错失他的报酬，不要在他离去后以试炼降临我们，并饶恕我们和他。",
    "ja": "ああアッラーよ、彼の報酬から私たちを遠ざけないでください、彼の後に私たちを試練にあわせないでください、そして私たちと彼をお赦しください。",
    "ko": "오 알라시여, 그의 보상에서 우리를 박탈하지 마시고, 그가 떠난 후 우리를 시험에 들게 하지 마시며, 우리와 그를 용서하여 주소서.",
    "hi": "ऐ अल्लाह, हमें उसके (पुण्य के) बदले से महरूम न कर, उसके बाद हमें फ़ितने में न डाल, और हमें तथा उसे माफ़ कर दे।"
  },
  "jenazah.doa4.wanita": {
    "id": "Ya Allah, janganlah Engkau haramkan kami dari pahalanya, jangan Engkau beri kami fitnah sepeninggalnya, dan ampunilah kami serta ia (perempuan).",
    "en": "O Allah, do not deprive us of her reward, do not afflict us with trial after her, and forgive us as well as her.",
    "ar": "اللهم لا تحرمنا أجرها ولا تفتنا بعدها واغفر لنا ولها.",
    "fr": "Ô Allah, ne nous prive pas de sa récompense (à elle), ne nous éprouve pas après elle et pardonne-nous ainsi qu'à elle.",
    "de": "O Allah, beraubt uns nicht ihres Lohnes, prüfe uns nicht nach ihr und vergib uns sowie ihr.",
    "es": "Oh Allah, no nos prives de su recompensa (de ella), no nos pongas a prueba tras ella y perdónanos a nosotros y a ella.",
    "ru": "О Аллах, не лишай нас её награды, не подвергай нас испытанию после неё и прости нас, а также её.",
    "zh": "哦，安拉，不要使我们错失她的报酬，不要在她离去后以试炼降临我们，并饶恕我们和她。",
    "ja": "ああアッラーよ、彼女の報酬から私たちを遠ざけないでください、彼女の後に私たちを試練にあわせないでください、そして私たちと彼女をお赦しください。",
    "ko": "오 알라시여, 그녀의 보상에서 우리를 박탈하지 마시고, 그녀가 떠난 후 우리를 시험에 들게 하지 마시며, 우리와 그녀를 용서하여 주소서.",
    "hi": "ऐ अल्लाह, हमें उसके (स्त्री के पुण्य के) बदले से महरूम न कर, उसके बाद हमें फ़ितने में न डाल, और हमें तथा उसे माफ़ कर दे।"
  },
  "jenazah.doa4.anak-l": {
    "id": "Ya Allah, janganlah Engkau haramkan kami dari pahalanya, jangan Engkau beri kami fitnah sepeninggalnya, dan ampunilah kami serta ia.",
    "en": "O Allah, do not deprive us of his reward, do not afflict us with trial after him, and forgive us as well as him.",
    "ar": "اللهم لا تحرمنا أجره ولا تفتنا بعده واغفر لنا وله.",
    "fr": "Ô Allah, ne nous prive pas de sa récompense, ne nous éprouve pas après lui et pardonne-nous ainsi qu'à lui.",
    "de": "O Allah, beraubt uns nicht seines Lohnes, prüfe uns nicht nach ihm und vergib uns sowie ihm.",
    "es": "Oh Allah, no nos prives de su recompensa, no nos pongas a prueba tras él y perdónanos a nosotros y a él.",
    "ru": "О Аллах, не лишай нас его награды, не подвергай нас испытанию после него и прости нас, а также его.",
    "zh": "哦，安拉，不要使我们错失他的报酬，不要在他离去后以试炼降临我们，并饶恕我们和他。",
    "ja": "ああアッラーよ、彼の報酬から私たちを遠ざけないでください、彼の後に私たちを試練にあわせないでください、そして私たちと彼をお赦しください。",
    "ko": "오 알라시여, 그의 보상에서 우리를 박탈하지 마시고, 그가 떠난 후 우리를 시험에 들게 하지 마시며, 우리와 그를 용서하여 주소서.",
    "hi": "ऐ अल्लाह, हमें उसके (पुण्य के) बदले से महरूम न कर, उसके बाद हमें फ़ितने में न डाल, और हमें तथा उसे माफ़ कर दे।"
  },
  "jenazah.doa4.anak-p": {
    "id": "Ya Allah, janganlah Engkau haramkan kami dari pahalanya, jangan Engkau beri kami fitnah sepeninggalnya, dan ampunilah kami serta ia (perempuan).",
    "en": "O Allah, do not deprive us of her reward, do not cause us to be tried after her, and forgive us and her.",
    "ar": "اللَّهُمَّ لَا تَحْرِمْنَا أَجْرَهَا، وَلَا تَفْتِنَّا بَعْدَهَا، وَاغْفِرْ لَنَا وَلَهَا.",
    "fr": "Ô Allah, ne nous prive pas de sa récompense, ne nous éprouve pas après elle, et pardonne-nous ainsi qu'à elle.",
    "de": "O Allah, beraubt uns nicht ihres Lohnes, prüfe uns nicht nach ihr, und vergib uns und ihr.",
    "es": "Oh Allah, no nos prives de su recompensa, no nos pongas a prueba tras ella, y perdónanos a nosotros y a ella.",
    "ru": "О Аллах, не лишай нас её награды, не подвергай нас испытанию после неё, и прости нас и её.",
    "zh": "求主啊，不要剥夺我们她的回报，不要在她离去后考验我们，并宽恕我们和她。",
    "ja": "ああアッラーよ、私たちを彼女の報酬から遠ざけないでください、彼女の後に私たちを試みないでください、そして私たちと彼女をお赦しください。",
    "ko": "오 알라시여, 그녀의 보상을 우리에게서 빼앗지 마시고, 그녀가 떠난 후 우리를 시험하지 마시며, 우리와 그녀를 용서하여 주소서.",
    "hi": "ऐ अल्लाह, हमें उसके सवाब से महरूम न कर, उसके बाद हमें फ़ितने में न डाल, और हमें तथा उसे माफ़ फ़रमा।"
  },
  "jenazah.shalawat": {
    "id": "Ya Allah, limpahkanlah shalawat kepada Nabi Muhammad dan keluarganya sebagaimana Engkau bershalawat kepada Ibrahim dan keluarganya, dan berkahilah Muhammad dan keluarganya.",
    "en": "O Allah, bestow Your blessings upon the Prophet Muhammad ﷺ and his family, just as You bestowed blessings upon Ibrahim and his family, and bless Muhammad and his family.",
    "ar": "اللَّهُمَّ صَلِّ عَلَى النَّبِيِّ مُحَمَّدٍ ﷺ وَعَلَى آلِهِ، كَمَا صَلَّيْتَ عَلَى إِبْرَاهِيمَ وَآلِهِ، وَبَارِكْ عَلَى مُحَمَّدٍ وَآلِهِ.",
    "fr": "Ô Allah, accorde Tes grâces au Prophète Muhammad ﷺ et à sa famille, comme Tu en as accordé à Ibrahim et à sa famille, et bénis Muhammad et sa famille.",
    "de": "O Allah, sende Deinen Segen auf den Propheten Muhammad ﷺ und seine Familie, so wie Du Deinen Segen auf Ibrahim und seine Familie gesandt hast, und segne Muhammad und seine Familie.",
    "es": "Oh Allah, envía Tu bendición sobre el Profeta Muhammad ﷺ y su familia, así como enviaste Tu bendición sobre Ibrahim y su familia, y bendice a Muhammad y a su familia.",
    "ru": "О Аллах, ниспошли Своё благословение на Пророка Мухаммада ﷺ и его семью, так же как Ты ниспослал благословение на Ибрахима и его семью, и благослови Мухаммада и его семью.",
    "zh": "求主啊，请赐福于先知穆罕默德ﷺ及其家人，正如您赐福于易卜拉欣及其家人一样，并赐福于穆罕默德及其家人。",
    "ja": "ああアッラーよ、あなたがイブラーヒームとその家族に祝福を与えられたように、預言者ムハンマドﷺとその家族に祝福をお与えください、そしてムハンマドとその家族を祝福してください。",
    "ko": "오 알라시여, 당신께서 이브라힘과 그의 가족에게 축복을 내리신 것처럼 예언자 무함마드ﷺ와 그의 가족에게 축복을 내려주시고, 무함마드와 그의 가족을 축복하여 주소서.",
    "hi": "ऐ अल्लाह, नबी मुहम्मद ﷺ और उनके परिवार पर दरूद भेज, जैसे तूने इब्राहीम और उनके परिवार पर दरूद भेजा, और मुहम्मद और उनके परिवार पर बरकत नाज़िल फ़रमा।"
  }
};
